export const data = {
  "vocabulary": [
    {
      "id": 1,
      "title": "abaks",
      "level": 3,
      "definition": "Vertikāla balsta vainagojuma (kapiteļa) augšējā daļa, parasti četrstūraina plāksne."
    },
    {
      "id": 2,
      "title": "abate",
      "level": 3,
      "definition": "Katoļu mūķeņu klostera priekšniece."
    },
    {
      "id": 3,
      "title": "abats",
      "level": 2,
      "definition": "Katoļu mūku klostera priekšnieks."
    },
    { "id": 4, "title": "acīte", "level": 2, "definition": "Dem. --> acs." },
    {
      "id": 5,
      "title": "adata",
      "level": 1,
      "definition": "Tievs (metāla) irbulis (šūšanai), kam vienā galā ir asa smaile, bet otrā - spraudziņa pavediena ievēršanai."
    },
    {
      "id": 6,
      "title": "afēra",
      "level": 1,
      "definition": "Negodīgs, arī bīstams pasākums; blēdīgs darījums."
    },
    {
      "id": 7,
      "title": "afiša",
      "level": 1,
      "definition": "Paliela formāta paziņojums (par izrādi, koncertu, lekciju u. tml.)."
    },
    {
      "id": 8,
      "title": "agars",
      "level": 2,
      "definition": "Recekļviela, ko iegūst no dažām jūras aļģēm."
    },
    {
      "id": 9,
      "title": "agave",
      "level": 2,
      "definition": "Liliju rindas dzimta (\"Agavaceae\"), ~20 ģ., >550 s."
    },
    {
      "id": 10,
      "title": "ahāts",
      "level": 3,
      "definition": "Kvarca paveids - kārtains halcedons, pusdārgakmens."
    },
    {
      "id": 11,
      "title": "airis",
      "level": 1,
      "definition": "Īpaši veidots rīks airēšanai - šaurs lāpstveida priekšmets ar kātu."
    },
    {
      "id": 12,
      "title": "aknas",
      "level": 1,
      "definition": "Iekšējais orgāns (cilvēkam un dzīvniekiem), kas izdala žulti un veic daudzas citas ar vielmaiņu saistītas funkcijas."
    },
    {
      "id": 13,
      "title": "akots",
      "level": 2,
      "definition": "Smalks, adatveidīgs graudzāļu zieda plēksnes veidojums."
    },
    {
      "id": 14,
      "title": "aleja",
      "level": 1,
      "definition": "Ceļš vai iela, kam abas puses apstādītas ar kokiem, krūmiem; gatve."
    },
    {
      "id": 15,
      "title": "alibi",
      "level": 2,
      "definition": "Apstāklis, kas pierāda apsūdzētā, aizdomās turētā nevainību: viņa atrašanos citā vietā tai laikā, kad izdarīts noziegums."
    },
    { "id": 16, "title": "aliņš", "level": 1, "definition": "Dem. --> alus." },
    {
      "id": 17,
      "title": "alkas",
      "level": 2,
      "definition": "Spēcīga, kaislīga vēlēšanās, lielas ilgas."
    },
    {
      "id": 18,
      "title": "alnis",
      "level": 1,
      "definition": "Briežu dzimtas suga (\"Alces alces\", vienīgā aļņu ģintī), lielākais šīs dzimtas dzīvnieks ar garām kājām un platiem, zarotiem ragiem."
    },
    {
      "id": 19,
      "title": "alods",
      "level": 3,
      "definition": "Zemes pilnas īpašumtiesības atšķirībā no zemes nosacītas turēšanas."
    },
    { "id": 20, "title": "aloje", "level": 3, "definition": "Alveja." },
    {
      "id": 21,
      "title": "amats",
      "level": 1,
      "definition": "Kvalificēts darbs, arī nodarbošanās - dažādu izstrādājumu ražošana ar rokām, izmantojot vienkāršus darba rīkus."
    },
    {
      "id": 22,
      "title": "ambra",
      "level": 3,
      "definition": "Smaržīga vaskveida viela, kas veidojas kašalotu gremošanas orgānos un kuru izmanto parfimērijā, arī kā kvēpināšanas līdzekli."
    },
    {
      "id": 23,
      "title": "amēba",
      "level": 2,
      "definition": "Sarkodīnu klases kailamēbu kārtas ģinšu grupa (\"Amoeba\", \"Entamoeba\" un \"Jodamoeba\"), brīvi dzīvojoši vienšūņi ar mainīgu ķermeņa formu."
    },
    {
      "id": 24,
      "title": "amīns",
      "level": 3,
      "definition": "Viens no amonija atvasinājumiem, kuros ūdeņraža atoma vietā ir alkila vai arila grupa; pēc aizvietoto ūdeņraža atomu skaita atšķir pirmējos, otrējos, trešējos amīnus."
    },
    {
      "id": 25,
      "title": "amoks",
      "level": 3,
      "definition": "Psihiska traucējuma veids, kas sastopams Malajas arhipelāga iedzīvotājiem; slimnieks pēc īslaicīgas lēkmes metas skriet, iznīcinot visu, kas gadās ceļā."
    },
    {
      "id": 26,
      "title": "anīss",
      "level": 2,
      "definition": "Čemurziežu dzimtas ģints (\"Anisum\"), viengadīgi lakstaugi ar plūksnainām lapām, Vidusjūras apkārtnē, 2 s."
    },
    {
      "id": 27,
      "title": "anods",
      "level": 3,
      "definition": "Elektriskās strāvas avota pozitīvais pols; elektrods, kas savienots ar elektriskās strāvas avota pozitīvo polu."
    },
    {
      "id": 28,
      "title": "aorta",
      "level": 2,
      "definition": "Lielā asinsrites loka galvenā artērija; sākas no kreisā sirds kambara."
    },
    { "id": 29, "title": "apačs", "level": 3, "definition": "Lielpilsētas huligāns." },
    {
      "id": 30,
      "title": "aplis",
      "level": 1,
      "definition": "Plaknes daļa, ko ierobežo aploce; riņķis."
    },
    {
      "id": 31,
      "title": "apogs",
      "level": 2,
      "definition": "Pūčveidīgo kārtas pūču dzimtas putns."
    },
    { "id": 32, "title": "arābs", "level": 1, "definition": "Arābi." },
    {
      "id": 33,
      "title": "arājs",
      "level": 2,
      "definition": "Cilvēks, kas ar zemi (ar zirgu)."
    },
    {
      "id": 34,
      "title": "arēna",
      "level": 1,
      "definition": "Senās Romas amfiteātra vidus daļa, sacensību laukums."
    },
    {
      "id": 35,
      "title": "arkls",
      "level": 1,
      "definition": "Augsnes pamatapstrādes rīks (ar kuru apvērš un drupina arumsloksni, iestrādājot augsnē augu atliekas, mēslojumu)."
    },
    {
      "id": 36,
      "title": "arods",
      "level": 1,
      "definition": "Amats; speciāla praktiskā, parasti tehniskā profesija, specialitāte."
    },
    {
      "id": 37,
      "title": "arums",
      "level": 1,
      "definition": "Paveikta darbība, rezultāts --> art; uzarta vieta."
    },
    {
      "id": 38,
      "title": "asaka",
      "level": 1,
      "definition": "Skelets (zivij), tā atsevišķs kauls."
    },
    {
      "id": 39,
      "title": "asara",
      "level": 1,
      "definition": "Asaris (\"Perca fluviatilis\")."
    },
    { "id": 40, "title": "asins", "level": 1, "definition": "Asinis." },
    {
      "id": 41,
      "title": "astma",
      "level": 1,
      "definition": "Elpas trūkuma lēkme, aizdusa."
    },
    { "id": 42, "title": "astra", "level": 2, "definition": "Astere." },
    { "id": 43, "title": "astrs", "level": 2, "definition": "Ass." },
    {
      "id": 44,
      "title": "asums",
      "level": 1,
      "definition": "Vispārināta īpašība --> ass 1, šīs īpašības konkrēta izpausme."
    },
    {
      "id": 45,
      "title": "ašums",
      "level": 1,
      "definition": "Vispārināta īpašība --> ašs, šīs īpašības konkrēta izpausme."
    },
    {
      "id": 46,
      "title": "atāls",
      "level": 1,
      "definition": "Jauna zāle, kas izaugusi nopļautās vai noganītās vietā (tajā pašā gadā)."
    },
    {
      "id": 47,
      "title": "ateja",
      "level": 1,
      "definition": "Telpa, arī īpaša neliela ēka dabisko vajadzību nokārtošanai; tualete."
    },
    {
      "id": 48,
      "title": "atols",
      "level": 3,
      "definition": "Plakana, zema, gredzenveida (koraļļu) sala, kuras vidū var būt sekla lagūna."
    },
    {
      "id": 49,
      "title": "atoms",
      "level": 1,
      "definition": "Ķīmiskā elementa vismazākā daļiņa, kurai ir visas šī elementa ķīmiskās īpašības."
    },
    {
      "id": 50,
      "title": "audze",
      "level": 2,
      "definition": "Vienas vai vairāku sugu augu kopums."
    },
    {
      "id": 51,
      "title": "augša",
      "level": 1,
      "definition": "Augšējā daļa (tā daļa, kas atrodas virs kā, kam pāri); pretstats apakša."
    },
    {
      "id": 52,
      "title": "aukla",
      "level": 1,
      "definition": "Samērā tievs šķiedru savijums; arī resns pavediens."
    },
    {
      "id": 53,
      "title": "ausma",
      "level": 1,
      "definition": "Pakāpeniska (rīta) gaismas parādīšanās austrumu pusē; rīta blāzma; spožums, blāzmojums (saulei lecot)."
    },
    {
      "id": 54,
      "title": "auzas",
      "level": 1,
      "definition": "Graudzāļu dzimtas labības augu ģints (\"Avena\"), viengadīgs lakstaugs, 25 sugas, Latvijā konstatētas 2 sugas."
    },
    {
      "id": 55,
      "title": "avene",
      "level": 1,
      "definition": "Rožu dzimtas ģints (\"Rubus\"), augs ar saldām, aromātiskām, parasti sarkanām ogām."
    },
    {
      "id": 56,
      "title": "avizo",
      "level": 3,
      "definition": "Raksts, ar ko adresātam paziņo par vekseļa, preču izsūtīšanu vai naudas pārskaitīšanu."
    },
    {
      "id": 57,
      "title": "avīze",
      "level": 1,
      "definition": "Periodisks izdevums (vairāku lielu lapu veidā) ar aktuālu saturu; laikraksts."
    },
    {
      "id": 58,
      "title": "avots",
      "level": 1,
      "definition": "Pazemes ūdeņu izplūdes vieta."
    },
    { "id": 59, "title": "azote","level": 2, "definition": "Vieta uz krūtīm zem drēbēm." },
    {
      "id": 60,
      "title": "ābece",
      "level": 1,
      "definition": "Mācību grāmata burtu un lasītprasmes apgūšanai; pirmmācības grāmata."
    },
    {
      "id": 61,
      "title": "ābele",
      "level": 1,
      "definition": "Rožu dzimtas augļu koks (ģints \"Malus\") ar kuplu, plašu lapotni, baltsārtiem ziediem, apaļiem vai ieapaļiem, parasti sulīgiem augļiem, 54 sugas, Latvijā savvaļā 1 s. (mežābele), 16 sugas introducētas, no tām 2 pāriet savvaļā, pasaulē kultuvē ~10 tk šķirņu, Latvijā dārzos un kolekcijās ~500 šķirņu."
    },
    {
      "id": 62,
      "title": "ābols",
      "level": 1,
      "definition": "Sulīgs daudzsēklu auglis, raksturīgs ābelēm, bumbierēm, cidonijām, pīlādžiem u. c."
    },
    {
      "id": 63,
      "title": "ādere",
      "level": 1,
      "definition": "Pazemes ūdeņus saturoša dzīsla vai slānis."
    },
    {
      "id": 64,
      "title": "āksts",
      "level": 1,
      "definition": "Cilvēks, kura amata pienākums bija uzjautrināt un izklaidēt valdnieku, augstmani un viņa viesus; nerrs."
    },
    {
      "id": 65,
      "title": "ālava",
      "level": 3,
      "definition": "Dzīvnieku mātīte, kas noteiktā laikā neapaugļojas."
    },
    {
      "id": 66,
      "title": "āmurs",
      "level": 1,
      "definition": "Roku darba rīks (kātam piestiprināts īpašas formas dzelzs, koka u. tml. materiāla gabals) sišanai."
    },
    {
      "id": 67,
      "title": "āpsis",
      "level": 1,
      "definition": "Sermuļu dzimtas suga (\"Meles meles\", senāk \"Meles vulgaris\"), vidēji liels plēsējs ar garu purnu, pagaru, rupju apmatojumu, visēdājs, Latvijā dzīvo 5-10 tūkstoši indivīdu."
    },
    {
      "id": 68,
      "title": "ārija",
      "level": 2,
      "definition": "Vokāls skaņdarbs (ar lirisku vai dramatisku saturu), kas rakstīts solistam ar orķestra pavadījumu (parasti operas, oratorijas, kantātes sastāvdaļa)."
    },
    {
      "id": 69,
      "title": "ārsts",
      "level": 1,
      "definition": "Speciālists ar augstāko medicīnisko izglītību un tiesībām ārstēt."
    },
    {
      "id": 70,
      "title": "baits",
      "level": 3,
      "definition": "Kā vienots veselums apstrādājama bitu grupa, parasti datora vismazākā adresējamā atmiņas daļa, sastāv no 8 bitiem."
    },
    {
      "id": 71,
      "title": "bakas",
      "level": 2,
      "definition": "Vīrusu izraisīta infekcijas slimība, kura rada rētas ādā (parasti sejas ādā)."
    },
    {
      "id": 72,
      "title": "baķis",
      "level": 2,
      "definition": "Saritināts, satīts liels (parasti auduma) gabals."
    },
    {
      "id": 73,
      "title": "balle",
      "level": 1,
      "definition": "Plašs, grezns sabiedrisks sarīkojums ar dejām."
    },
    {
      "id": 74,
      "title": "balss",
      "level": 1,
      "definition": "Skaņu kopums, ko veido (cilvēka) elpošanas ceļa orgāni (balss aparāts); skaņu kopums, kas raksturīgs runai."
    },
    {
      "id": 75,
      "title": "balva",
      "level": 1,
      "definition": "Priekšmets, naudas summa, ko pasniedz kā atzinības apliecinājumu (piemēram, par uzvaru sporta sacensībās, par labu darbu); godalga."
    },
    {
      "id": 76,
      "title": "baļļa",
      "level": 1,
      "definition": "Plats - apaļš vai iegarens - koka trauks ar paplašinātu augšdaļu."
    },
    {
      "id": 77,
      "title": "banda",
      "level": 1,
      "definition": "Personu grupa, kas apvienojušās noziedzīgai darbībai."
    },
    { "id": 78, "title": "banga", "level": 2, "definition": "Liels, spēcīgs vilnis." },
    {
      "id": 79,
      "title": "banka",
      "level": 1,
      "definition": "Uzņēmums, kas realizē starpniecību starp kreditoriem un aizņēmējiem, kā arī tirgojas ar naudas kapitālu, nodarbojas ar vērtspapīriem un valūtām."
    },
    { "id": 80, "title": "bante", "level": 1, "definition": "Lente, saite." },
    { "id": 81, "title": "bards", "level": 2, "definition": "Seno ķeltu dziesminieks." },
    {
      "id": 82,
      "title": "barka",
      "level": 3,
      "definition": "Liellaiva ar plakanu dibenu un seklu iegrimi."
    },
    {
      "id": 83,
      "title": "barža",
      "level": 3,
      "definition": "Plakandibena kuģis kravas pārvadāšanai pa upēm, kanāliem, ezeriem un jūru slēgtā rajonā (pārvietojams ar velkoni vai pašgājējs)."
    },
    {
      "id": 84,
      "title": "bauda",
      "level": 1,
      "definition": "Liela (galvenokārt jutekliska) patika, tīksme."
    },
    {
      "id": 85,
      "title": "bažas",
      "level": 1,
      "definition": "Nemiers, bailes, ko izraisa iespējama neveiksme, nelaime."
    },
    {
      "id": 86,
      "title": "bārda",
      "level": 1,
      "definition": "Sejas apakšējās daļas apmatojums (vīriešiem)."
    },
    { "id": 87, "title": "bāris", "level": 3, "definition": "Bārenis ." },
    {
      "id": 88,
      "title": "bebrs",
      "level": 1,
      "definition": "Zīdītāju klases grauzēju kārtas dzimta (\"Castoridae\"), lieli drukni grauzēji ar saplacinātu, kailu asti un īsām kājām, dzīvo alās vai virszemes mītnēs, labi peld un nirst, 1 ģ., 2 sugas, Latvijā konstatēta 1 ģ., 1 s."
    },
    {
      "id": 89,
      "title": "bedre",
      "level": 1,
      "definition": "Padziļinājums, iedobums ar vairāk vai mazāk stāvām malām (parasti zemes virsmā - nelielā platībā)."
    },
    {
      "id": 90,
      "title": "bende",
      "level": 2,
      "definition": "Cilvēks, kas izpilda nāves sodu, miesas sodus, spīdzina."
    },
    {
      "id": 91,
      "title": "berze",
      "level": 1,
      "definition": "Mehāniska pretestība, kas rodas starp diviem ķermeņiem, kuri savā starpā saskaras un pārvietojas attiecībā viens pret otru; ārējā berze."
    },
    {
      "id": 92,
      "title": "bēres",
      "level": 1,
      "definition": "Mirušā apbedīšana (parasti pēc noteiktām paražām un ar noteiktām ceremonijām)."
    },
    {
      "id": 93,
      "title": "bēris",
      "level": 3,
      "definition": "Zirgs ar brūnu apmatojumu, melnām krēpēm un asti."
    },
    {
      "id": 94,
      "title": "bērns",
      "level": 1,
      "definition": "Persona, kas nav sasniegusi 18 gadu vecumu, izņemot personas, kurām saskaņā ar likumu pilngadība iestājas agrāk."
    },
    {
      "id": 95,
      "title": "bērzs",
      "level": 1,
      "definition": "Divdīgļlapju klases burvjlazdu apakšklases rinda (\"Betulales\")."
    },
    {
      "id": 96,
      "title": "bieds",
      "level": 1,
      "definition": "Tas, kas biedē; tas, kas iedveš bailes."
    },
    {
      "id": 97,
      "title": "biete",
      "level": 1,
      "definition": "Uzturā lietojams dārzenis ar tumši sarkanu, paresninātu sakni; šī auga sakne."
    },
    {
      "id": 98,
      "title": "bikts",
      "level": 2,
      "definition": "Grēksūdze, kristiešu (piemēram, pareizticīgo un katoļu) sakraments rituālās tīrības atjaunošanai."
    },
    {
      "id": 99,
      "title": "bilde",
      "level": 1,
      "definition": "Ilustratīvs attēls (parasti bērnu grāmatā); ilustrācija."
    },
    {
      "id": 100,
      "title": "bingo",
      "level": 1,
      "definition": "Azartspēle, kurā spēlētājam, uzminot nejaušu skaitļu kombināciju no iepriekš noteiktām skaitļu kombinācijām, ir iespēja iegūt laimestu un kurā laimesta lielums ir atkarīgs no izlozētās vai uzminētās skaitļu kombinācijas un iemaksāto likmju kopsummas (Azartspēļu un izložu likums)."
    },
    {
      "id": 101,
      "title": "birka",
      "level": 2,
      "definition": "Plāksnīte, ko piestiprina pie priekšmeta (piemēram, tā nosaukuma, raksturojuma, īpašnieka atzīmēšanai)."
    },
    { "id": 102, "title": "birze", "level": 2, "definition": "Birzs 1." },
    {
      "id": 103,
      "title": "birzs",
      "level": 2,
      "definition": "Neliels bērzu mežs; bērzu audze."
    },
    {
      "id": 104,
      "title": "birža",
      "level": 2,
      "definition": "Iestāde, kur pērk un pārdod vērtspapīrus, kā arī noslēdz vairumtirdzniecības darījumus; arī ēka, kurā atrodas šī iestāde."
    },
    {
      "id": 105,
      "title": "biste",
      "level": 2,
      "definition": "Cilvēka ķermeņa augšdaļas skulpturāls attēls; krūšutēls."
    },
    {
      "id": 106,
      "title": "bjefs",
      "level": 3,
      "definition": "Ūdensteces posms starp divām hidrotehniskajām būvēm (aizsprostiem, slūžām) vai abās būves pusēs."
    },
    { "id": 107, "title": "blats", "level": 2, "definition": "Izdevīga pazīšanās." },
    {
      "id": 108,
      "title": "blefs",
      "level": 2,
      "definition": "Izdomājums, lai kādu apmulsinātu vai apmānītu."
    },
    {
      "id": 109,
      "title": "blīve",
      "level": 2,
      "definition": "Speciāls ielikums, starplika, kas veido ciešu divu detaļu savienojumu."
    },
    {
      "id": 110,
      "title": "bloks",
      "level": 1,
      "definition": "Apvienība (piemēram, starp valstīm, organizācijām) kopīgai rīcībai."
    },
    {
      "id": 111,
      "title": "blusa",
      "level": 1,
      "definition": "Mazs, bezspārnains asinssūcējs kukainis, kas pārvietojas lecot."
    },
    {
      "id": 112,
      "title": "blūze",
      "level": 1,
      "definition": "No auduma vai trikotāžas šūts sieviešu apģērba gabals, kas sniedzas līdz vai pāri jostas vietai."
    },
    {
      "id": 113,
      "title": "blūzs",
      "level": 2,
      "definition": "Lirisks, melanholisks Amerikas nēģeru vokālās mūzikas žanrs."
    },
    {
      "id": 114,
      "title": "bļoda",
      "level": 1,
      "definition": "Padziļš (parasti apaļš) trauks."
    },
    {
      "id": 115,
      "title": "bokss",
      "level": 2,
      "definition": "Sporta veids - divcīņa ringā ar dūrēm speciālos cimdos."
    },
    {
      "id": 116,
      "title": "bomis",
      "level": 1,
      "definition": "Paresns, pagarš, parasti nodarināts, koks; resna koka kārts (piemēram, smaguma celšanai, balstam)."
    },
    {
      "id": 117,
      "title": "bordo",
      "level": 3,
      "definition": "Tumši sarkans, sarkanbrūns."
    },
    {
      "id": 118,
      "title": "borts",
      "level": 2,
      "definition": "Sānu siena, sāni (kuģim, laivai)."
    },
    {
      "id": 119,
      "title": "brase",
      "level": 3,
      "definition": "Virve, ar kuras palīdzību groza burukuģa rājas."
    },
    {
      "id": 120,
      "title": "brass",
      "level": 3,
      "definition": "Peldēšana uz krūtīm, peldētājam vienlaikus darbojoties ar rokām un kājām, neizceļot rokas no ūdens."
    },
    {
      "id": 121,
      "title": "brāga",
      "level": 3,
      "definition": "Pārpalikumi (biezumi), kas rodas spirta vai alus ražošanas procesā; izmanto arī kā lopbarību."
    },
    {
      "id": 122,
      "title": "brēka",
      "level": 2,
      "definition": "Skaļu balsu, kliedzienu troksnis; troksnis, kurā dzirdami kliedzieni."
    },
    {
      "id": 123,
      "title": "briga",
      "level": 3,
      "definition": "Divmastu burinieks ar taisnajām burām abos mastos."
    },
    { "id": 124, "title": "brīve", "level": 3, "definition": "Brīvība ." },
    {
      "id": 125,
      "title": "brīze",
      "level": 2,
      "definition": "Jūru, okeānu, kā arī lielu ezeru piekrastes vējš."
    },
    {
      "id": 126,
      "title": "broms",
      "level": 3,
      "definition": "Ķīmiskais elements - smags, sarkani brūngans šķidrums, simbols Br, atomnumurs 35, atommasa - 79,904, zināmi 18 izotopi, no kuriem 2 ir stabili."
    },
    {
      "id": 127,
      "title": "broša",
      "level": 2,
      "definition": "Rotas lieta (bieži ar dārgakmeni vai tā imitāciju), kas paredzēta piespraušanai pie tērpa."
    },
    {
      "id": 128,
      "title": "bruka",
      "level": 2,
      "definition": "Trūce - iekšējo orgānu vai dziļo audu izspiešanās zem ādas, muskuļaudos vai ķermeņa dobumos."
    },
    {
      "id": 129,
      "title": "brusa",
      "level": 2,
      "definition": "No vairākām pusēm apzāģēts, retāk aptēsts, kokmateriāls, kura biezums un platums ir lielāks par 100 milimetriem."
    },
    {
      "id": 130,
      "title": "bruto",
      "level": 2,
      "definition": "Preces svars kopā ar iesaiņojumu."
    },
    {
      "id": 131,
      "title": "brūce",
      "level": 2,
      "definition": "Ievainota audu vieta (cilvēkam vai dzīvniekiem)."
    },
    { "id": 132, "title": "brūte", "level": 2, "definition": "Līgava." },
    {
      "id": 133,
      "title": "bukse",
      "level": 2,
      "definition": "Mašīnu elements ar cilindrisku vai konisku caurumu cita elementa ievietošanai elementu savienojumos vai slīdgultņos (nedalīts ieliktnis)."
    },
    {
      "id": 134,
      "title": "bukte",
      "level": 2,
      "definition": "Iegludināta ieloce, iegludināta vīle (parasti biksēm)."
    },
    {
      "id": 135,
      "title": "bulla",
      "level": 3,
      "definition": "Ar zīmogu apstiprināts Romas pāvesta (viduslaikos arī imperatora) raksts, lēmums, rīkojums."
    },
    {
      "id": 136,
      "title": "bulta",
      "level": 1,
      "definition": "Tieva (metāla, kaula, koka) stiegra ar atkarpainu galu (šaušanai no loka, stopa)."
    },
    {
      "id": 137,
      "title": "bumba",
      "level": 1,
      "definition": "Lodveida priekšmets (sportam, vingrošanai, rotājām), kas izgatavots no elastīga materiāla un pildīts ar saspiestu gaisu."
    },
    { "id": 138, "title": "bunte", "level": 1, "definition": "Saišķis." },
    {
      "id": 139,
      "title": "burka",
      "level": 1,
      "definition": "Cilindrveida (parasti stikla) trauks."
    },
    {
      "id": 140,
      "title": "burts",
      "level": 1,
      "definition": "Grafiska zīme valodas skaņas vai skaņu grupas apzīmēšanai."
    },
    {
      "id": 141,
      "title": "burve",
      "level": 1,
      "definition": "Zintniece, kam piemīt spēja ar skatienu vai ar vārdiem darīt labu vai ļaunu; pareģe; ragana; spīgana; viegle."
    },
    {
      "id": 142,
      "title": "būris",
      "level": 1,
      "definition": "Miteklis (dzīvniekiem), kas veidots no metāla vai koka režģiem; sprosts; krātiņš."
    },
    {
      "id": 143,
      "title": "būtne",
      "level": 1,
      "definition": "Organisms (augs, dzīvnieks), kas eksistē."
    },
    {
      "id": 144,
      "title": "cauna",
      "level": 2,
      "definition": "Plēsēju kārtas sermuļu dzimtas ģints (\"Martes\"), vidēja lieluma dzīvnieks ar slaidu ķermeni, īsām kājām un pagaru asti."
    },
    {
      "id": 145,
      "title": "cālis",
      "level": 1,
      "definition": "Putnu (parasti vistu) mazulis; arī jaunputns."
    },
    {
      "id": 146,
      "title": "celis",
      "level": 1,
      "definition": "Locītava, kas savieno kājas augšstilbu ar apakšstilbu; arī ceļgals."
    },
    {
      "id": 147,
      "title": "celle",
      "level": 3,
      "definition": "Atsevišķa (parasti neliela) telpa mūkam vai mūķenei klosterī."
    },
    {
      "id": 148,
      "title": "celms",
      "level": 1,
      "definition": "Koka daļa, kas paliek virs zemes pēc tā nociršanas, nozāģēšanas, nolaušanas; šāda daļa kopa ar saknēm."
    },
    { "id": 149, "title": "cemme", "level": 3, "definition": "Dzintele." },
    {
      "id": 150,
      "title": "cents",
      "level": 1,
      "definition": "Naudas vienība, sīka monēta, parasti kādas valsts valūtas vienības 1/100; eirozonas valstīs eiro 1/100."
    },
    {
      "id": 151,
      "title": "cenzs",
      "level": 3,
      "definition": "Nosacījums, ar kuru ierobežo kādas tiesības."
    },
    {
      "id": 152,
      "title": "cērme",
      "level": 3,
      "definition": "Nematožu klases apakškārta (\"Ascaridata\"), līdz 30 cm garš parazītisks velteniskais tārps (dzīvnieku, arī cilvēku organismā)."
    },
    {
      "id": 153,
      "title": "cērte",
      "level": 2,
      "definition": "Vienā galā uzasināts āmurs (piemēram, akmeņu skaldīšanai)."
    },
    {
      "id": 154,
      "title": "ciāns",
      "level": 3,
      "definition": "Bezkrāsaina, ļoti indīga gāze ar asu rūgto mandeļu aromātu; diciāns."
    },
    {
      "id": 155,
      "title": "ciems",
      "level": 1,
      "definition": "Lauku apdzīvota vieta ar koncentrētu apbūvi, kurā ir pastāvīgie iedzīvotāji."
    },
    {
      "id": 156,
      "title": "cieņa",
      "level": 1,
      "definition": "Attieksme, kurai ir raksturīga (kāda cilvēka) spēju, zināšanu, nopelnu, vērtības u. tml. atzīšana; šādas attieksmes izpausme."
    },
    {
      "id": 157,
      "title": "ciesa",
      "level": 2,
      "definition": "Graudzāļu dzimtas ģints (\"Calamagrostis\"), daudzgadīgs augs ar garu stiebru un gariem ložņu sakneņiem, ~150 s., Latvijā konstatētas 6 sugas."
    },
    {
      "id": 158,
      "title": "ciete",
      "level": 1,
      "definition": "Polisaharīds, kas rodas augu zaļajās daļās graudiņu veidā."
    },
    {
      "id": 159,
      "title": "cikls",
      "level": 1,
      "definition": "Noteikts (procesu, norišu, darbību) kopums."
    },
    {
      "id": 160,
      "title": "cilme",
      "level": 2,
      "definition": "Izcelšanās (kādai parādībai, parasti mākslā, valodā)."
    },
    {
      "id": 161,
      "title": "cilpa",
      "level": 1,
      "definition": "Veidojums (no virves, auklas, siksnas u. tml.), kam ir gredzena vai loka forma un kas velkot sašaurinās, savelkas ciet."
    },
    {
      "id": 162,
      "title": "cilts",
      "level": 1,
      "definition": "Sabiedrības organizācijas forma pirmatnējās kopienas iekārtā."
    },
    { "id": 163, "title": "cimds", "level": 1, "definition": "Rokas ietērps." },
    {
      "id": 164,
      "title": "cinga",
      "level": 3,
      "definition": "Skorbuts - slimība, kuru izraisa C vitamīna trūkums organismā."
    },
    {
      "id": 165,
      "title": "cinis",
      "level": 1,
      "definition": "Neliels izcilnis (parasti zemā, purvainā vietā)."
    },
    {
      "id": 166,
      "title": "cinks",
      "level": 3,
      "definition": "Ķīmiskais elements - zilgani balts metāls, simbols Zn."
    },
    {
      "id": 167,
      "title": "cirks",
      "level": 1,
      "definition": "Mākslas veids, kura galvenie žanri ir akrobātika, jāšanas sports, ekvilibristika, žonglēšana, klaunāde, dzīvnieku dresūra, iluzionisms."
    },
    { "id": 168, "title": "cirpe", "level": 3, "definition": "Bīde." },
    {
      "id": 169,
      "title": "cirta",
      "level": 2,
      "definition": "Matu šķipsna (parasti vijīga, viļņota); sproga."
    },
    {
      "id": 170,
      "title": "cirte",
      "level": 2,
      "definition": "Meža koku izciršana, lai iegūtu koksni vai uzlabotu mežaudzes kvalitāti."
    },
    {
      "id": 171,
      "title": "cisas",
      "level": 3,
      "definition": "Salmi, siens, zirnāji, izžāvētas ūdenszāles, no kurām veido guļasvietu (gultā, uz grīdas u. tml.)."
    },
    {
      "id": 172,
      "title": "ciska",
      "level": 1,
      "definition": "Kājas daļa no iegurņa līdz ceļa locītavai; augšstilbs."
    },
    {
      "id": 173,
      "title": "cista",
      "level": 3,
      "definition": "Aizsargčaula, kas palielina zemāko organismu izturību nelabvēlīgos apstākļos."
    },
    {
      "id": 174,
      "title": "colla",
      "level": 2,
      "definition": "Garuma mērvienība - 2,54 centimetri (angļu un vecajā krievu mērvienību sistēmā) vai 2,36 centimetri (vācu mērvienību sistēmā), arī 1/12 pēdas = 24,74 mm; un decimālcolla = 1/10 pēdas = 29,69 mm."
    },
    {
      "id": 175,
      "title": "čadra",
      "level": 3,
      "definition": "Viegls plīvurs, kurā musulmaņu sievietes, izejot no mājas, ietinas, atstājot šauru spraugu acīm."
    },
    {
      "id": 176,
      "title": "čakra",
      "level": 3,
      "definition": "Metamais ierocis senajā Indijā, metāla riņķis (12-15 cm diametrā) ar asu ārmalu, kuru uzmauca uz rokas vidējā pirksta, sagrieza un meta uz pretinieku."
    },
    { "id": 177, "title": "čalas", "level": 2, "definition": "Runas, pļāpas." },
    { "id": 178, "title": "čalis", "level": 2, "definition": "Puisis, jauns vīrietis." },
    {
      "id": 179,
      "title": "čaula",
      "level": 1,
      "definition": "Ciets apvalks (sēklām, augļiem, pumpuriem)."
    },
    { "id": 180, "title": "čello", "level": 3, "definition": "Čells." },
    {
      "id": 181,
      "title": "čells",
      "level": 3,
      "definition": "Stīgu lociņinstruments, kas pēc skanējuma un apmēriem ir vidējs starp altu un kontrabasu."
    },
    { "id": 182, "title": "čulga", "level": 3, "definition": "Ūdeņaina tulzna." },
    {
      "id": 183,
      "title": "čuprs",
      "level": 3,
      "definition": "Kakls un muguras sākuma daļa (cilvēkam vai dzīvniekiem); skausts."
    },
    {
      "id": 184,
      "title": "čužas",
      "level": 3,
      "definition": "Saslaukas, gruži, dažādi atkritumi."
    },
    {
      "id": 185,
      "title": "čūska",
      "level": 1,
      "definition": "Rāpuļu klases zvīņrāpuļu kārtas apakškārta (\"Ophidia syn. Serpentes\"), dzīvnieks bez kājām ar garu, veltenisku ķermeni (piemēram, odze, zalktis), 12 dzimtas, ~2700 sugu, Latvijā konstatētas 2 dzimtas, 3 sugas; čūskveidīgie."
    },
    { "id": 186, "title": "daile", "level": 3, "definition": "Skaistums, daiļums." },
    {
      "id": 187,
      "title": "daina",
      "level": 2,
      "definition": "Latviešu klasiskā tautas dziesma."
    },
    {
      "id": 188,
      "title": "daiva",
      "level": 3,
      "definition": "Katra no vienveidīgām, norobežotām daļiņām, kas veido veselo."
    },
    {
      "id": 189,
      "title": "dakša",
      "level": 1,
      "definition": "Metāla darba rīks ar diviem vai vairākiem (parasti paralēliem) zariem (piemēram, siena, salmu uzņemšanai un pacelšanai) un pagaru kātu."
    },
    {
      "id": 190,
      "title": "dakts",
      "level": 3,
      "definition": "Auduma sloksne vai diegu vijums (parasti apgaismošanas ierīcē), pa kuru degšanas vietā pieplūst šķidrā degviela."
    },
    { "id": 191, "title": "danga", "level": 3, "definition": "Iebraukta gramba." },
    {
      "id": 192,
      "title": "darbs",
      "level": 1,
      "definition": "Cilvēka mērķtiecīga darbība, kurā viņš noteiktā nolūkā pārveido dabas priekšmetus, kā arī sabiedriskās attiecības, uzskatus."
    },
    {
      "id": 193,
      "title": "darva",
      "level": 2,
      "definition": "Cieto kurināmo sausās pārtvaices produkts - eļļains, parasti melns, šķidrums ar asu, īpatnēju smaku."
    },
    {
      "id": 194,
      "title": "datne",
      "level": 2,
      "definition": "Datu kopa, tekstuāls vai grafisks dokuments, kas datorā tiek uzglabāts vai apstrādāts kā atsevišķa vienība ar savu nosaukumu; fails."
    },
    { "id": 195, "title": "dānis", "level": 2, "definition": "Dāņi." },
    {
      "id": 196,
      "title": "dārds",
      "level": 3,
      "definition": "Spēcīgs, dobjš, nevienmērīgs troksnis, ko rada parādības dabā, parasti pērkons, arī ūdeņi."
    },
    {
      "id": 197,
      "title": "dārzs",
      "level": 1,
      "definition": "Īpaši ierīkots zemes gabals dažādu sugu, šķirņu kultūraugu (piemēram, dārzeņu, augļaugu, krāšņumaugu) audzēšanai; īpaši ierīkots zemes gabals vienas sugas, šķirnes augļaugu audzēšanai."
    },
    {
      "id": 198,
      "title": "deģis",
      "level": 3,
      "definition": "Cilvēks, kas nodarbojas ar (darvas, ogļu, spirta u. tml.) dedzināšanu."
    },
    { "id": 199, "title": "deķis", "level": 2, "definition": "Sega." },
    {
      "id": 200,
      "title": "delms",
      "level": 2,
      "definition": "Rokas daļa no pleca līdz plaukstai."
    },
    { "id": 201, "title": "delna", "level": 2, "definition": "Plaukstas apakšējā daļa." },
    {
      "id": 202,
      "title": "delta",
      "level": 3,
      "definition": "Zemiene, kas upes grīvā izveidojusies no sanesām un nogulsnēm, un upes sazarojumu kopums šādā zemienē."
    },
    {
      "id": 203,
      "title": "dēlis",
      "level": 1,
      "definition": "Zāģmateriāls, kas iegūts, garenvirzienā sazāģējot baļķi (apaļkoku) dažus centimetrus biezās plāksnēs."
    },
    {
      "id": 204,
      "title": "dēsts",
      "level": 2,
      "definition": "Jauns augs (parasti neliels lakstaugs), ko attīstības sākumā audzē, piemēram, siltumnīcās, lecektīs, siltajās dobēs un noteiktā attīstības pakāpē stāda paliekošā vietā."
    },
    {
      "id": 205,
      "title": "diegs",
      "level": 1,
      "definition": "No tekstilšķiedrām (piemēram, kokvilnas, vilnas, zīda) izgatavots un pēc tam savērpts pavediens (parasti šūšanai)."
    },
    {
      "id": 206,
      "title": "diena",
      "level": 1,
      "definition": "Laika posms no saules lēkta līdz rietam, no rīta līdz vakaram."
    },
    { "id": 207, "title": "dieve", "level": 3, "definition": "Dieviete." },
    {
      "id": 208,
      "title": "dievs",
      "level": 1,
      "definition": "Pēc reliģiskiem priekšstatiem - pārdabiska augstākā būtne, kas radījusi pasauli un valda pār to."
    },
    { "id": 209, "title": "diēta", "level": 2, "definition": "Īpašs uztura režīms." },
    {
      "id": 210,
      "title": "diēzs",
      "level": 3,
      "definition": "Zīme (nošu rakstā), kas norāda uz skaņas paaugstinājumu par pustoni."
    },
    { "id": 211, "title": "dilbs", "level": 3, "definition": "Apakšdelms." },
    { "id": 212, "title": "dille", "level": 2, "definition": "Dilles." },
    {
      "id": 213,
      "title": "dingo",
      "level": 3,
      "definition": "Austrālijas savvaļas suns (\"Canis familiaris dingo\") ar dzelteni rūsganu apmatojumu, atšķirībā no mājas suņiem tas nerej."
    },
    {
      "id": 214,
      "title": "diode",
      "level": 3,
      "definition": "Elektroniska ierīce, kas vada strāvu tikai vienā virzienā."
    },
    {
      "id": 215,
      "title": "disks",
      "level": 1,
      "definition": "Plakana, apaļa (ierīces) detaļa; arī ripa."
    },
    {
      "id": 216,
      "title": "dīķis",
      "level": 1,
      "definition": "Neliela ūdenskrātuve (parasti mākslīgi izveidota)."
    },
    {
      "id": 217,
      "title": "dodžs",
      "level": 3,
      "definition": "Vēlēts valdnieks senajās Venēcijas un Dženovas republikā (līdz 18. gadsimta beigām)."
    },
    {
      "id": 218,
      "title": "dogma",
      "level": 3,
      "definition": "Tēze, apgalvojums, mācība, ko pieņem par nemainīgu patiesību, nekritiski, neievērojot konkrētos apstākļus."
    },
    {
      "id": 219,
      "title": "domna",
      "level": 3,
      "definition": "Šahtveida krāsns ķeta kausēšanai no dzelzs rūdas."
    },
    {
      "id": 220,
      "title": "dosjē",
      "level": 3,
      "definition": "Dokumentu, materiālu kopums (kādā lietā vai jautājumā); mape ar šādiem dokumentiem, materiāliem."
    },
    {
      "id": 221,
      "title": "draga",
      "level": 3,
      "definition": "Peldoša ierīce, ko lieto derīgo izrakteņu mehanizētai iegūšanai."
    },
    {
      "id": 222,
      "title": "draps",
      "level": 3,
      "definition": "Biezs, mīksts, parasti uzkārsts, vilnas vai pusvilnas audums (parasti virsdrēbēm)."
    },
    {
      "id": 223,
      "title": "drava",
      "level": 2,
      "definition": "Biškopības vienība, kurā ietilpst bišu saimes, biškopības inventārs."
    },
    { "id": 224, "title": "draza", "level": 1, "definition": "Atkritumi, gruži." },
    { "id": 225, "title": "dražē", "level": 3, "definition": "Dražeja." },
    {
      "id": 226,
      "title": "drāma",
      "level": 1,
      "definition": "Viens no daiļliteratūras veidiem (blakus epikai un lirikai), kam raksturīgi daiļdarbi, kuri rakstīti personu sarunu vai monologu formā bez autora stāstījuma."
    },
    { "id": 227, "title": "drāna", "level": 2, "definition": "Austs materiāls; audums." },
    { "id": 228, "title": "drāts", "level": 2, "definition": "Stieple." },
    {
      "id": 229,
      "title": "drena",
      "level": 3,
      "definition": "Apakšzemes cauruļvads gruntsūdens novadīšanai vai tā līmeņa pazemināšanai."
    },
    {
      "id": 230,
      "title": "drēbe",
      "level": 1,
      "definition": "Austs materiāls; audums, drāna."
    },
    {
      "id": 231,
      "title": "drīve",
      "level": 3,
      "definition": "Materiāls, ar ko aizpilda nelielas spraugas."
    },
    { "id": 232, "title": "droga", "level": 3, "definition": "Drogas." },
    { "id": 233, "title": "druka", "level": 2, "definition": "Iespiedums, iespiešana." },
    { "id": 234, "title": "druva", "level": 2, "definition": "Labības lauks." },
    {
      "id": 235,
      "title": "dubļi",
      "level": 1,
      "definition": "Šķidra masa - ūdenī izmirkusi zeme."
    },
    {
      "id": 236,
      "title": "ducis",
      "level": 2,
      "definition": "Skaita mērvienība - 12 gabalu; kopa, kurā ir divpadsmit (parasti vienveidīgu) priekšmetu."
    },
    {
      "id": 237,
      "title": "duets",
      "level": 2,
      "definition": "Vokāls skaņdarbs divām balsīm; instrumentāls skaņdarbs diviem instrumentiem."
    },
    { "id": 238, "title": "duļķe", "level": 3, "definition": "Duļķes; nogulsnes." },
    {
      "id": 239,
      "title": "duļļi",
      "level": 3,
      "definition": "Tapas (laivas malās), starp kurām airējot liek airus."
    },
    {
      "id": 240,
      "title": "dunka",
      "level": 2,
      "definition": "Sitiens ar dūri vai elkoni (parasti pa sāniem, muguru)."
    },
    {
      "id": 241,
      "title": "dūcis",
      "level": 3,
      "definition": "Duncis; cūku kaujamais nazis."
    },
    {
      "id": 242,
      "title": "dūdas",
      "level": 2,
      "definition": "Savienojumā \"somu dūdas\" vai \"soma dūdas\": daudzu tautu pūšamais mūzikas instruments, ko darina no jēra vai kazlēna ādas, kurā iestiprina iemutni un, parasti divas, stabules; dūkas."
    },
    {
      "id": 243,
      "title": "dūkas",
      "level": 3,
      "definition": "Sens ide tautu pūšams instruments, ko vēl tagad lieto skotu un Balkānu tautu kara orķestrī, īru zemnieki, bet Latvijā suiti; somu (soma) dūdas."
    },
    {
      "id": 244,
      "title": "dūlis",
      "level": 3,
      "definition": "Dūmeklis, ar ko apdūmo bites vai citus kukaiņus."
    },
    {
      "id": 245,
      "title": "dūnas",
      "level": 2,
      "definition": "Mīkstas putnu spalvas (zem segspalvām)."
    },
    {
      "id": 246,
      "title": "dūņas",
      "level": 2,
      "definition": "Sīku organisko vielu vai minerāldaļiņu nogulumi ūdenskrātuvju dibenā."
    },
    {
      "id": 247,
      "title": "dūzis",
      "level": 2,
      "definition": "Spēļu kārts ar vienu attiecīgās sugas zīmi (vairākās spēlēs visspēcīgākā vai visvērtīgākā kārts attiecīgajā sugā)."
    },
    {
      "id": 248,
      "title": "dvaka",
      "level": 2,
      "definition": "Smaka, smakas piesātināts gaiss."
    },
    { "id": 249, "title": "dvaša", "level": 2, "definition": "Elpa." },
    {
      "id": 250,
      "title": "dzega",
      "level": 3,
      "definition": "Līmenisks, retāk liekts vai lauzīts, izlaidums ēkas ārsienā (starp sienu un jumtu, starp stāviem, virs logiem un durvīm) vai iekštelpā."
    },
    {
      "id": 251,
      "title": "dzeja",
      "level": 1,
      "definition": "Daiļliteratūras veids, kam raksturīgi saistītā valodā sacerēti liriski, liroepiski un humoristiski satīriski daiļdarbi."
    },
    { "id": 252, "title": "dzens", "level": 3, "definition": "Dzenbudisms." },
    {
      "id": 253,
      "title": "dzēse",
      "level": 3,
      "definition": "Zivju gārnis (\"Ardea cinerea\")."
    },
    {
      "id": 254,
      "title": "dzija",
      "level": 2,
      "definition": "Savērptas (vilnas vai tai līdzīgas izejvielas) šķiedras."
    },
    {
      "id": 255,
      "title": "dziņa",
      "level": 3,
      "definition": "Spēcīga tieksme (pēc kā); spēcīga vēlēšanās (ko darīt)."
    },
    {
      "id": 256,
      "title": "dzira",
      "level": 2,
      "definition": "Šķidra barība (mājdzīvnieku ēdināšanai)."
    },
    { "id": 257, "title": "dzīle", "level": 3, "definition": "Dzelme." },
    {
      "id": 258,
      "title": "dzīve",
      "level": 1,
      "definition": "Bioloģiska (cilvēku vai dzīvnieku) eksistence."
    },
    {
      "id": 259,
      "title": "dzots",
      "level": 3,
      "definition": "No kokmateriāliem zemē izbūvēts (parasti ložmetēju) ugunspunkts aizstāvēšanās kaujai."
    },
    {
      "id": 260,
      "title": "džems",
      "level": 2,
      "definition": "Ievārījums, kurā augļi vai ogas ir biezā, sarecējušā sīrupā."
    },
    {
      "id": 261,
      "title": "džezs",
      "level": 2,
      "definition": "Vieglā mūzika (īpašam orķestrim), kam raksturīga improvizācija, specifiski sinkopēti ritmi."
    },
    { "id": 262, "title": "džins", "level": 2, "definition": "Paegļu ogu degvīns." },
    {
      "id": 263,
      "title": "džips",
      "level": 2,
      "definition": "Apvidus mašīna ar četru riteņu piedziņu."
    },
    {
      "id": 264,
      "title": "džudo",
      "level": 3,
      "definition": "Cīņas sporta veids, kas sevišķi populārs Japānā; dziudo."
    },
    {
      "id": 265,
      "title": "džuta",
      "level": 3,
      "definition": "Liepu dzimtas ģints (\"Corchorus\"), viengadīgs, līdz 4,5 m augsts tropu šķiedraugs, no kura šķiedras izgatavo, piemēram, brezentu, auklas, maisu audeklu."
    },
    { "id": 266, "title": "ecēša", "level": 3, "definition": "Ecēšas." },
    {
      "id": 267,
      "title": "efeja",
      "level": 3,
      "definition": "Arāliju dzimtas ģints (\"Hedera\"), mūžzaļi liānveida krūmi ar tvērējsaknēm, vienkāršām veselām vai daivainām lapām, 7-9 sugas, Latvijā savvaļā 1 suga, vairākas sugas un šķirnes audzē kā krāšņumaugus un telpaugus."
    },
    {
      "id": 268,
      "title": "ekers",
      "level": 3,
      "definition": "Portatīvs ģeodēziskais instruments taisna leņķa nospraušanai dabā vai situācijas uzmērīšanai."
    },
    {
      "id": 269,
      "title": "ekijs",
      "level": 3,
      "definition": "Eiropas valūtas vienība (angļu \"European Currency Unit\"), balstījās uz dalībvalstu bruto nacionālo produktu un tirdzniecību; tā vērtība citu valstu valūtās tika aprēķināta un publicēta ik dienas; 1999. g. to aizstāja ar eiro."
    },
    {
      "id": 270,
      "title": "elite",
      "level": 3,
      "definition": "Selekcijā iegūta, augstvērtīga (augu vai dzīvnieku) izlase."
    },
    {
      "id": 271,
      "title": "elsas",
      "level": 2,
      "definition": "Krampjaina, skaļa ieelpa un izelpa (raudot)."
    },
    {
      "id": 272,
      "title": "emīrs",
      "level": 3,
      "definition": "Valdošās personas, arī valdošās dzimtas piederīgā tituls (dažās musulmaņu zemēs); cilvēks, kam ir šāds tituls."
    },
    {
      "id": 273,
      "title": "epika",
      "level": 3,
      "definition": "Viens no daiļliteratūras pamatveidiem (blakus drāmai un lirikai), kam raksturīgs autora objektīvs vēstījums par notikumiem un personām."
    },
    {
      "id": 274,
      "title": "epīra",
      "level": 3,
      "definition": "Kādas figūras projekciju rasējums plaknē, kas iegūts, savietojot projekciju plaknes."
    },
    {
      "id": 275,
      "title": "epoha",
      "level": 3,
      "definition": "Laika moments, kam atbilst astronomisko novērojumu vai aprēķinu dati, kuri raksturo debess spīdekļu stāvokli."
    },
    {
      "id": 276,
      "title": "eposs",
      "level": 2,
      "definition": "Liroepikas paveids - varoņpoēma, kas vēstī par svarīgiem notikumiem tautas dzīvē; šī liroepikas paveida daiļdarbs."
    },
    {
      "id": 277,
      "title": "eseja",
      "level": 2,
      "definition": "Neliela mākslinieciski kritiska apcere, kurā izceļas galvenokārt autora subjektīvi emocionālā attieksme pret attēlojamo parādību."
    },
    {
      "id": 278,
      "title": "esība",
      "level": 3,
      "definition": "Kādu konkrētu vai abstraktu priekšmetu tiešā klātbūtne, atrašanās noteiktā vietā, vidē, laikā."
    },
    {
      "id": 279,
      "title": "etaps",
      "level": 3,
      "definition": "Posms (kādā norisē, procesā)."
    },
    {
      "id": 280,
      "title": "etāns",
      "level": 3,
      "definition": "Bezkrāsaina gāzveida viela - piesātinātais ogļūdeņradis, kas ietilpst deggāzes un naftas gāzu sastāvā."
    },
    {
      "id": 281,
      "title": "etils",
      "level": 3,
      "definition": "Organisks radikālis C2H5 - etilgrupa."
    },
    {
      "id": 282,
      "title": "etīde",
      "level": 3,
      "definition": "Zīmējums vai gleznojums no dabas (dabas studijām)."
    },
    {
      "id": 283,
      "title": "ezers",
      "level": 1,
      "definition": "Dabiska ūdenskrātuve, kas aizņem sauszemes virsas iedobumu."
    },
    {
      "id": 284,
      "title": "ēdājs",
      "level": 1,
      "definition": "Cilvēks, kas ēd, kas patērē pārtiku."
    },
    { "id": 285, "title": "ēdējs", "level": 3, "definition": "Cilvēks, kas ēd." },
    { "id": 286, "title": "ēdums", "level": 3, "definition": "Apēstais." },
    {
      "id": 287,
      "title": "ēters",
      "level": 2,
      "definition": "Hipotētiska vide, kura it kā aizņem pasaules telpu un brīvo telpu starp ķermeņiem, tajā skaitā starp atomiem un molekulām, un kas bija pieņemta, lai izskaidrotu elektromagnētisko viļņu izplatīšanos."
    },
    {
      "id": 288,
      "title": "ētika",
      "level": 2,
      "definition": "Zinātne par morāli, tikumību."
    },
    {
      "id": 289,
      "title": "ēvele",
      "level": 1,
      "definition": "Darba rīks koka virsmas apstrādāšanai."
    },
    {
      "id": 290,
      "title": "fails",
      "level": 1,
      "definition": "Datu kopa, tekstuāls vai grafisks dokuments, kas datorā tiek uzglabāts vai apstrādāts kā atsevišķa vienība ar savu nosaukumu; datne."
    },
    {
      "id": 291,
      "title": "fakss",
      "level": 2,
      "definition": "Aparāts informācijas pārraidīšanai un uztveršanai ar faksimilsakariem, telefakss."
    },
    {
      "id": 292,
      "title": "fakts",
      "level": 1,
      "definition": "Reāls, patiess notikums, (īstenības) parādība."
    },
    {
      "id": 293,
      "title": "falle",
      "level": 3,
      "definition": "Virve, tauva, ar kuru uz kuģa paceļ buras, rājas (arī karogus, signālus u. tml.)."
    },
    {
      "id": 294,
      "title": "farss",
      "level": 2,
      "definition": "Sens franču sadzīves komēdijas paveids; komēdija vai vodeviļa ar ārišķīgiem, parupjiem efektiem."
    },
    {
      "id": 295,
      "title": "fauna",
      "level": 1,
      "definition": "Vēsturiski izveidojies dzīvnieku sugu kopums (piemēram, noteiktā teritorijā, ainavā, ģeoloģiskajā laikmetā); dzīvnieku valsts."
    },
    {
      "id": 296,
      "title": "feods",
      "level": 3,
      "definition": "Zemes īpašums, ko vasalis saņēma valdījumā no sava senjora; lēnis."
    },
    {
      "id": 297,
      "title": "ferma",
      "level": 1,
      "definition": "Celtne vai celtņu komplekss lauksaimniecības dzīvnieku mitināšanai, arī lopbarības uzglabāšanai un sagatavošanai."
    },
    {
      "id": 298,
      "title": "feska",
      "level": 3,
      "definition": "Galvassega nošķelta konusa formā ar pušķi (dažās Tuvo Austrumu un Ziemeļāfrikas zemēs)."
    },
    { "id": 299, "title": "fibra", "level": 3, "definition": "Šķiedra." },
    {
      "id": 300,
      "title": "filcs",
      "level": 2,
      "definition": "Smalks un biezs, uzkārsts augstākā labuma audums."
    },
    {
      "id": 301,
      "title": "filma",
      "level": 1,
      "definition": "Plāna, no caurspīdīga materiāla izgatavota lente ar gaismjutīgu emulsiju (fotografēšanai); fotofilma."
    },
    {
      "id": 302,
      "title": "firma",
      "level": 1,
      "definition": "Uzņēmums (organizācija) vai uzņēmumu apvienība, kam ir juridiskas personas tiesības."
    },
    { "id": 303, "title": "fisks", "level": 3, "definition": "Valsts kase." },
    {
      "id": 304,
      "title": "flīze",
      "level": 1,
      "definition": "Kāda materiāla (piemēram, akmens, betona, keramikas) plāksne, ko lieto celtniecībā sienu, grīdu vai citu virsmu apdarei."
    },
    {
      "id": 305,
      "title": "flora",
      "level": 3,
      "definition": "Vēsturiski izveidojies augu sugu kopums (piemēram, noteiktā teritorijā, ainavā, ģeoloģiskajā laikmetā); augu valsts."
    },
    {
      "id": 306,
      "title": "flote",
      "level": 2,
      "definition": "Kuģu kopums, kam ir vienāds uzdevums."
    },
    {
      "id": 307,
      "title": "foajē",
      "level": 2,
      "definition": "Telpa (teātrī, kinoteātrī u. tml.), kur publika var uzkavēties starpbrīžos vai pirms izrādes sākuma."
    },
    {
      "id": 308,
      "title": "fogts",
      "level": 3,
      "definition": "Amatpersona (viduslaikos Livonijā, Vācijā) ar dažādām funkcijām (piemēram, pils un pils novada pārvaldītājs, tiesnesis, soģis)."
    },
    {
      "id": 309,
      "title": "folio",
      "level": 3,
      "definition": "Poligrāfijā grāmatas lappuses formāts, kas iegūts, standarta loksni pārliecot tikai uz pusēm."
    },
    {
      "id": 310,
      "title": "fonds",
      "level": 2,
      "definition": "Tas, kas ir (kā) krājums, rezerve."
    },
    {
      "id": 311,
      "title": "fonts",
      "level": 2,
      "definition": "Noteikta lieluma un stila rakstzīmju komplekts."
    },
    { "id": 312, "title": "fords", "level": 2, "definition": "Vieglo automašīnu marka." },
    {
      "id": 313,
      "title": "forma",
      "level": 1,
      "definition": "Ārējais veids, apveids (piemēram, priekšmetam)."
    },
    {
      "id": 314,
      "title": "forts",
      "level": 2,
      "definition": "Nocietinājums (parasti liels) vai nocietinājumu sistēma."
    },
    {
      "id": 315,
      "title": "fraka",
      "level": 2,
      "definition": "Vīriešu svinību tērps - žakete ar lielu izgriezumu priekšā un pagarinātu, dziļi šķeltu muguras daļu."
    },
    {
      "id": 316,
      "title": "frāze",
      "level": 2,
      "definition": "Runas vienība, vārdu savienojums (parasti teikums)."
    },
    {
      "id": 317,
      "title": "frēze",
      "level": 2,
      "definition": "Rotējošs daudzšķautņu griezējinstruments (cietu materiālu apstrādei); arī frēzmašīna."
    },
    {
      "id": 318,
      "title": "frīze",
      "level": 3,
      "definition": "Līmeniska dekoratīva josla klasiskajā orderī; antablementa daļa starp arhitrāvu un karnīzu."
    },
    { "id": 319, "title": "frīzs", "level": 3, "definition": "Dzega, josla; frīze." },
    {
      "id": 320,
      "title": "frotē",
      "level": 2,
      "definition": "Pabiezs, mīksts cilpveida (parasti kokvilnas) audums."
    },
    {
      "id": 321,
      "title": "fuetē",
      "level": 3,
      "definition": "Klasiskās dejas soļu (pas) apzīmējums."
    },
    {
      "id": 322,
      "title": "gabro",
      "level": 3,
      "definition": "Tumšs, rupjgraudains bāzisks intruzīvs iezis, dažreiz satur vara, niķeļa, titāna rūdas."
    },
    {
      "id": 323,
      "title": "gaida",
      "level": 3,
      "definition": "Pēc skautu parauga dibinātas meiteņu organizācijas locekle."
    },
    {
      "id": 324,
      "title": "gaide",
      "level": 3,
      "definition": "Medījamā dzīvnieka gaidīšana, medniekiem atrodoties slēptā vietā."
    },
    {
      "id": 325,
      "title": "gaiss",
      "level": 1,
      "definition": "Gāzveida slānis, kas aptver Zemi un veido tās atmosfēru."
    },
    {
      "id": 326,
      "title": "gaita",
      "level": 1,
      "definition": "Pārvietošanās, ejot uz kurieni (cilvēkiem vai dzīvniekiem)."
    },
    {
      "id": 327,
      "title": "galds",
      "level": 1,
      "definition": "Mēbele, kas sastāv no horizontālas plaknes, kura balstās uz vienas vai vairākām kājām, un ir paredzēta dažādu priekšmetu novietošanai (piemēram, ēdot, strādājot)."
    },
    {
      "id": 328,
      "title": "galms",
      "level": 2,
      "definition": "Valdnieka dzīvesvieta; dižciltīgu cilvēku grupa, kas dzīvo šādā vietā."
    },
    {
      "id": 329,
      "title": "galva",
      "level": 1,
      "definition": "Ķermeņa augšējā daļa (cilvēkam) vai priekšējā daļa (dzīvniekam), kurā atrodas smadzenes."
    },
    {
      "id": 330,
      "title": "gamma",
      "level": 3,
      "definition": "Noteiktā intervālu secībā sakārtota pakāpeniska skaņu rinda oktāvas apjomā."
    },
    {
      "id": 331,
      "title": "garša",
      "level": 1,
      "definition": "Spēja uztvert vielu ķīmiskās īpašības - saldumu, rūgtumu, skābumu vai sāļumu."
    },
    {
      "id": 332,
      "title": "gatve",
      "level": 2,
      "definition": "Ceļš, kam abas puses apstādītas ar kokiem, krūmiem; aleja."
    },
    {
      "id": 333,
      "title": "gaučo",
      "level": 3,
      "definition": "Gans jātnieks Dienvidamerikā."
    },
    {
      "id": 334,
      "title": "gaume",
      "level": 2,
      "definition": "Skaistuma izpratne; spēja uztvert un vērtēt skaistumu."
    },
    {
      "id": 335,
      "title": "gārsa",
      "level": 3,
      "definition": "Čemurziežu dzimtas ģints (\"Aegopodium\"), daudzgadīgs lakstaugs ar lielām divkārt trīsstaraini plūksnainām lapām (\"Aegopodium\"), 7 s., Latvijā konstatēta 1 s."
    },
    {
      "id": 336,
      "title": "gārša",
      "level": 3,
      "definition": "Mežs, kurā aug egles, bērza, apses, oša un ozola mistrotas audzes; meža augšanas apstākļu tips, kam parasti raksturīgi pamatmorēnu līdzenumi."
    },
    {
      "id": 337,
      "title": "gāzma",
      "level": 3,
      "definition": "Spēcīga (lietus) līšana, spēcīgs lietus; spēcīga (vēja) brāzma."
    },
    {
      "id": 338,
      "title": "geiša",
      "level": 3,
      "definition": "Vispusīgi izglītota, profesionāli sagatavota japāņu dziedātāja un dejotāja, kas kavē laiku viesiem, piemēram, tējnīcās, viesībās."
    },
    {
      "id": 339,
      "title": "ginks",
      "level": 3,
      "definition": "Augu valsts sēklaugu apakšvalsts kailsēkļu nodalījuma klase (\"Ginkgoopsida\"), cēlusies no sēklpapardēm, atliekas atrastas perma nogulumos līdz krīta periodam."
    },
    {
      "id": 340,
      "title": "glāze",
      "level": 1,
      "definition": "Neliels (parasti cilindrveida) stikla vai cita, parasti caurspīdīga, materiāla trauks bez osas, no kura dzer."
    },
    {
      "id": 341,
      "title": "glets",
      "level": 3,
      "definition": "Svina oksīds, dzeltenīgs pulveris, ko lieto keramikas glazūru izgatavošanai, svina baltuma, okera un citu svina preparātu ražošanā."
    },
    {
      "id": 342,
      "title": "glūda",
      "level": 3,
      "definition": "Ļoti plastisks māls, parasti pelēkā vai zilganpelēkā krāsā."
    },
    { "id": 343, "title": "glūņa", "level": 2, "definition": "Cilvēks, kas glūn (2)." },
    { "id": 344, "title": "gnīda", "level": 2, "definition": "Uts oliņa." },
    {
      "id": 345,
      "title": "gnoms",
      "level": 3,
      "definition": "Pazemes gars (Rietumeiropas tautu mitoloģijā); kalna gariņš; arī rūķītis."
    },
    {
      "id": 346,
      "title": "golfs",
      "level": 2,
      "definition": "Sporta spēle, kurā bumbiņa ar nūju jāieraida laukuma bedrītēs."
    },
    {
      "id": 347,
      "title": "gongs",
      "level": 2,
      "definition": "Austrumāzijas tautu metāla sitamais mūzikas instruments izliekta bronzas diska veidā (izmanto arī signalizēšanai); metāla gabals, ko skandina signalizējot."
    },
    {
      "id": 348,
      "title": "grafs",
      "level": 3,
      "definition": "Figūra, ko veido ar līnijām savienoti punkti un ko parasti izmanto, lai shematiski attēlotu kādu objektu vai norisi."
    },
    {
      "id": 349,
      "title": "grams",
      "level": 1,
      "definition": "Masas mērvienība, kas vienāda ar vienu kilograma tūkstošdaļu."
    },
    {
      "id": 350,
      "title": "grava",
      "level": 2,
      "definition": "Tekošu ūdeņu izveidots vagveida padziļinājums, ieleja ar stāvām nogāzēm."
    },
    {
      "id": 351,
      "title": "grāds",
      "level": 1,
      "definition": "Temperatūras intervāla mērvienība (noteiktā temperatūras skalā)."
    },
    {
      "id": 352,
      "title": "grāfs",
      "level": 1,
      "definition": "Karaļa ierēdnis, tiesnesis (agrā feodālisma laikā Rietumeiropā), neliela teritoriāla apgabala (grāfistes) valdnieks."
    },
    { "id": 353, "title": "grēda", "level": 1, "definition": "Iegarens krāvums." },
    {
      "id": 354,
      "title": "grēks",
      "level": 1,
      "definition": "Reliģisko normu un tikumisko priekšrakstu pārkāpums domās, vārdos un darbos."
    },
    {
      "id": 355,
      "title": "griba",
      "level": 1,
      "definition": "Psihisku norišu kopums, kuras izpaužas motivētā, mērķtiecīgā, apzinātā darbībā, pārvarot kādas grūtības."
    },
    {
      "id": 356,
      "title": "grifs",
      "level": 3,
      "definition": "Piekūnveidīgo kārtas vanagu dzimtas divas ģintis (\"Gyps\" un \"Aegypius\"), ģintī \"Gyps\" ir 7 sugas, ģintī \"Aegypius\" - 2 sugas, Latvijā kā ļoti reti ieceļotāji konstatētas 2 sugas."
    },
    {
      "id": 357,
      "title": "grils",
      "level": 2,
      "definition": "Īpašas restes vai speciāla kamera cepšanai."
    },
    {
      "id": 358,
      "title": "gripa",
      "level": 1,
      "definition": "Akūta infekcijas slimība, kam raksturīga paaugstināta temperatūra, augšējo elpošanas ceļu iekaisums un organisma vispārēja intoksikācija."
    },
    {
      "id": 359,
      "title": "grīda",
      "level": 1,
      "definition": "Telpas apakšējais iekšējais segums (pa kuru staigā)."
    },
    {
      "id": 360,
      "title": "grīva",
      "level": 3,
      "definition": "Upes posms pie ietekas jūrā, ezerā, ūdenskrātuvē vai citā upē; vieta upes lejtecē, kur ūdens izsīkst, nesasniedzot ieteku."
    },
    { "id": 361, "title": "grods", "level": 3, "definition": "Stingri savīts, savērpts." },
    {
      "id": 362,
      "title": "groks",
      "level": 3,
      "definition": "Alkoholisks dzēriens, ko gatavo, piejaucot saldai, karstai tējai rumu, konjaku vai spirtu."
    },
    {
      "id": 363,
      "title": "grope",
      "level": 3,
      "definition": "Šaura, gara (kādā priekšmetā izveidota) rieva, kurā iestiprina (citu priekšmetu, detaļu u. tml.)."
    },
    {
      "id": 364,
      "title": "grota",
      "level": 3,
      "definition": "Dabiska vai mākslīgi izveidota ala, arī atsevišķa alas daļa, nozarojums."
    },
    {
      "id": 365,
      "title": "grozs",
      "level": 1,
      "definition": "Traukam vai kastei līdzīgs pinums no klūgām, skaliem u. tml. (kā) uzglabāšanai, pārnešanai."
    },
    {
      "id": 366,
      "title": "groži",
      "level": 3,
      "definition": "Iejūga daļa - virve, siksna, lente, kuras galus piestiprina pie zirga mutes dzelžiem, lai varētu vadīt iejūgto zirgu."
    },
    {
      "id": 367,
      "title": "grupa",
      "level": 1,
      "definition": "Vairāki, piemēram, cilvēki, dzīvnieki, priekšmeti, kas atrodas tuvu cits pie cita."
    },
    {
      "id": 368,
      "title": "guaša",
      "level": 2,
      "definition": "Necaurspīdīga, blīva krāsa, ko iegūst, krāsu pigmentus šķīdinot ūdenī, kuram piejaukta augu līme un baltā krāsa."
    },
    {
      "id": 369,
      "title": "gulta",
      "level": 1,
      "definition": "Mēbele gulēšanai, parasti paaugstinātiem galiem un rāmi matracim, guļammaisam; arī guļasvieta."
    },
    {
      "id": 370,
      "title": "gurns",
      "level": 1,
      "definition": "Ķermeņa daļa starp muguras apakšējo galu un augšstilbu; gūža."
    },
    {
      "id": 371,
      "title": "gūsts",
      "level": 2,
      "definition": "Nebrīve, kādā nokļūst karavīrs, ko sagūstījis pretinieks."
    },
    {
      "id": 372,
      "title": "gūzma",
      "level": 2,
      "definition": "Liels daudzums (cilvēku, arī dzīvnieku), kas sablīvējies vai sablīvēts cieši vienkopus; drūzma."
    },
    {
      "id": 373,
      "title": "gvano",
      "level": 3,
      "definition": "Izžuvuši savvaļas putnu mēsli, ko izmanto par slāpekļa un fosforskābes mēslojumu."
    },
    { "id": 374, "title": "ģeķis", "level": 3, "definition": "Muļķis; nelga." },
    { "id": 375, "title": "ģērbs", "level": 3, "definition": "Apģērbs, tērps." },
    {
      "id": 376,
      "title": "ģikts",
      "level": 3,
      "definition": "Podagra - vielmaiņas traucējumi, kas saistīti ar urīnskābes sāļu uzkrāšanos organismā un to izgulsnēšanos locītavās, zemādā un citur."
    },
    {
      "id": 377,
      "title": "ģilde",
      "level": 3,
      "definition": "Cilvēku apvienība, kuriem ir vienādas intereses vai prasmes un kuri apvienojušies, lai atbalstītu cits citu."
    },
    {
      "id": 378,
      "title": "ģints",
      "level": 3,
      "definition": "Pirmatnējās kopienas iekārtas galvenā sabiedrības ekonomiskā vienība, ko apvieno asinsradniecība vai šķietama izcelšanās no kopīga senča, kopēja saimniecība un paražas; dzimta ."
    },
    { "id": 379, "title": "ģīmis", "level": 2, "definition": "Seja; grimase; maska." },
    { "id": 380, "title": "haika", "level": 3, "definition": "Haiku." },
    { "id": 381, "title": "halle", "level": 3, "definition": "Liela telpa, zāle." },
    {
      "id": 382,
      "title": "halva",
      "level": 2,
      "definition": "Konditorejas izstrādājums - saldvielu un sasmalcinātu eļļas augu kodolu masa."
    },
    {
      "id": 383,
      "title": "halze",
      "level": 3,
      "definition": "Kuģa kurss attiecībā pret vēja virzienu."
    },
    {
      "id": 384,
      "title": "haoss",
      "level": 2,
      "definition": "Pilnīgs sistēmas trūkums; liela nekārtība, juceklis."
    },
    {
      "id": 385,
      "title": "harta",
      "level": 3,
      "definition": "Politisks un juridisks dokuments, kurā gk. izteiktas kādu sabiedrības slāņu politiskās prasības."
    },
    {
      "id": 386,
      "title": "henna",
      "level": 3,
      "definition": "Sarkanbrūna dabiskā krāsviela."
    },
    {
      "id": 387,
      "title": "hercs",
      "level": 3,
      "definition": "Svārstību frekvences mērvienība (starptautiskajā mērvienību sistēmā); Hz."
    },
    { "id": 388, "title": "hiāts", "level": 3, "definition": "Šķēlums, plaisa; sprauga." },
    {
      "id": 389,
      "title": "hidra",
      "level": 3,
      "definition": "Zarndobumaiņu tipa hidrozoju klases apakšklases (\"Hydrida\"), vientuļi, pārvietoties spējīgi polipi, 30 s."
    },
    {
      "id": 390,
      "title": "hiēna",
      "level": 2,
      "definition": "Zīdītāju klases plēsēju kārtas dzimta (\"Hyaenidae\"), samērā lieli dzīvnieki (ķermeņa gar. 55-165 cm, masa - 10-80 kg), parasti dzīvo atklātos līdzenumos (pustuksnešos, tuksnešos), izplatīti Āfrikā un Dienvidāzijā, 3 ģ., 4 s."
    },
    {
      "id": 391,
      "title": "himna",
      "level": 1,
      "definition": "Svinīga dziesma, kas simbolizē, piemēram, valsti, organizāciju."
    },
    {
      "id": 392,
      "title": "hlors",
      "level": 2,
      "definition": "Ķīmiskais elements - dzelteni zaļgana, indīga, ķīmiski ļoti aktīva gāze; simbols Cl."
    },
    {
      "id": 393,
      "title": "horda",
      "level": 3,
      "definition": "Taisnes nogrieznis, kas savieno divus riņķa līnijas punktus."
    },
    {
      "id": 394,
      "title": "hroms",
      "level": 3,
      "definition": "Ķīmiskais elements - zilgani balts, spožs, ļoti ciets metāls, atomnumurs - 24, atommasa - 51,996, zināmi 11 izotopi, no kuriem 4 ir stabili."
    },
    {
      "id": 395,
      "title": "hunta",
      "level": 3,
      "definition": "Sabiedriski politiska organizācija, sapulce vai apvienība (parasti Spānijā, Latīņamerikas zemēs)."
    },
    {
      "id": 396,
      "title": "hurma",
      "level": 2,
      "definition": "Ebenu rindas ebenu (ebenaugu) dzimtas ģints (\"Diospyros\"), 200-500 s., kas izplatītas gk. Āzijas dienvidos."
    },
    {
      "id": 397,
      "title": "ibiss",
      "level": 3,
      "definition": "Putnu klases stārķveidīgo kārtas dzimta (\"Threskiornithidae\"), bridējputns ar garu, lokveidā saliektu vai taisnu knābi; 20 ģintis, 32 sugas, kas dzīvo tropos un subtropos; Latvijā kā reti ieceļotāji konstatētas 2 sugas."
    },
    {
      "id": 398,
      "title": "ideja",
      "level": 1,
      "definition": "Jēdziens, priekšstats, kas cilvēka apziņā atspoguļo īstenību un pauž viņa attieksmi pret apkārtējo pasauli."
    },
    {
      "id": 399,
      "title": "ieeja",
      "level": 1,
      "definition": "Vieta, kura paredzēta iekļūšanai vai pa kuru var iekļūt (kur iekšā)."
    },
    { "id": 400, "title": "iekša", "level": 1, "definition": "Telpu iekšiene, iekšpuse." },
    {
      "id": 401,
      "title": "iesms",
      "level": 1,
      "definition": "Nūja, stienis, kuram viens vai abi gali ir nosmailināti un kuru parasti izmanto, lai ko uzdurtu cepšanai uz uguns."
    },
    {
      "id": 402,
      "title": "ietve",
      "level": 1,
      "definition": "Speciāli izveidota, parasti mazliet paaugstināta (ielas, ceļa, tilta u. tml.), daļa gājēju kustībai (līdztekus brauktuvei)."
    },
    { "id": 403, "title": "iezis", "level": 1, "definition": "Ieži." },
    {
      "id": 404,
      "title": "ikona",
      "level": 1,
      "definition": "Romas katoļu un Pareizticīgo baznīcas svētbilde."
    },
    {
      "id": 405,
      "title": "ilgas",
      "level": 2,
      "definition": "Psihisks stāvoklis, kam raksturīga dziļa, parasti arī ilgstoša, tieksme, vēlēšanās (parasti pēc kā labāka vai arī tāla, grūti sasniedzama)."
    },
    { "id": 406, "title": "ilkss", "level": 3, "definition": "Ilknis." },
    {
      "id": 407,
      "title": "imīds",
      "level": 3,
      "definition": "Skābes atvasinājums, kurā divi skābju atlikumi saistīti ar NH vai NR grupu (R - ogļūdeņraža atlikums)."
    },
    { "id": 408, "title": "incis", "level": 3, "definition": "Kaķis." },
    {
      "id": 409,
      "title": "irdne",
      "level": 3,
      "definition": "Augsne, zeme; augsnes, zemes irdenā virskārta."
    },
    { "id": 410, "title": "irsis", "level": 2, "definition": "Sirsenis." },
    {
      "id": 411,
      "title": "izeja",
      "level": 1,
      "definition": "Vieta, kas paredzēta iziešanai, izkļūšanai (no kādas telpas, teritorijas), vieta, pa kuru iziet, izkļūst (no kurienes)."
    },
    {
      "id": 412,
      "title": "īlens",
      "level": 1,
      "definition": "Darba rīks - spalā iestiprināts smails metāla stienis (caurumu izduršanai, piemēram, ādā, papē)."
    },
    { "id": 413, "title": "īrējs", "level": 2, "definition": "Airētājs." },
    {
      "id": 414,
      "title": "īriss",
      "level": 2,
      "definition": "Skalbju dzimtas ģints (\"Iris\"), augs ar ložņājošu sakneni, zobenveida lapām un lieliem ziediem; skalbes."
    },
    {
      "id": 415,
      "title": "īsums",
      "level": 2,
      "definition": "Vispārināta īpašība --> īss , šīs īpašības konkrēta izpausme."
    },
    {
      "id": 416,
      "title": "jahta",
      "level": 2,
      "definition": "Viegla vienmasta buru laiva (sportam)."
    },
    {
      "id": 417,
      "title": "jambs",
      "level": 3,
      "definition": "Pantmērs, kam ir divzilbīga pēda, kurā pēdējā zilbe ir uzsvērta (sillabotoniskajā vārsmošanas sistēmā) vai gara (antīkajā vārsmošanas sistēmā)."
    },
    {
      "id": 418,
      "title": "jamss",
      "level": 3,
      "definition": "Daudzgadīgs tropu un subtropu tīteņaugs; dioskorejas."
    },
    {
      "id": 419,
      "title": "jards",
      "level": 2,
      "definition": "Angļu garuma mērvienība 3 pēdas jeb 36 collas - aptuveni 914,39179 milimetri (ASV - 914,402 mm)."
    },
    {
      "id": 420,
      "title": "jašma",
      "level": 3,
      "definition": "Kristālisks, blīvs dažādas krāsas iezis, kas satur kvarcu un halcedonu (izmanto rotājumiem un mākslas priekšmetu izgatavošanai)."
    },
    { "id": 421, "title": "jauda", "level": 1, "definition": "Spēks, spēja (cilvēkam)." },
    { "id": 422, "title": "jezga", "level": 1, "definition": "Troksnis, kņada." },
    { "id": 423, "title": "jonis", "level": 1, "definition": "Laikposms, brīdis." },
    {
      "id": 424,
      "title": "josla",
      "level": 1,
      "definition": "Samērā šaura, parasti garena (virsmas, priekšmeta) daļa, kas (piemēram, ar krāsu, formu) atšķiras no pārējām daļām."
    },
    {
      "id": 425,
      "title": "josta",
      "level": 1,
      "definition": "Saite, šaura sloksne, ko apņem ap vidukli."
    },
    {
      "id": 426,
      "title": "jukas",
      "level": 1,
      "definition": "Nekārtības, sajukums (parasti sabiedrības dzīvē)."
    },
    {
      "id": 427,
      "title": "jumis",
      "level": 2,
      "definition": "Dubultauglis, dubultvārpa, pa pārim kopā saauguši augi."
    },
    {
      "id": 428,
      "title": "jumts",
      "level": 1,
      "definition": "Konstrukcija, kas sedz (celtni) no augšas; šīs konstrukcijas segums."
    },
    {
      "id": 429,
      "title": "junda",
      "level": 2,
      "definition": "Dienas gaitu sākuma vai beigu signāls (parasti bruņotajos spēkos)."
    },
    {
      "id": 430,
      "title": "junga",
      "level": 3,
      "definition": "Pusaudzis, kas uz kuģa mācās par matrozi, kā arī veic dažādus darbus."
    },
    { "id": 431, "title": "jupis", "level": 2, "definition": "Nelabais, velns; jods." },
    {
      "id": 432,
      "title": "jurģi",
      "level": 2,
      "definition": "23. aprīlis kā nomas un darba līgumu termiņš; pāriešana uz citu nomas vai darba vietu."
    },
    {
      "id": 433,
      "title": "jurta",
      "level": 3,
      "definition": "Pārvietojams mājoklis tjurku un mongoļu klejotājtautām; sastāv no koka karkasa un filca pārklājuma."
    },
    {
      "id": 434,
      "title": "jūdze",
      "level": 2,
      "definition": "Nemetrisko mērvienību sistēmu garuma mērvienība - meridiāna loka minūtes garums, ko izmanto navigācijā, taču sferoīdās Zemes formas dēļ tās garums mainās no 1842,9 m (uz ekvatora) līdz 1861,6 m (pie poliem)."
    },
    {
      "id": 435,
      "title": "jūsma",
      "level": 2,
      "definition": "Psihisks stāvoklis, kam raksturīga emocionāla pacilātība, dziļš saviļņojums."
    },
    {
      "id": 436,
      "title": "jūtas",
      "level": 1,
      "definition": "Cilvēka pārdzīvojums, attieksme pret apkārtējo pasauli un pašam pret sevi; emocijas."
    },
    {
      "id": 437,
      "title": "jūtis",
      "level": 3,
      "definition": "Savienojumā ar \"ceļa\": krustceles."
    },
    {
      "id": 438,
      "title": "kadrs",
      "level": 2,
      "definition": "Atsevišķs uzņēmums (fotofilmā, kinofilmā)."
    },
    {
      "id": 439,
      "title": "kaifs",
      "level": 2,
      "definition": "Patīkamu sajūtu kopums, ko rada narkotiku, alkohola iedarbība; estētiska vai citāda bauda vai arī laiska tīksme."
    },
    {
      "id": 440,
      "title": "kaija",
      "level": 1,
      "definition": "Putnu klases tārtiņveidīgo kārtas dzimta (\"Laridae\"), 2 apakšdzimtas."
    },
    { "id": 441, "title": "kaite", "level": 1, "definition": "Slimība." },
    {
      "id": 442,
      "title": "kakao",
      "level": 1,
      "definition": "Tropu koks ar lielām, veselām lapām, sīkiem, iesarkaniem ziediem un gurķveidīgiem augļiem."
    },
    {
      "id": 443,
      "title": "kakls",
      "level": 1,
      "definition": "Ķermeņa daļa starp galvu un vidukli."
    },
    {
      "id": 444,
      "title": "kakts",
      "level": 1,
      "definition": "Vieta, kur saskaras (telpas, celtnes) iekšējās sienas, veidojot leņķi; (telpas, celtnes) daļa šādas vietas tuvumā."
    },
    {
      "id": 445,
      "title": "kaķis",
      "level": 1,
      "definition": "Zīdītāju klases plēsēju kārtas dzimta (\"Felidae\"), neliels mājdzīvnieks, kas medī peles, žurkas, putnus."
    },
    {
      "id": 446,
      "title": "kalla",
      "level": 3,
      "definition": "Daudzgadīgs lakstaugs ar garkātainām tumši zaļām bultveida lapām un lieliem, baltiem ziediem."
    },
    {
      "id": 447,
      "title": "kalme",
      "level": 3,
      "definition": "Ārumu dzimtas ģints (\"Acorus\"), daudzgadīgs smaržīgs lakstaugs ar ložņājošu sakneni (ūdenstilpju malās, mitrās vietās), 2 sugas, Latvijā konstatēta 1 suga."
    },
    {
      "id": 448,
      "title": "kalns",
      "level": 1,
      "definition": "No visām pusēm izteikti norobežots augsts zemes virsas pacēlums (parasti ar relatīvo augstumu pāri par 200 metriem); nozīmīgs paugurs (piemēram, pēc augstuma)."
    },
    { "id": 449, "title": "kalps", "level": 1, "definition": "Algots laukstrādnieks." },
    {
      "id": 450,
      "title": "kalte",
      "level": 2,
      "definition": "Telpa, arī celtne ar attiecīgu iekārtu (piemēram, graudu) kaltēšanai."
    },
    {
      "id": 451,
      "title": "kalts",
      "level": 2,
      "definition": "Darbarīks trieciena pārnešanai uz cietu materiālu, piemēram, lai tam veidotu formu, ko atšķeltu no tā."
    },
    { "id": 452, "title": "kalve", "level": 2, "definition": "Kalēja darbnīca." },
    {
      "id": 453,
      "title": "kanna",
      "level": 1,
      "definition": "Cilindriskas, retāk saplacinātas formas (parasti metāla) trauks ar vāku (šķidrumu vai šķidru masu uzglabāšanai un transportēšanai)."
    },
    {
      "id": 454,
      "title": "kanoe",
      "level": 3,
      "definition": "Viegla sporta laiva, ko airē ar vienu īsu airi."
    },
    {
      "id": 455,
      "title": "kanva",
      "level": 3,
      "definition": "Rupjš audums ar kvadrātiskām rūtiņām, kuru izmanto par palīglīdzekli izšujot."
    },
    {
      "id": 456,
      "title": "karma",
      "level": 2,
      "definition": "Indiešu filozofijā un reliģijā - cilvēka vai citas dzīvās būtnes dzīves un darbības seku kopums, kas uzlabo vai pasliktina tās likteni; atkarībā no tā, kā cilvēks pildījis dzīves priekšrakstus, nākamajā dzīvē viņa dvēsele pārdzimst cildenākā vai zemākā veidolā."
    },
    {
      "id": 457,
      "title": "karpa",
      "level": 3,
      "definition": "Zivju klases karpveidīgo kārtas dzimta (\"Cyprinidae\"), pie kuras pieder ātraudzīgas, siltumu mīlošas saldūdens zivis."
    },
    {
      "id": 458,
      "title": "karte",
      "level": 1,
      "definition": "Zemes virsmas vai tās daļas pamazināts, vispārināts, matemātiski noteikts grafisks attēlojums plaknē (parasti uz papīra vai digitāli)."
    },
    {
      "id": 459,
      "title": "kasta",
      "level": 3,
      "definition": "Noslēgta sabiedrības grupa (piemēram, Indijā), ko vieno noteikta nodarbošanās un priekšstats par kopēju izcelšanos."
    },
    {
      "id": 460,
      "title": "kaste",
      "level": 1,
      "definition": "Stūrainas formas priekšmets kā ievietošanai (ar sānu malām, dibenu, parasti arī vāku)."
    },
    {
      "id": 461,
      "title": "katls",
      "level": 1,
      "definition": "Cilindrveida vai puslodes veida (metāla) trauks (parasti kā vārīšanai)."
    },
    {
      "id": 462,
      "title": "kauja",
      "level": 1,
      "definition": "Organizēta karaspēka vienību, daļu, apakšvienību bruņota sadursme ar pretinieku, lai iznīcinātu tā dzīvo spēku un kara tehniku."
    },
    {
      "id": 463,
      "title": "kauls",
      "level": 1,
      "definition": "Skeleta atsevišķa sastāvdaļa (cilvēkam un citiem mugurkaulniekiem)."
    },
    {
      "id": 464,
      "title": "kauns",
      "level": 1,
      "definition": "Morālas jūtas, kas saistītas ar nepatīkamu pārdzīvojumu, piemēram, par kādu nodarījumu, rīcību."
    },
    {
      "id": 465,
      "title": "kauss",
      "level": 1,
      "definition": "Paliels, dzeršanai paredzēts trauks ar osu; šāds trauks bez osas."
    },
    {
      "id": 466,
      "title": "kāķis",
      "level": 3,
      "definition": "Kauna stabs - soda vieta pie baznīcas durvīm vai baznīcas tuvumā Eiropā viduslaikos un jauno laiku sākumā."
    },
    {
      "id": 467,
      "title": "kālis",
      "level": 2,
      "definition": "Kāpostu ģints sugas \"Brassica napus\" varietāte (\"Brassica napus var. rapifera\"), uzturā lietojams divgadīgs dārzenis ar dzeltenu, paresninātu sakni."
    },
    {
      "id": 468,
      "title": "kāmis",
      "level": 1,
      "definition": "Zīdītāju klases grauzēju kārtas dzimta (\"Cricetidae\"), neliels, drukns dzīvnieks ar ādainām ausīm, lielām acīm, īsu asti (stepju apgabalos), 127 ģ., ~625 sugas, Latvijā konstatētas 4 ģ., 6 s."
    },
    {
      "id": 469,
      "title": "kārba",
      "level": 1,
      "definition": "Kaste (parasti kartona vai metāla, ar vāku)."
    },
    {
      "id": 470,
      "title": "kārpa",
      "level": 1,
      "definition": "Infekciozas slimības izraisīts ciets, norobežots, pārragots labdabīgs veidojums uz ādas."
    },
    {
      "id": 471,
      "title": "kārta",
      "level": 1,
      "definition": "Viendabīgs (piemēram, zemes, iežu, vielas, organiska veidojuma) slānis, kas atrodas starp (arī virs) citiem slāņiem vai pārklāj kā virsmu."
    },
    { "id": 472, "title": "kārts", "level": 1, "definition": "Pagarš, tievs apaļkoks." },
    {
      "id": 473,
      "title": "kāsis",
      "level": 1,
      "definition": "Priekšmets, darbarīks - stienis ar āķveida galu kā uzkabināšanai."
    },
    {
      "id": 474,
      "title": "kāzas",
      "level": 1,
      "definition": "Ar laulībām saistīta ceremonija un svinības."
    },
    {
      "id": 475,
      "title": "kēkss",
      "level": 1,
      "definition": "Veidnē cepts konditorejas izstrādājums no mīklas, kas gatavota no miltiem, sviesta, olām, cukura, rozīnēm."
    },
    {
      "id": 476,
      "title": "klade",
      "level": 1,
      "definition": "Bieza, parasti cietos vākos iesieta, burtnīca."
    },
    {
      "id": 477,
      "title": "klans",
      "level": 3,
      "definition": "Ģints (retāk cilts) kopiena (piemēram, ķeltu tautām); radinieku ģints vai grupa."
    },
    { "id": 478, "title": "klape", "level": 3, "definition": "Aizkars; durtiņas; vāks." },
    {
      "id": 479,
      "title": "klase",
      "level": 1,
      "definition": "Mācību posma daļa (parasti vispārizglītojošā skolā), kurā skolēni viena mācību gada laikā apgūst noteiktu programmu; skolēnu grupa, kas apgūst šo programmu."
    },
    {
      "id": 480,
      "title": "klājs",
      "level": 3,
      "definition": "Horizontāls vienlaidu segums (kuģa vai jahtas korpusā)."
    },
    {
      "id": 481,
      "title": "klērs",
      "level": 3,
      "definition": "Kristīgo garīdznieku un baznīcas kalpotāju kopums kristietībā (kristiešu garīdzniekus sākumā izraudzījās ar lozēšanu)."
    },
    {
      "id": 482,
      "title": "klēts",
      "level": 2,
      "definition": "Lauksaimniecības celtne graudu uzglabāšanai."
    },
    {
      "id": 483,
      "title": "klija",
      "level": 3,
      "definition": "Vanagu dzimtas ģints (\"Milvus\"), vidēji liels putns ar platiem spārniem un garu, galā šķeltu asti, 2 sugas, abas sastopamas arī Latvijā un ir aizsargājamas."
    },
    {
      "id": 484,
      "title": "kliķe",
      "level": 2,
      "definition": "Cilvēku grupa, kas apvienojusies savtīgos, arī zemiskos nolūkos."
    },
    {
      "id": 485,
      "title": "klips",
      "level": 1,
      "definition": "Īss kinofilmas fragments (sākotnēji); īsa muzikāla vai reklāmas filma, gk. demonstrēšanai televīzijā."
    },
    {
      "id": 486,
      "title": "klons",
      "level": 1,
      "definition": "Blīva, gluda virsma, ko parasti veido sablietēts māla vai zemes slānis; grīda, kas veidota, piemēram, no sablietēta māla slāņa, cementa, ķieģeļiem."
    },
    {
      "id": 487,
      "title": "klubs",
      "level": 1,
      "definition": "Biedrība, kurā apvienojušies noteiktu aprindu, vienas profesijas, tautības, kopīgu interešu cilvēki, lai biedrības telpās pavadītu brīvo laiku, organizētu dažādus pasākumus, nodarbotos ar sportu u. c."
    },
    {
      "id": 488,
      "title": "klupe",
      "level": 3,
      "definition": "Vītņgriezis - rokas instruments vītņu iegriešanai; to veido rāmis, kurā iestiprināts griezējinstruments - vītņgriezis."
    },
    {
      "id": 489,
      "title": "klūga",
      "level": 3,
      "definition": "Lokans, elastīgs (parasti sutināts kārkla vai vīksnas) zars, ko izmanto pinumiem; arī kaut kā sasiešanai, saistīšanai."
    },
    {
      "id": 490,
      "title": "kļava",
      "level": 1,
      "definition": "Sapindu rindas dzimta (\"Aceraceae\"), kļavaugu dzimta, 2 ģ."
    },
    {
      "id": 491,
      "title": "kļūda",
      "level": 1,
      "definition": "Neatbilstība kādām prasībām, normām, nosacījumiem (piemēram, darbībā, tās rezultātā); neatbilstība īstenībai (piemēram, darbībā, tās rezultātā)."
    },
    { "id": 492, "title": "kļūme", "level": 1, "definition": "Neveiksme; arī kļūda ." },
    { "id": 493, "title": "knīpa", "level": 2, "definition": "Maza meitene, mazs zēns." },
    {
      "id": 494,
      "title": "kņada",
      "level": 1,
      "definition": "Troksnis, kas rodas no vairāku vai daudzu cilvēku, arī dzīvnieku balsīm."
    },
    {
      "id": 495,
      "title": "kņaze",
      "level": 3,
      "definition": "Kņaza meita, kas nav precējusies."
    },
    {
      "id": 496,
      "title": "kņazs",
      "level": 3,
      "definition": "Karaspēka vadonis un kādas teritorijas valdnieks (slāvu un dažās citās zemēs no 9. līdz 16. gadsimtam); šī valdnieka tituls."
    },
    { "id": 497, "title": "kņope", "level": 3, "definition": "Āķis apģērba aizdarei." },
    {
      "id": 498,
      "title": "koala",
      "level": 2,
      "definition": "Lāčsomainis, jaunam lācēnam līdzīgs somains dzīvnieks; izplatīts Austrālijā, pārtiek tikai no eikaliptu lapām un jaunajiem dzinumiem."
    },
    {
      "id": 499,
      "title": "kobra",
      "level": 1,
      "definition": "Zvīņrāpuļu kārtas čūsku apakškārtas dzimta (\"Elapidae\"), vidēji lielas un lielas indīgas čūskas (garums - līdz 5,5 m) ar 1-2 pāriem indeszobu, izplatītas tropos un subtropos (izņemot Eiropu), 41 ģ., ~180 s."
    },
    {
      "id": 500,
      "title": "kodne",
      "level": 3,
      "definition": "Ķimikālija, ar ko kodina ."
    },
    {
      "id": 501,
      "title": "kokle",
      "level": 1,
      "definition": "Latviešu tautas strinkšķināmais stīgu instruments ar 5-9 stīgām."
    },
    {
      "id": 502,
      "title": "kokss",
      "level": 3,
      "definition": "Ar oglekli bagāts cietais kurināmais, ko iegūst, karsējot kurināmo, piemēram, akmeņogles, kūdru, naftas paliekas, bez gaisa piekļūšanas."
    },
    {
      "id": 503,
      "title": "kolba",
      "level": 3,
      "definition": "Stikla trauks ar apaļu vai plakanu dibenu (ķīmijas laboratorijās)."
    },
    {
      "id": 504,
      "title": "kolts",
      "level": 2,
      "definition": "Amerikāņu parauga revolveris."
    },
    {
      "id": 505,
      "title": "konts",
      "level": 1,
      "definition": "Grāmatvedības forma, paņēmienu kopums (piemēram, uzņēmuma, iestādes) finansiālo operāciju sistemātiskai uzskaitei un kontrolei."
    },
    {
      "id": 506,
      "title": "kopne",
      "level": 3,
      "definition": "Nesošais (pārsedzošu būvkonstrukciju) elements."
    },
    {
      "id": 507,
      "title": "kopra",
      "level": 3,
      "definition": "Sadalīti un izžāvēti kokosriekstu kodoli; to izmanto eļļas iegūšanai un lopbarībai."
    },
    { "id": 508, "title": "korda", "level": 3, "definition": "Stīga, metāla stieple." },
    {
      "id": 509,
      "title": "kords",
      "level": 3,
      "definition": "Grods, ļoti izturīgs diegs."
    },
    {
      "id": 510,
      "title": "koris",
      "level": 1,
      "definition": "Liels, tembrāli un skaitliski līdzsvarots dziedātāju ansamblis."
    },
    { "id": 511, "title": "korts", "level": 3, "definition": "Laukums tenisa spēlēšanai." },
    {
      "id": 512,
      "title": "krahs",
      "level": 3,
      "definition": "Pilnīga neveiksme, bojāeja."
    },
    {
      "id": 513,
      "title": "krams",
      "level": 3,
      "definition": "Ciets, dažādas krāsas oksīdu un hidroksīdu grupas minerāls (kvarca paveids); šī minerāla gabals."
    },
    {
      "id": 514,
      "title": "krava",
      "level": 1,
      "definition": "Ar transportlīdzekli pārvadājami priekšmeti, masa; šādu priekšmetu, masas kopums, daudzums transportlīdzeklī."
    },
    {
      "id": 515,
      "title": "krāce",
      "level": 1,
      "definition": "Posms (upē, strautā u. tml), kurā ūdens strauji plūst lejup pa nelīdzenu klinšainu vai akmeņainu gultni."
    },
    { "id": 516, "title": "krāga", "level": 1, "definition": "Apkakle." },
    { "id": 517, "title": "krāms", "level": 1, "definition": "Krāmi." },
    {
      "id": 518,
      "title": "krāns",
      "level": 1,
      "definition": "Hidrauliska ierīce no ūdensvada, kāda trauka u. tml. plūstoša šķidruma daudzuma regulēšanai."
    },
    {
      "id": 519,
      "title": "krāsa",
      "level": 1,
      "definition": "Redzamās gaismas noteikta garuma viļņu izraisīta redzes sajūta, uztvere."
    },
    { "id": 520, "title": "kredo", "level": 3, "definition": "Pārliecība, uzskats." },
    {
      "id": 521,
      "title": "kreps",
      "level": 3,
      "definition": "Sīkgrubuļains (zīda, vilnas, kokvilnas) audums, kas austs no grodi savērptiem diegiem."
    },
    {
      "id": 522,
      "title": "krese",
      "level": 3,
      "definition": "Divdīgļlapju klases dzimta (\"Tropaeolaceae\"), 2 ģintis, ~80 sugu."
    },
    {
      "id": 523,
      "title": "kreve",
      "level": 3,
      "definition": "Atmirušo audu slānis, kas veidojas kokaugu stumbra virspusē no peridermas un mizas šūnām."
    },
    {
      "id": 524,
      "title": "krēms",
      "level": 1,
      "definition": "Saputota saldā krējuma vai sviesta un dažādu piedevu (piemēram, olu, augļu, cukura, želatīna, garšvielu) stinga masa (saldēdienam, ēdienu rotāšanai, pildīšanai)."
    },
    {
      "id": 525,
      "title": "krika",
      "level": 3,
      "definition": "Asas sāpes (mugurā krustu apvidū vai locekļos)."
    },
    {
      "id": 526,
      "title": "krīts",
      "level": 1,
      "definition": "Organiskas izcelsmes, parasti balts, nogulumiezis."
    },
    {
      "id": 527,
      "title": "krīvs",
      "level": 3,
      "definition": "Seno prūšu, lietuviešu, latviešu priesteris, zintnieks."
    },
    {
      "id": 528,
      "title": "krīze",
      "level": 1,
      "definition": "Bīstams, sarežģīts, smags stāvoklis; sarežģīts pārejas stāvoklis."
    },
    {
      "id": 529,
      "title": "krogs",
      "level": 1,
      "definition": "Celtne ceļotāju un zirgu atpūtai; alkoholisko dzērienu, arī dažu citu preču pārdotava un dzertuve, izpriecu vieta."
    },
    {
      "id": 530,
      "title": "kroka",
      "level": 2,
      "definition": "Nelīdzens viļņveida (virsmas) veidojums."
    },
    {
      "id": 531,
      "title": "krona",
      "level": 2,
      "definition": "Naudas vienība Čehijā, Dānijā, Islandē, Norvēģijā un Zviedrijā."
    },
    {
      "id": 532,
      "title": "kross",
      "level": 2,
      "definition": "Sporta disciplīna - skriešana, braukšana vai jāšana apvidū, kurā ir dabiski šķēršļi; sacensības šajā sporta disciplīnā."
    },
    {
      "id": 533,
      "title": "krusa",
      "level": 1,
      "definition": "Nokrišņi - blīvas ledus daļiņas, kas siltajā periodā izveidojas spēcīgos lietus gubu mākoņos."
    },
    {
      "id": 534,
      "title": "krūka",
      "level": 1,
      "definition": "Keramikas (parasti māla) krūze vai krūzei līdzīgs trauks dzērienu ieliešanai."
    },
    {
      "id": 535,
      "title": "krūms",
      "level": 1,
      "definition": "Daudzgadīgs augs ar vairākiem ilggadīgiem koksnainiem virszemes stumbriem (bez viena galvenā stumbra)."
    },
    {
      "id": 536,
      "title": "krūts",
      "level": 1,
      "definition": "Ķermeņa priekšējā daļa no kakla līdz viduklim (cilvēkiem vai mugurkaulniekiem)."
    },
    {
      "id": 537,
      "title": "krūze",
      "level": 1,
      "definition": "Cilindriskas, arī saplacinātas formas (parasti keramikas) trauks ar osu (parasti šķidrumu ieliešanai)."
    },
    {
      "id": 538,
      "title": "kubls",
      "level": 2,
      "definition": "Liels konusveida, arī cilindrveida koka trauks, parasti ar vāku."
    },
    {
      "id": 539,
      "title": "kuģis",
      "level": 1,
      "definition": "Samērā liels ūdens transportlīdzeklis noteiktu (piemēram, saimniecisku, zinātniski pētniecisku, militāru) uzdevumu veikšanai."
    },
    {
      "id": 540,
      "title": "kulba",
      "level": 1,
      "definition": "Rati, ragavas ar segtu virsu."
    },
    {
      "id": 541,
      "title": "kults",
      "level": 2,
      "definition": "Reliģiska (kā) pielūgšana, uzskatīšana par svētu, par dievību; arī reliģija."
    },
    {
      "id": 542,
      "title": "kumpa",
      "level": 3,
      "definition": "Kūkums (mugurā); izvirzījums uz āru, izliekums (ķermeņa daļā)."
    },
    {
      "id": 543,
      "title": "kunde",
      "level": 2,
      "definition": "Pastāvīgs pircējs vai pasūtītājs; klients."
    },
    {
      "id": 544,
      "title": "kungs",
      "level": 1,
      "definition": "Uzrunas forma (runājot ar vīrieti); cieņas izteikšanas forma."
    },
    {
      "id": 545,
      "title": "kurpe",
      "level": 1,
      "definition": "Būvniecībā dzelzs čaula, kas uzmaukta koka vai dzelzs konstrukcijas apakšējai, parasti uz mūra atbalstāmai daļai, lai aizsargātu to no bojājumiem vai sadalītu tās spiedienu vienmērīgi uz plašāka laukuma."
    },
    {
      "id": 546,
      "title": "kurss",
      "level": 1,
      "definition": "Kustības virziens (transportlīdzeklim); leņķis starp transportlīdzekļa garenisko asi un meridiānu."
    },
    {
      "id": 547,
      "title": "kurts",
      "level": 3,
      "definition": "Medību suns, kam raksturīga maza galva, smails purns, platas krūtis un tievas, garas kājas; attiecīgā suņu šķirne."
    },
    {
      "id": 548,
      "title": "kūdra",
      "level": 1,
      "definition": "Organiskas izcelsmes iezis, kas veidojas pārmērīgi mitrās vietās no augu atliekām, kuras ir vairāk vai mazāk sadalījušās; atsevišķs šī ieža gabals."
    },
    {
      "id": 549,
      "title": "kūlis",
      "level": 3,
      "definition": "Sasiets, arī savelts (nopļautas labības, noplūktu linu) stiebru klēpis."
    },
    {
      "id": 550,
      "title": "kvass",
      "level": 1,
      "definition": "Saldskābs bezalkoholisks dzēriens, ko gatavo parasti no rupjmaizes vai rudzu miltiem un iesala."
    },
    {
      "id": 551,
      "title": "kvēle",
      "level": 2,
      "definition": "Stiprs karstums; augsta sakaršanas pakāpe (parasti līdz gaismas izstarošanai)."
    },
    { "id": 552, "title": "kvēps", "level": 2, "definition": "Kvēpi." },
    {
      "id": 553,
      "title": "kvīts",
      "level": 2,
      "definition": "Dokuments, kas apliecina (kā, piemēram, maksājuma) saņemšanu."
    },
    {
      "id": 554,
      "title": "kvota",
      "level": 3,
      "definition": "Kādas parādības pieļaujamā vai atļautā norma (piem., savos ūdeņos citai valstij atļautais nozvejas apjoms; skaits, kas gada laikā drīkst iebraukt valstī u. tml.)."
    },
    {
      "id": 555,
      "title": "ķegļi",
      "level": 3,
      "definition": "Spēle, kuras mērķis ir, ripinot bumbiņu, apgāzt stateniski novietotas figūras."
    },
    {
      "id": 556,
      "title": "ķeģis",
      "level": 3,
      "definition": "Zvirbuļveidīgo kārtas žubīšu dzimtas ģints (\"Acanthis\"), nelieli dziedātājputni, 6 s., Latvijā konstatētas 4 s."
    },
    {
      "id": 557,
      "title": "ķelle",
      "level": 3,
      "definition": "Mūrnieka darbarīks - neliela trīsstūrveida plāksne ar izliektu kātu un rokturi."
    },
    {
      "id": 558,
      "title": "ķemme",
      "level": 1,
      "definition": "Iegarena plāksne (matu sakārtošanai) ar, parasti vienādiem, iegriezumiem vienā vai, retāk, abās malās."
    },
    {
      "id": 559,
      "title": "ķerra",
      "level": 1,
      "definition": "Transportlīdzeklis (nelielu kravu pārvadāšanai) ar vienu riteni un diviem gariem rokturiem."
    },
    {
      "id": 560,
      "title": "ķetna",
      "level": 3,
      "definition": "Dzīvnieka pēda ar spēcīgiem nagiem."
    },
    { "id": 561, "title": "ķēkša", "level": 3, "definition": "Virēja, virtuvene." },
    { "id": 562, "title": "ķēķis", "level": 3, "definition": "Virtuve." },
    { "id": 563, "title": "ķērna", "level": 3, "definition": "Smulis, trašķis." },
    {
      "id": 564,
      "title": "ķērne",
      "level": 3,
      "definition": "Augšdaļā sašaurināts koka trauks ar vāku un noteces caurumiņu apakšmalā."
    },
    {
      "id": 565,
      "title": "ķērsa",
      "level": 3,
      "definition": "Krustziežu dzimtas ģints (\"Cardamine\"), viengadīgs, divgadīgs vai daudzgadīgs pļavu, mežu, purvu lakstaugs, 130 sugas, Latvijā konstatētas 6 sugas."
    },
    {
      "id": 566,
      "title": "ķidas",
      "level": 3,
      "definition": "Iekšējie orgāni un sīkās ķermeņa daļas (nelieliem dzīvniekiem, piemēram, zivīm, putniem)."
    },
    {
      "id": 567,
      "title": "ķilda",
      "level": 2,
      "definition": "Cilvēku sadursme (pretēju uzskatu, interešu, tieksmju dēj), kas izpaužas satrauktā, asā sarunā; strīds."
    },
    {
      "id": 568,
      "title": "ķipis",
      "level": 2,
      "definition": "Apaļš koka trauks (aptuveni spaiņa lielumā) ar mazliet paplašinātu augšdaļu un rokturi, ko veido pagarināts sānu dēlis."
    },
    {
      "id": 569,
      "title": "ķirpa",
      "level": 3,
      "definition": "Garena (siena, labības u. tml.) guba; stirpa."
    },
    {
      "id": 570,
      "title": "ķīķis",
      "level": 3,
      "definition": "Piekūnveidīgo kārtas vanagu dzimtas suga (\"Pernis apivorus\"), pelēcīgi brūns gājputns, masa - 0,7-0,8 kg., ēd gk. lapseņu kāpurus un kūniņas, arī abiniekus un rāpuļus, Latvijā aizsargājams; lapseņu klijāns."
    },
    {
      "id": 571,
      "title": "ķīlis",
      "level": 2,
      "definition": "Plakans, garens, vienā galā sašaurināts darbarīks, piemēram, koka gabalu, akmeņu pāršķelšanai."
    },
    {
      "id": 572,
      "title": "ķīris",
      "level": 3,
      "definition": "Putnu klases tārtiņveidīgo kārtas kaiju apakšdzimtas ģints (\"Larus\"), putns ar baltu apspalvojumu un melnu vai tumšbrūnu galvu."
    },
    {
      "id": 573,
      "title": "ķīsis",
      "level": 3,
      "definition": "Asaru dzimtas suga (\"Gymnocephalus cernuus syn. Acerina cernua\"), neliela saldūdens zivs ar zaļgani brūnu, melni plankumainu ķermeni."
    },
    { "id": 574, "title": "ķocis", "level": 3, "definition": "Grozs (parasti pīts)." },
    {
      "id": 575,
      "title": "ķūlis",
      "level": 3,
      "definition": "Gurns (parasti nelieliem dzīvniekiem); stilba kauls."
    },
    {
      "id": 576,
      "title": "laide",
      "level": 3,
      "definition": "Koka daļa, spals (dažiem šaujamieročiem)."
    },
    {
      "id": 577,
      "title": "laiks",
      "level": 1,
      "definition": "Viens no galvenajiem fizikas jēdzieniem (lielumiem), ar kuru apraksta notikumu (procesu) ilgstību un secību."
    },
    {
      "id": 578,
      "title": "laime",
      "level": 1,
      "definition": "Psihisks (emocionāls) stāvoklis, ko izraisa saskaņa starp cilvēka vēlēšanos, mērķiem, darbību un īstenību, darbības rezultātu."
    },
    {
      "id": 579,
      "title": "laims",
      "level": 1,
      "definition": "Citrusu ģints suga (\"Citrus aurantifolia\"), augļu koks; šī koka auglis."
    },
    {
      "id": 580,
      "title": "laipa",
      "level": 1,
      "definition": "Pāriešanai paredzēts dēlis, baļķis u. tml., no dēļiem, baļķiem u. tml. izveidota šaura pāreja (piemēram, pāri šaurai upei, grāvim, staignai vietai)."
    },
    {
      "id": 581,
      "title": "laiva",
      "level": 1,
      "definition": "Neliels ūdens transportlīdzeklis ar sānu malām un dibenu, parasti atklātu virsmu."
    },
    {
      "id": 582,
      "title": "lakta",
      "level": 2,
      "definition": "Masīvs tērauda veidojums, uz kā atbalsta apstrādājamo materiālu, kaļot ar roku darbarīkiem."
    },
    {
      "id": 583,
      "title": "lamas",
      "level": 2,
      "definition": "Rupji, apvainojoši, aizskaroši vārdi, izteicieni."
    },
    {
      "id": 584,
      "title": "lampa",
      "level": 1,
      "definition": "Apgaismošanas ierīce, kas sastāv no armatūras un elektriskās spuldzes, kuru parasti aptver kupols; apgaismošanas ierīce, kas sastāv, piemēram, no īpaša ar degvielu piepildāma trauka un tajā ievietota degļa un dakts, kurus parasti aptver cilindrs."
    },
    {
      "id": 585,
      "title": "lapsa",
      "level": 1,
      "definition": "Plēsēju kārtas suņu dzimtas suga (\"Vulpes vulpes\"), vidēja lieluma dzīvnieks ar smailu purnu un garu, kuplu asti."
    },
    {
      "id": 586,
      "title": "lasis",
      "level": 1,
      "definition": "Zivju klases lašveidīgo kārtas dzimta (\"Salmonidae\"), pie kuras pieder, piemēram, laši, foreles, taimiņi."
    },
    {
      "id": 587,
      "title": "lauks",
      "level": 1,
      "definition": "Zemes platība, kas ir aizņemta ar vienu un to pašu vai dažu augu (parasti kultūraugu) kopu, kuriem ir līdzīgi augšanas apstākļi."
    },
    {
      "id": 588,
      "title": "lauma",
      "level": 1,
      "definition": "Pārdabiska sievišķa būtne, kas spēj ietekmēt cilvēka dzīvi, darbību; spīgana, burve."
    },
    {
      "id": 589,
      "title": "laurs",
      "level": 2,
      "definition": "Divdīgļlapju klases magnoliju apakšklases rinda (\"Laurales\"), 10 dz., raksturīgi primitīvās ziedkopās sakārtoti vai vientuļi ziedi, kuros spirāliski sakārtots nenoteikts locekļu skaits, lapās un mizā daudz ēterisko eļļu."
    },
    {
      "id": 590,
      "title": "lauta",
      "level": 3,
      "definition": "Sens strinkšķināmais stīgu instruments."
    },
    {
      "id": 591,
      "title": "lauva",
      "level": 1,
      "definition": "Zīdītāju klases plēsēju kārtas kaķu dzimtas suga (\"Leo leo\"), liels, ļoti spēcīgs dzīvnieks ar dzeltenīgu apmatojumu."
    },
    {
      "id": 592,
      "title": "lazda",
      "level": 1,
      "definition": "Bērzu dzimtas ģints (\"Corylus\"), krūms ar ieapaļām lapām un cietā čaulā ietvertiem augļiem - riekstiem."
    },
    {
      "id": 593,
      "title": "lācis",
      "level": 1,
      "definition": "Plēsēju kārtas dzimta (\"Ursidae\"), kurā ietilpst lieli dzīvnieki ar masīvu ķermeni, biezu apmatojumu, īsu kaklu, strupu asti, 6 ģintis, 7 sugas, Latvijā sastopams tikai brūnais lācis, 21. gs. sākumā ~10 īpatņi."
    },
    { "id": 594, "title": "lāsma", "level": 1, "definition": "Lāma ." },
    {
      "id": 595,
      "title": "lāsts",
      "level": 2,
      "definition": "Draudīgs ļauna vēlējums, pareģojums; izteikums, arī, parasti reliģisks, rituāls, ar ko izslēdz no sabiedrības, tās grupas, reliģiskas organizācijas u. tml."
    },
    {
      "id": 596,
      "title": "ledus",
      "level": 1,
      "definition": "Sasalis ūdens, tā gabals vai gabali."
    },
    {
      "id": 597,
      "title": "lelle",
      "level": 1,
      "definition": "Bērnu rotaļlieta cilvēka izskatā."
    },
    {
      "id": 598,
      "title": "lemma",
      "level": 3,
      "definition": "Palīgteorēma citas teorēmas pierādīšanai."
    },
    {
      "id": 599,
      "title": "lence",
      "level": 3,
      "definition": "Pār plecu pārliekama lentveida (apģērba) daļa (svārku, bikšu u. tml. noturēšanai)."
    },
    {
      "id": 600,
      "title": "lenčs",
      "level": 3,
      "definition": "Otrās brokastis - ap 11:00-12:00."
    },
    { "id": 601, "title": "lenta", "level": 1, "definition": "Lente." },
    {
      "id": 602,
      "title": "lente",
      "level": 1,
      "definition": "Samērā šaura sloksne (parasti no auduma) kā apdarei, rotāšanai, nostiprināšanai."
    },
    {
      "id": 603,
      "title": "lepra",
      "level": 3,
      "definition": "Hroniska vispārēja infekcijas slimība, kas bojā galvenokārt ādu un nervu sistēmu; spitālība."
    },
    {
      "id": 604,
      "title": "lēkme",
      "level": 2,
      "definition": "Strauja, krasa (slimības vai tās izpausmju) saasināšanās, pastiprināšanās; samērā īslaicīga (slimības) krasa izpausme."
    },
    {
      "id": 605,
      "title": "lēkši",
      "level": 3,
      "definition": "Ātrs (parasti zirga) skrējiens straujos lēcienos; aulekši."
    },
    {
      "id": 606,
      "title": "lēkts",
      "level": 2,
      "definition": "Pakāpeniska (parasti saules) parādīšanās virs horizonta; gaisma, kas rodas, parādoties (parasti saulei) virs horizonta."
    },
    {
      "id": 607,
      "title": "lēlis",
      "level": 3,
      "definition": "Putnu klases lēļveidīgo kārtas dzimta (\"Caprimulgidae\"), 19 ģ, 75 s."
    },
    {
      "id": 608,
      "title": "lēnis",
      "level": 3,
      "definition": "Zemes īpašums (parasti kopā ar zemniekiem) vai citāda veida materiāls labums, ko vasalis saņēma valdījumā no sava senjora; feods."
    },
    {
      "id": 609,
      "title": "lēpis",
      "level": 3,
      "definition": "Vakarlēpis (\"Caprimulgus europaeus\")."
    },
    {
      "id": 610,
      "title": "liāna",
      "level": 3,
      "definition": "Daudzgadīgs lakstaugs vai kokaugs ar garu, vijīgu vai kāpelējošu stumbru."
    },
    {
      "id": 611,
      "title": "liece",
      "level": 3,
      "definition": "Ķermeņa deformācija, kas rodas, mehāniskiem spēkiem vai temperatūrai iedarbojoties perpendikulāri ķermeņa asij."
    },
    {
      "id": 612,
      "title": "liepa",
      "level": 1,
      "definition": "Divdīgļlapju klases malvu rindas dzimta (\"Tiliaceae\"), vasarzaļi, koki, krūmi, puskrūmi un pat lakstaugi ar nektārainiem ziediem, kas sakārtoti ziedkopās ar garām augšlapām, 46 ģ., 450 s., Latvijā konstatēta 1 ģ."
    },
    {
      "id": 613,
      "title": "liesa",
      "level": 2,
      "definition": "Asinsrades un limfātiskās sistēmas orgāns."
    },
    {
      "id": 614,
      "title": "lieta",
      "level": 1,
      "definition": "Priekšmets (ar noteiktu lietošanas vērtību, funkciju)."
    },
    {
      "id": 615,
      "title": "lifts",
      "level": 1,
      "definition": "Stacionārs transportlīdzeklis, parasti kabīnes vai platformas veidā, (kā) pārvietošanai vertikāli, samērā lielā augstumā."
    },
    {
      "id": 616,
      "title": "likme",
      "level": 2,
      "definition": "Ar likumu noteikta algas norma par kāda darba izpildi; ar likumu noteikta maksas norma par kā lietošanu, izmantošanu."
    },
    {
      "id": 617,
      "title": "limbs",
      "level": 3,
      "definition": "Metāla gredzens ar skalu pagrieziena leņķa noteikšanai vai darbināmā elementa pārvietojumu noteikšanai."
    },
    {
      "id": 618,
      "title": "limfa",
      "level": 3,
      "definition": "Bezkrāsains šķidrums, kas cirkulē mugurkaulnieku organismā pa limfātisko sistēmu, aizpilda starpšūnu telpu un pārnes šūnu vielmaiņas produktus."
    },
    {
      "id": 619,
      "title": "linga",
      "level": 3,
      "definition": "Metamais ierocis (parasti virves, ādas cilpa) nelielu priekšmetu (parasti akmeņu) mešanai; šāda veida rotaļu rīks."
    },
    {
      "id": 620,
      "title": "liste",
      "level": 2,
      "definition": "Blanka, anketa, arī saraksts."
    },
    {
      "id": 621,
      "title": "litrs",
      "level": 2,
      "definition": "Tilpuma mērvienība (parasti šķidruma mērīšanai) - 0,001 kubikmetrs = 1 kubikdecimetrs; 1 l ir vienāds ar 1 kg tīra ūdens tilpumu, ja tā temperatūra ir 4 Celsija grādi un atmosfēras spiediens ir 760 mm Hg."
    },
    {
      "id": 622,
      "title": "līcis",
      "level": 2,
      "definition": "Sauszemē ievirzījusies (okeāna, jūras, ezera) daļa."
    },
    { "id": 623, "title": "līkne", "level": 2, "definition": "Lokveidā liekta līnija." },
    {
      "id": 624,
      "title": "līķis",
      "level": 2,
      "definition": "Miruša cilvēka vai dzīvnieka ķermenis."
    },
    {
      "id": 625,
      "title": "līnis",
      "level": 2,
      "definition": "Karpveidīgo zivju kārtas karpu dzimtas suga (\"Tinca tinca\", senāk \"Tinca vulgaris\"), dzīvo ezeros vai lēni tekošās upēs, zivs ar tumši zaļu muguru un tumši violetām spurām."
    },
    {
      "id": 626,
      "title": "līste",
      "level": 2,
      "definition": "Garš, latai līdzīgs izstrādājums, kam ir taisnstūra vai profilēts šķērsgriezums un ko izmanto, piemēram, apmaļu, ierāmējumu veidošanai, salaidumu vietu nosegšanai."
    },
    {
      "id": 627,
      "title": "locis",
      "level": 3,
      "definition": "Speciālists, kas vada kuģi kuģošanai sarežģītās vietās (piemēram, iebraucot ostās, kanālos)."
    },
    {
      "id": 628,
      "title": "lords",
      "level": 2,
      "definition": "Augsts feodālis (viduslaikos Anglijā)."
    },
    {
      "id": 629,
      "title": "ložņa",
      "level": 2,
      "definition": "Cilvēks, kas ar dažādiem (parasti slepeniem) paņēmieniem izzina, izdibina (piemēram, noslēpumus), iegūst (piemēram, ziņas, datus)."
    },
    {
      "id": 630,
      "title": "lubas",
      "level": 3,
      "definition": "Koka mizas, kas plēstas, piemēram, no augošas liepas, egles; skali, skaidas, kas plēstas no bezzaraina koka."
    },
    {
      "id": 631,
      "title": "lucis",
      "level": 3,
      "definition": "Lucītis (3) - neliela asarveidīgo kārtas jūras zivs ar garenu, gļotām klātu, slaidi konisku ķermeni, strupu galvu un platu muti, kurā ir koniski zobi vairākās rindās."
    },
    {
      "id": 632,
      "title": "lukss",
      "level": 3,
      "definition": "Apgaismojuma mērvienība starptautiskajā mērvienību sistēmā; lx."
    },
    {
      "id": 633,
      "title": "lukta",
      "level": 3,
      "definition": "Garš, šaurs balkons virs sānu jomiem vai priekšhalles (parasti baznīcās)."
    },
    {
      "id": 634,
      "title": "luste",
      "level": 2,
      "definition": "Prieks, jautrība, arī izprieca."
    },
    {
      "id": 635,
      "title": "lūsis",
      "level": 1,
      "definition": "Plēsēju kārtas kaķu dzimtas suga (\"Lynx lynx\", senāk \"Felis lynx\"), vidēji liels dzīvnieks ar slaidu ķermeni, garām kājām, īsu asti un ausīm, kurām ir pagari apmatojuma pušķi; Eirāzijas lūsis."
    },
    {
      "id": 636,
      "title": "lūžņa",
      "level": 3,
      "definition": "Bojātu, lietošanai nederīgu, arī nekārtīgi novietotu priekšmetu kopums; vieta, kur atrodas šādi priekšmeti."
    },
    {
      "id": 637,
      "title": "ļekas",
      "level": 2,
      "definition": "Parasti savienojumos \"laist ļekas (vaļā)\", \"laisties ļekās\": ātri bēgt, ātri doties prom."
    },
    {
      "id": 638,
      "title": "magma",
      "level": 2,
      "definition": "Izkususi, ugunīgi šķidra, parasti silikātu, masa, kas rodas Zemes mantijā vai garozā un, lavas veidā nonākot Zemes virspusē, veido izvirduma iežus."
    },
    { "id": 639, "title": "maijs", "level": 1, "definition": "Gada piektais mēnesis." },
    {
      "id": 640,
      "title": "maiņa",
      "level": 2,
      "definition": "Laikposms, kam beidzoties, viena cilvēku grupa mainās ar citu grupu (piemēram, darbā, mācību iestādē, nometnē)."
    },
    {
      "id": 641,
      "title": "maiss",
      "level": 1,
      "definition": "Samērā liels, četrstūrains priekšmets (kā sausa glabāšanai, transportēšanai), kas veidots no auduma, plastmasas, papīra u. tml. un kam viens gals ir vaļējs."
    },
    { "id": 642, "title": "maita", "level": 2, "definition": "Bojā gājis dzīvnieks." },
    {
      "id": 643,
      "title": "maize",
      "level": 1,
      "definition": "Pārtikas produkts, ko cep, parasti no raudzētas mīklas, krāsnī un kam ir raksturīga klaipa, kukuļa forma; šāda pārtikas produkta šķēle, gabals."
    },
    {
      "id": 644,
      "title": "maksa",
      "level": 1,
      "definition": "Nauda, kas tiek dota vai ņemta kā maksāšanas līdzeklis."
    },
    {
      "id": 645,
      "title": "maldi",
      "level": 2,
      "definition": "Uzskati, spriedumi, priekšstati u. t ml., ko rada sagrozīta (kā) izpratne."
    },
    {
      "id": 646,
      "title": "malka",
      "level": 1,
      "definition": "Koksne, ko izmanto par kurināmo."
    },
    {
      "id": 647,
      "title": "malks",
      "level": 1,
      "definition": "Šķidruma daudzums, ko var vienā reizē ieņemt mutē un norīt."
    },
    { "id": 648, "title": "mamma", "level": 1, "definition": "Māte." },
    {
      "id": 649,
      "title": "manna",
      "level": 2,
      "definition": "Uzturlīdzeklis, ko iegūst no kviešu graudiem, nolobot tiem biezo apvalku un pēc tam sīki saskaldot; mannas putraimi."
    },
    {
      "id": 650,
      "title": "manta",
      "level": 1,
      "definition": "Tas, uz ko ir pilnīgas valdījuma, lietojuma un rīcības tiesības; tas (lietu kopums), kas kādam pieder, uz ko kādam ir valdījuma, lietojuma un rīcības tiesības; īpašums ."
    },
    {
      "id": 651,
      "title": "marka",
      "level": 2,
      "definition": "Pasta, zīmoga u. tml. nodevas samaksas dokuments - neliels četrstūrains, retāk trīsstūrains pielīmējams papīra gabals, uz kura ir cenas norāde un parasti attēls."
    },
    {
      "id": 652,
      "title": "marle",
      "level": 2,
      "definition": "Plāns kokvilnas audums ar retiem audiem un šķēriem."
    },
    {
      "id": 653,
      "title": "maršs",
      "level": 3,
      "definition": "Gājiens ierindā (parasti ritmiskā, vienmērīgā solī)."
    },
    { "id": 654, "title": "marts",
      "level": 1, "definition": "Gada trešais mēnesis." },
    {
      "id": 655,
      "title": "marža",
      "level": 3,
      "definition": "Starpība starp preces biržas cenu un maksimālo aizdevumu (ko ir atļauts pret šo preci izsniegt)."
    },
    {
      "id": 656,
      "title": "maska",
      "level": 1,
      "definition": "Uzliktnis (sejai) ar (piemēram, cilvēka, dzīvnieka, fantastiskas būtnes) galvas attēlu; uzliktnis (sejas augšējai daļai) ar izgrieztiem acu caurumiem; krāsojumu un līmējumu kopums, kas ievērojami pārveido sejas formu."
    },
    {
      "id": 657,
      "title": "masts",
      "level": 2,
      "definition": "Augsta, parasti vertikāla, stabveida konstrukcija (kuģim, jahtai u. tml.), pie kuras piestiprina, piemēram, buras, gaismas avotus."
    },
    {
      "id": 658,
      "title": "mauka",
      "level": 3,
      "definition": "Netikla, izvirtusi sieviete; ielasmeita."
    },
    {
      "id": 659,
      "title": "maurs",
      "level": 3,
      "definition": "Biezi saaudzis izturīgs, īsu lakstaugu zālājs, kas pārklāj kādu, parasti arī staigājamu, augsnes daļu, piemēram, pagalmu."
    },
    {
      "id": 660,
      "title": "mārks",
      "level": 3,
      "definition": "Dīķis (parasti pļavā, ganībās), kas paredzēts, piemēram, linu, kaņepāju, mērcēšanai."
    },
    {
      "id": 661,
      "title": "medus",
      "level": 1,
      "definition": "Salds, aromātisks vielu maisījums, ko no ziedu nektāra pārstrādā bišu un lapseņu dzimtas kukaiņi."
    },
    {
      "id": 662,
      "title": "meiča",
      "level": 1,
      "definition": "Jauna, neprecējusies sieviete."
    },
    {
      "id": 663,
      "title": "meija",
      "level": 2,
      "definition": "Nocirsts neliels zaļojošs lapu koks (parasti bērzs) vai tā zars (piemēram, telpu) rotāšanai."
    },
    {
      "id": 664,
      "title": "meita",
      "level": 1,
      "definition": "Sieviešu dzimuma bērns (attiecībā pret vecākiem)."
    },
    {
      "id": 665,
      "title": "melis",
      "level": 1,
      "definition": "Cilvēks, kas bieži mēdz melot; cilvēks, kas melo."
    },
    { "id": 666, "title": "melša", "level": 3, "definition": "Melis; arī pļāpa." },
    {
      "id": 667,
      "title": "menca",
      "level": 2,
      "definition": "Mencveidīgo zivju kārtas dzimta (\"Gadidae\"), pie kuras pieder, piemēram, Atlantijas menca."
    },
    {
      "id": 668,
      "title": "mente",
      "level": 3,
      "definition": "Neliela, parasti koka, lāpstiņa (piemēram, kā maisīšanai)."
    },
    {
      "id": 669,
      "title": "mesjē",
      "level": 3,
      "definition": "Pieklājības forma, ko lieto, uzrunājot vīrieti vai runājot par viņu (zemēs, kur runā franču valodā)."
    },
    { "id": 670, "title": "mesls", "level": 3, "definition": "Nodoklis, meteklis." },
    {
      "id": 671,
      "title": "metro",
      "level": 2,
      "definition": "Pilsētas elektriskais dzelzceļš, kas izbūvēts pazemes tuneļos vai dažreiz virs zemes - uz estakādēm, retāk īpaši nodalītā ielu daļā; metropolitēns."
    },
    {
      "id": 672,
      "title": "metrs",
      "level": 1,
      "definition": "Garuma mērvienība starptautiskajā mērvienību sistēmā; 1 m ir ceļa garums, ko gaisma vakuumā noiet 1/299792458 s; 1 m aptuveni vienāds ar 0,0000001 daļu no Parīzes meridiāna ceturtdaļas."
    },
    {
      "id": 673,
      "title": "mērce",
      "level": 1,
      "definition": "Šķidra piedeva, kas papildina ēdiena garšu, izskatu, uzturvielu daudzumu."
    },
    {
      "id": 674,
      "title": "mēris",
      "level": 2,
      "definition": "Sevišķi bīstama akūta infekcijas slimība, kam raksturīga organisma vispārēja intoksikācija, iekaisuma procesi ādā, limfmezglos, plaušās un citur un ko izraisa cilvēkam vai dažādu sugu dzīvniekiem specifiski vīrusi."
    },
    {
      "id": 675,
      "title": "mēsls",
      "level": 3,
      "definition": "Vispārīgs apzīmējums kaut kā niecīga, nevajadzīga u. tml. nosaukšanai."
    },
    {
      "id": 676,
      "title": "miece",
      "level": 3,
      "definition": "Darbība, process --> miecēt; miecēšana."
    },
    {
      "id": 677,
      "title": "miegs",
      "level": 1,
      "definition": "Nervu sistēmas diennakts ritma izraisīts organisma stāvoklis, kurā intensīvi atjaunojas un uzkrājas audu enerģētiskās un funkcionālās rezerves un kuram raksturīgi kavēšanas procesi plašos galvas smadzeņu garozas apvidos."
    },
    {
      "id": 678,
      "title": "miers",
      "level": 1,
      "definition": "Apstākļu kopums, stāvoklis (apkārtnē, vietā, arī telpā), kad nav kustības, arī (stipru) skaņu."
    },
    {
      "id": 679,
      "title": "miesa",
      "level": 1,
      "definition": "Ķermeņa daļu kopums, kuras veido muskuļaudi, taukaudi, āda; arī ķermenis (cilvēkiem vai dzīvniekiem)."
    },
    {
      "id": 680,
      "title": "miets",
      "level": 1,
      "definition": "Samērā tievs, garš kokauga stumbra, zara stieņveida gabals, parasti ar nosmailinātu galu."
    },
    {
      "id": 681,
      "title": "mieži",
      "level": 2,
      "definition": "Graudzāļu dzimtas ģints (\"Hordeum\"), viengadīgi labības augi ar blīvu vārpu un palielām, iegarenām sēklām."
    },
    {
      "id": 682,
      "title": "migla",
      "level": 1,
      "definition": "Sīku ūdens pilienu vai ledus kristāliņu sabiezinājums atmosfēras zemākajos slāņos."
    },
    { "id": 683, "title": "milna", "level": 3, "definition": "Liela, smaga runga; boze." },
    {
      "id": 684,
      "title": "milti",
      "level": 1,
      "definition": "Pulverveida masa, ko iegūst, speciālās ierīcēs, iekārtās sasmalcinot graudus, sēklas."
    },
    { "id": 685, "title": "milze", "level": 2, "definition": "Milzis." },
    { "id": 686, "title": "minka", "level": 1, "definition": "Kaķis." },
    {
      "id": 687,
      "title": "mioma",
      "level": 3,
      "definition": "Labdabīgs muskuļaudu audzējs, parasti labi norobežots, apaļas formas, ar pacietu konsistenci."
    },
    {
      "id": 688,
      "title": "mirla",
      "level": 3,
      "definition": "Vārgs, arī neveikls cilvēks."
    },
    {
      "id": 689,
      "title": "mirte",
      "level": 3,
      "definition": "Divdīgļlapju klases rožu apakšklases miršu rinda (\"Myrtales\")."
    },
    {
      "id": 690,
      "title": "mīkla",
      "level": 1,
      "definition": "Masa, kuras sastāvā ir milti, ierauga šķidrums un parasti aizdars vai milti un aizdars un kuru izmanto maizes vai konditorejas izstrādājumu izgatavošanai."
    },
    {
      "id": 691,
      "title": "mītne",
      "level": 2,
      "definition": "Par (cilvēku) dzīvesvietu izmantojama telpa, tās daļa, celtne."
    },
    {
      "id": 692,
      "title": "mokas",
      "level": 2,
      "definition": "Sajūtu, izjūtu kopums, ko izraisa stipras sāpes, arī ļoti nepatīkami fizioloģiski traucējumi."
    },
    {
      "id": 693,
      "title": "molls",
      "level": 3,
      "definition": "Minors (alfabētiskajā burtu notācijā)."
    },
    {
      "id": 694,
      "title": "morgs",
      "level": 2,
      "definition": "Celtne, arī telpa līķu novietošanai, glabāšanai, identificēšanai, secēšanai."
    },
    { "id": 695, "title": "moris", "level": 3, "definition": "Tumšādainais." },
    {
      "id": 696,
      "title": "morss",
      "level": 3,
      "definition": "Atspirdzinošs salds dzēriens - ar ūdeni atšķaidīta ogu vai augļu sula."
    },
    {
      "id": 697,
      "title": "muarē",
      "level": 3,
      "definition": "Blīvs, parasti zīda, audums ar svēdrainu virsmu."
    },
    {
      "id": 698,
      "title": "muita",
      "level": 2,
      "definition": "Maksājums valstij par preču importu, eksportu vai tranzītu."
    },
    {
      "id": 699,
      "title": "muiža",
      "level": 2,
      "definition": "Feodālā zemes valdījuma saimniecisks un administratīvs centrs; šāds centrs kopā ar tam pakļauto zemnieku zemi."
    },
    {
      "id": 700,
      "title": "mulda",
      "level": 2,
      "definition": "Garens, samērā liels trauks (parasti kā jaukšanai, mīcīšanai)."
    },
    {
      "id": 701,
      "title": "mulla",
      "level": 3,
      "definition": "Persiešu valodas vārds, kas atbilst arābu valodas vārdam \"skolotājs\" vai \"mācīts vīrs\"; islāma kulta kalpotājs un likumu skaidrotājs."
    },
    { "id": 702, "title": "muļļa",
      "level": 2, "definition": "Gauss, neveikls cilvēks." },
    {
      "id": 703,
      "title": "murds",
      "level": 2,
      "definition": "Aizsprosta zvejas rīks, ko veido pēc lamatu principa un novieto, piemēram, upē, ezerā."
    },
    {
      "id": 704,
      "title": "murgs",
      "level": 1,
      "definition": "Cilvēks, kas ne runā ne darbā netiek ne no vietas; tūļīgs, kūtrs cilvēks."
    },
    { "id": 705, "title": "mūlis", "level": 3, "definition": "Ēzeļa un ķēves krustojums." },
    {
      "id": 706,
      "title": "mūris",
      "level": 2,
      "definition": "Celtnes daļa, celtnes elementa daļa, arī atsevišķs objekts, kas veidots no dabiskiem vai mākslīgiem materiāliem (parasti tos sastiprinot ar javu), vai arī no kādas masas (to lejot vai blietējot)."
    },
    {
      "id": 707,
      "title": "nafta",
      "level": 1,
      "definition": "Šķidrs derīgais izraktenis - eļļains, degošs ogļūdeņražu maisījums."
    },
    {
      "id": 708,
      "title": "nagla",
      "level": 1,
      "definition": "Stieņveida (parasti metāla) detaļa, kam ir smails gals un ko izmanto tādu priekšmetu savienošanai, piestiprināšanai, kuri ir mīkstāki par šo detaļu."
    },
    {
      "id": 709,
      "title": "naids",
      "level": 1,
      "definition": "Dziļas un noturīgas jūtas, kam ir raksturīga nelabvēlīga, nosodoša, arī kaujinieciska attieksme (parasti pret cilvēkiem, parādībām sabiedrībā)."
    },
    {
      "id": 710,
      "title": "nakts",
      "level": 1,
      "definition": "Laikposms no saules rieta līdz lēktam, no vakara līdz rītam."
    },
    {
      "id": 711,
      "title": "nasta",
      "level": 1,
      "definition": "Priekšmetu, masas daudzums, kopums, kas ir sakārtots, savienots tā, ka to var nest; siena, salmu u. tml. daudzums, kopums, ko var vienā reizē saņemt ar darbarīku (parasti ar dakšām)."
    },
    {
      "id": 712,
      "title": "nauda",
      "level": 1,
      "definition": "Īpaša prece, ko izmanto par visu citu preču vērtības vispārējo ekvivalentu; šādas preces priekšmetiskās izpausmes forma (piemēram, banknote, monēta)."
    },
    {
      "id": 713,
      "title": "nazis",
      "level": 1,
      "definition": "Darbarīks (griešanai, duršanai) - parasti spalā iestiprināta plāksne ar asu malu, arī galu; šāds aukstais ierocis."
    },
    {
      "id": 714,
      "title": "nātre",
      "level": 1,
      "definition": "Augu dzimta (\"Urticaceae\"), kurā ietilpst lakstaugi, retāk koki, kam raksturīgas ar dzeļmatiņiem klātas lapas un sīki viendzimuma ziedi spurdzēs vai vārpās, 40 ģ., ~500 sugas, Latvijā konstatēta 1 ģ."
    },
    {
      "id": 715,
      "title": "nekas",
      "level": 1,
      "definition": "Norāda uz vispārīgu, noliegtu priekšmetu, parādību, norisi."
    },
    {
      "id": 716,
      "title": "nelga",
      "level": 1,
      "definition": "Cilvēks, kas izturas, rīkojas, runā muļķīgi, nejēdzīgi, arī vientiesīgi."
    },
    {
      "id": 717,
      "title": "neļķe",
      "level": 2,
      "definition": "Divdīgļlapju klases augu dzimta (\"Caryophyllaceae\"), kurā ietilpst lakstaugi, retāk puskrūmi vai krūmi, gk. ziemeļu puslodes mērenajā joslā, 89 ģintis, >2100 sugas, Latvijā tikai lakstaugi, konstatēas 23 ģintis, 66 sugas."
    },
    {
      "id": 718,
      "title": "neons",
      "level": 3,
      "definition": "Ķīmiskais elements - cēlgāze, periodiskās sistēmas 10. elements, Ne, atommasa - 20,183, zināmi 7 izotopi, no kuriem 3 ir stabili."
    },
    {
      "id": 719,
      "title": "nercs",
      "level": 3,
      "definition": "Zvērkopībā - Amerikas ūdele."
    },
    {
      "id": 720,
      "title": "nerrs",
      "level": 3,
      "definition": "Cilvēks, kura amata pienākums bija uzjautrināt un izklaidēt valdnieku, augstmani un viņa viesus; āksts."
    },
    {
      "id": 721,
      "title": "nervs",
      "level": 2,
      "definition": "Veidojums (cilvēka vai dzīvnieka organismā), kurš sastāv no šķiedru kūlīšiem un kura funkcija ir saistīt centrālo nervu sistēmu ar visiem orgāniem un audiem."
    },
    {
      "id": 722,
      "title": "nēģis",
      "level": 2,
      "definition": "Apaļmutnieku klases apakšklase (\"Petromyzones\")."
    },
    {
      "id": 723,
      "title": "nieks",
      "level": 1,
      "definition": "Neliels priekšmets; neliels mazvērtīgs, arī nelietderīgs priekšmets."
    },
    {
      "id": 724,
      "title": "nieze",
      "level": 1,
      "definition": "Īpaša sajūta, kas rada tieksmi kasīt ādu."
    },
    {
      "id": 725,
      "title": "niķis",
      "level": 1,
      "definition": "Slikts ieradums; arī netikums."
    },
    {
      "id": 726,
      "title": "nimbs",
      "level": 3,
      "definition": "Staru vainags; mirdzums (riņķa veidā) ap dievību un svēto galvām (piem., tēlotājmākslā); oreols."
    },
    {
      "id": 727,
      "title": "nimfa",
      "level": 3,
      "definition": "Sengrieķu un romiešu mitoloģijā - dabas dievība jaunas, skaistas sievietes veidolā."
    },
    {
      "id": 728,
      "title": "noeja",
      "level": 2,
      "definition": "Vieta, kas paredzēta nokļūšanai kur lejā."
    },
    {
      "id": 729,
      "title": "norma",
      "level": 2,
      "definition": "Likuma formulēts noteikums, arī tradicionāli izveidojies noteikums, princips, uzskats, kas regulē cilvēku attiecības sabiedrībā."
    },
    {
      "id": 730,
      "title": "nulle",
      "level": 2,
      "definition": "Cipars, ar ko norāda, ka attiecīgajā skaitļu šķirā nav nevienas vienības; skaitlis, kas ir robeža starp pozitīvajiem un negatīvajiem skaitļiem."
    },
    {
      "id": 731,
      "title": "nūģis",
      "level": 2,
      "definition": "Nesimpātisks, nepatīkams, nenovīdīgs cilvēks."
    },
    {
      "id": 732,
      "title": "ņerga",
      "level": 2,
      "definition": "Cilvēks (vai dzīvnieks), kas peļ, arī iznieko ēdienu; cilvēks, kam nav ēstgribas."
    },
    {
      "id": 733,
      "title": "ņirga",
      "level": 3,
      "definition": "Cilvēks, kas mēdz ņirgāties."
    },
    {
      "id": 734,
      "title": "oboja",
      "level": 3,
      "definition": "Koka pūšamais instruments ar divkāršu niedres mēlīti, kas pēc skanējuma ir aptuveni vidējs starp flautu un klarneti."
    },
    {
      "id": 735,
      "title": "odere",
      "level": 2,
      "definition": "Materiāls, materiāla kārta, kas ir iestrādāta (kā, piemēram, apģērba, apavu) iekšpusē."
    },
    {
      "id": 736,
      "title": "okers",
      "level": 3,
      "definition": "Dabiska minerālkrāsa (limonīta paveids) ar dažādiem dzeltenās krāsas toņiem."
    },
    {
      "id": 737,
      "title": "olājs",
      "level": 3,
      "definition": "Vieta, kur ir daudz oļu; oļājs."
    },
    {
      "id": 738,
      "title": "olīva",
      "level": 2,
      "definition": "Divdīgļlapju klases rožu apakšklases rinda (\"Oleales\"), kurā ir 1 dzimta."
    },
    {
      "id": 739,
      "title": "omārs",
      "level": 2,
      "definition": "Dzīvnieku valsts posmkāju tipa žaunaiņu apakštipa vēžu klases desmitkājvēžu kārtas rāpotājvēžu apakškārtas dzimta (\"Homaridae\"), 16 s., dzīvo gk. Atlantijas okeānā, mūža ilgums līdz 50 g."
    },
    {
      "id": 740,
      "title": "omega",
      "level": 3,
      "definition": "Grieķu alfabēta pēdējais (24.) burts."
    },
    { "id": 741, "title": "omīte", "level": 1, "definition": "Vecāmāte." },
    {
      "id": 742,
      "title": "opāls",
      "level": 3,
      "definition": "Bezkrāsains, balts, iedzeltens, sarkans, retāk citas krāsas minerāls (dārgakmens vai pusdārgakmens), reizumis ar varavīkšņainu lāsmojumu."
    },
    {
      "id": 743,
      "title": "opera",
      "level": 2,
      "definition": "Skatuves mākslas darbs, kura saturs ir izteikts vokāli instrumentālās mūzikas tēlos."
    },
    {
      "id": 744,
      "title": "opijs",
      "level": 3,
      "definition": "Gaisā sažuvusi miega magones nenogatavojušos pogaļu sula, kas satur alkaloīdus (piemēram, morfīnu, kodeīnu)."
    },
    {
      "id": 745,
      "title": "opuss",
      "level": 3,
      "definition": "Literārs vai muzikāls sacerējums, it īpaši skaņdarbs."
    },
    {
      "id": 746,
      "title": "osājs",
      "level": 3,
      "definition": "Ošu audze; ošiem apaugusi vieta."
    },
    {
      "id": 747,
      "title": "ozols",
      "level": 1,
      "definition": "Dižskābaržu dzimtas ģints (\"Quercus\"), koks, retāk krūms ar tumši pelēku, kreveļainu mizu, plūksnaini daivainām lapām, sīkiem viendzimuma ziediem un augli - zīli, 450 s., Latvijā savvaļā 1 s."
    },
    {
      "id": 748,
      "title": "ozons",
      "level": 1,
      "definition": "Ķīmisks savienojums, kura molekula sastāv no trim skābekļa atomiem, - gāze ar raksturīgu smaržu."
    },
    {
      "id": 749,
      "title": "paēna",
      "level": 1,
      "definition": "Vieta, kur kas neļauj krist gaismas stariem; ēna (2), pavēnis , pakrēslis ."
    },
    { "id": 750, "title": "paija",
      "level": 2, "definition": "Rotaļlieta." },
    {
      "id": 751,
      "title": "pakts",
      "level": 2,
      "definition": "Starptautisks līgums, vienošanās, kam ir sevišķa politiska nozīme."
    },
    {
      "id": 752,
      "title": "palma",
      "level": 2,
      "definition": "Viendīgļlapju klases apakšklase (\"Arecidae\"), iedala 3-5 rindās."
    },
    {
      "id": 753,
      "title": "palts",
      "level": 3,
      "definition": "Ar ūdeni, retāk ar dubļiem pildīts sekls padziļinājums, piemēram, zemes, ceļa virsā; ūdens, retāk dubļi šādā padziļinājumā; peļķe."
    },
    {
      "id": 754,
      "title": "paļas",
      "level": 3,
      "definition": "Noliedzošas, pazemojoši necienīgas attieksmes izpausme izturēšanās veidā, runā; nievas."
    },
    {
      "id": 755,
      "title": "pampa",
      "level": 3,
      "definition": "Subtropu joslas stepes līdzenums (Dienvidamerikā, galvenokārt Argentīnā)."
    },
    {
      "id": 756,
      "title": "panda",
      "level": 1,
      "definition": "Jenotveidīgo dzimtas apakšdzimta (\"Ailurinae\"), neliels plēsīgs zīdītājs, kas dzīvo Himalajos; bambuslācis; dažkārt iekļauj lāču dzimtā vai nodala patstāvīgā dzimtā \"Ailuropodidae\"."
    },
    {
      "id": 757,
      "title": "panga",
      "level": 3,
      "definition": "Kaitēkļu izraisīts izaugums uz augu daļām."
    },
    {
      "id": 758,
      "title": "panks",
      "level": 2,
      "definition": "Jaunietis, kam raksturīgs kultūras vērtību noliegums, sevišķi ekstravagants apģērbs; panku subkultūras pārstāvis."
    },
    {
      "id": 759,
      "title": "panna",
      "level": 1,
      "definition": "Lēzens metāla, parasti apaļš, trauks ar rokturi (cepšanai uz atklātas uguns, karstas virsmas); taisnstūraina metāla plāksne ar uzliektām malām (cepšanai cepeškrāsni)."
    },
    {
      "id": 760,
      "title": "panno",
      "level": 3,
      "definition": "Glezna vai cilnis uz norobežota sienas laukuma; siena, kas ir rotāta ar šādu gleznu vai cilni."
    },
    {
      "id": 761,
      "title": "pants",
      "level": 2,
      "definition": "Divu vai vairāku dzejas rindu kopa, ko apvieno vai nu atskaņu sistēma, metriskā shēma un kopīga intonācija, vai tikai intonācija."
    },
    {
      "id": 762,
      "title": "parks",
      "level": 1,
      "definition": "Īpaši iekārtota, parasti plaša, dekoratīva atpūtas teritorija, dārzs, arī ar dabiskās ainavas iesaistījumu, apstādījumiem, lielu koku grupām, celiņiem, strūklakām, spēļu laukumiem u. tml."
    },
    {
      "id": 763,
      "title": "parts",
      "level": 3,
      "definition": "Daļa; loma teātrī; pretinieks (saka it sevišķi tiesā par advokātiem)."
    },
    {
      "id": 764,
      "title": "pasta",
      "level": 1,
      "definition": "Masa ar mīklai vai biezputrai līdzīgu konsistenci; ziede, kas satur vairāk par 25 procentiem pulverveida vielas."
    },
    {
      "id": 765,
      "title": "pasts",
      "level": 1,
      "definition": "Iestāde, organizācija, kas kārto sūtījumu (korespondences, periodisku izdevumu, naudas pārvedumu, īpaši noformētu saiņu, bandroļu) regulāru nogādi noteiktai personai, iestādei, organizācijai u. tml., celtne, telpas, kur darbojas šāda iestāde, organizācija."
    },
    {
      "id": 766,
      "title": "pauna",
      "level": 2,
      "definition": "Priekšmets vai priekšmetu kopums, kas ir iesaiņots (parasti drānā); sainis."
    },
    {
      "id": 767,
      "title": "pauze",
      "level": 1,
      "definition": "Neilgs pārtraukums, klusuma brīdis (skaņā, skaņu virknē)."
    },
    { "id": 768, "title": "pāķis",
      "level": 2, "definition": "Laucinieks." },
    {
      "id": 769,
      "title": "pālis",
      "level": 2,
      "definition": "Pilnīgi vai daļēji gruntī iedziļināts pamatu konstrukcijas elements, piemēram, celtnes slodzes pārnešanai uz dziļāku pamatnes slāni."
    },
    {
      "id": 770,
      "title": "pāris",
      "level": 1,
      "definition": "Kopums, ko veido divi līdzīgi, savstarpēji saistīti (piemēram, pēc funkcijas, izskata) priekšmeti, parādības u. tml."
    },
    { "id": 771, "title": "pekle",
      "level": 1, "definition": "Elle." },
    {
      "id": 772,
      "title": "pelde",
      "level": 1,
      "definition": "Darbība, process --> peldēties, arī peldēt; peldēšanās, arī peldēšana."
    },
    {
      "id": 773,
      "title": "pelni",
      "level": 1,
      "definition": "Cietais atlikums, kas paliek pēc kurināmā, arī pēc kādu organisku vielu sadegšanas."
    },
    {
      "id": 774,
      "title": "peļķe",
      "level": 1,
      "definition": "Ar ūdeni, retāk ar dubļiem pildīts sekls padziļinājums, piemēram, zemes, ceļa virsā; ūdens, retāk dubļi šādā padziļinājumā."
    },
    {
      "id": 775,
      "title": "peļņa",
      "level": 1,
      "definition": "Uzņēmuma tīrais ienākums, ko veido starpība starp produkcijas realizācijas cenu un produkcijas pilno pašizmaksu."
    },
    { "id": 776, "title": "penis",
      "level": 2, "definition": "Vīrieša dzimumloceklis." },
    {
      "id": 777,
      "title": "penss",
      "level": 3,
      "definition": "Naudas vienība (Anglijā); attiecīgā naudas zīme, monēta."
    },
    { "id": 778, "title": "peons",
      "level": 3, "definition": "Četrzilbīga pēda." },
    {
      "id": 779,
      "title": "perve",
      "level": 3,
      "definition": "Rēta, kas veidojas augošam kokam noplēšot gabalu mizas."
    },
    {
      "id": 780,
      "title": "pēlis",
      "level": 3,
      "definition": "Gultas maiss, kas parasti ir pildīts ar dūnām."
    },
    {
      "id": 781,
      "title": "pērle",
      "level": 2,
      "definition": "Apaļš, ciets dažādas krāsas perlamutra vielas grauds (pusdārgakmens), kas izveidojas dažu gliemeņu (pērleņu) gliemežvākos."
    },
    {
      "id": 782,
      "title": "piala",
      "level": 3,
      "definition": "Ieapaļš konusveida dzeramais trauks (Vidusāzijā) ar paplatinātu augšdaļu un bez osas."
    },
    {
      "id": 783,
      "title": "piens",
      "level": 1,
      "definition": "Īpašs (mātes) dziedzeru izstrādāts balts sekrēts, kas rodas pēcdzemdību periodā un ir fizioloģiski paredzēts bērnu un dzīvnieku mazuļu barošanai."
    },
    {
      "id": 784,
      "title": "pieņi",
      "level": 2,
      "definition": "Sēklinieku un sēklas šķidruma kopums (zivju tēviņiem)."
    },
    {
      "id": 785,
      "title": "piepe",
      "level": 1,
      "definition": "Sēne, kas parazitē uz kokiem."
    },
    {
      "id": 786,
      "title": "piere",
      "level": 1,
      "definition": "Sejas daļa starp uzacīm un matiem (cilvēkam); galvas virsējā priekšdaļa (dzīvniekam)."
    },
    {
      "id": 787,
      "title": "piets",
      "level": 3,
      "definition": "Plakanā, paplatinātā (cērtamo, šķeļamo u. tml. rīku) mugurējā daļa."
    },
    {
      "id": 788,
      "title": "piķis",
      "level": 2,
      "definition": "No naftas vai darvas destilācijas atlikumiem iegūta cieta vai stīgra melna viela."
    },
    {
      "id": 789,
      "title": "pinka",
      "level": 1,
      "definition": "Izspūrusi, samudžinājusies, arī nesakopta (matu, bārdas) šķipsna."
    },
    { "id": 790, "title": "pinne",
      "level": 2, "definition": "Salaidums, ieloks." },
    {
      "id": 791,
      "title": "pinte",
      "level": 2,
      "definition": "Šķidru un beramu vielu tilpuma mērvienība angļu mēru sistēmā; Lielbritānijā - 1/8 galona = 0,568 l, ASV - 0,473 l (šķidrumiem) un 0,550 l (beramām vielām)."
    },
    {
      "id": 792,
      "title": "pions",
      "level": 3,
      "definition": "Nestabila elementārdaļiņa, kuras masa ir aptuveni 270 elektronu masa, spins 0."
    },
    {
      "id": 793,
      "title": "pipka",
      "level": 3,
      "definition": "Pātaga, kas parasti ir pīta no ādas sloksnēm; arī nagaika."
    },
    {
      "id": 794,
      "title": "pirts",
      "level": 1,
      "definition": "Celtne vai telpu kopums, kas ir īpaši iekārtots mazgāšanās vajadzībām, arī veselības uzlabošanas procedūrām."
    },
    {
      "id": 795,
      "title": "pīcka",
      "level": 2,
      "definition": "Dūņu pīkste (\"Misgurnus fossilis syn. Cobitis fossilis\")."
    },
    {
      "id": 796,
      "title": "pīķis",
      "level": 2,
      "definition": "Duramais ierocis - garā kātā nostiprināts smails asmens."
    },
    { "id": 797, "title": "pīpis",
      "level": 3, "definition": "Pīpe." },
    {
      "id": 798,
      "title": "plate",
      "level": 2,
      "definition": "Plakans, parasti gluds, taisnstūrveida (dažāda materiāla, piemēram, koksnes, metāla) veidojums, ko izmanto par izejmateriālu (kā) izgatavošanai; arī plātne ."
    },
    {
      "id": 799,
      "title": "plāte",
      "level": 2,
      "definition": "Taisnstūraina plāna panna (kā) cepšanai krāsnī, cepeškrāsnī."
    },
    {
      "id": 800,
      "title": "plecs",
      "level": 1,
      "definition": "Ķermeņa daļa (cilvēkam), ko veido rokas savienojums ar vidukli; šīs ķermeņa daļas augšējā virsma."
    },
    {
      "id": 801,
      "title": "pleds",
      "level": 1,
      "definition": "Liels, parasti bārkstains, rūtains, vilnas auduma izstrādājums, ko izmanto par segu vai klāj uz pleciem."
    },
    {
      "id": 802,
      "title": "plēne",
      "level": 3,
      "definition": "Viendabīga, plāna vispirms atdzisušas vielas kārta, kas rodas uz kā kvēlojoša (parasti uz oglēm)."
    },
    {
      "id": 803,
      "title": "plēve",
      "level": 1,
      "definition": "Viendabīga, parasti plāna, samērā blīva (piemēram, vielas, organiska veidojuma) kārta, kas atrodas virs citām, parasti mazāk blīvām (to) kārtām vai pārklāj (to) virsmu."
    },
    {
      "id": 804,
      "title": "plīšs",
      "level": 3,
      "definition": "Plūksnains, pamīksts kokvilnas audums (parasti mēbeļu pārvilkšanai)."
    },
    {
      "id": 805,
      "title": "plīts",
      "level": 1,
      "definition": "Kurināmā, arī sildāmā ierīce (parasti virtuvē) ēdienu un dzērienu gatavošanai."
    },
    {
      "id": 806,
      "title": "plovs",
      "level": 1,
      "definition": "Ēdiens no rīsiem un gaļas, dārzeņiem, augļiem ar dažādu garšvielu piedevām."
    },
    {
      "id": 807,
      "title": "pluss",
      "level": 1,
      "definition": "Zīme ( + ), ar ko apzīmē saskaitīšanu vai pozitīvu lielumu."
    },
    {
      "id": 808,
      "title": "plūdi",
      "level": 1,
      "definition": "Teritorijas pārplūšana, parasti ar palu ūdeņiem, lietus uzplūdienu ūdeņiem."
    },
    {
      "id": 809,
      "title": "plūme",
      "level": 1,
      "definition": "Rožu dzimtas ģints (\"Prunus\"), augļu koks vai krūms ar plašu vainagu, pamīšus sakārtotām vienkāršām lapām, gareniem vai apaļīgiem dzelteniem, ziliem vai sarkani zilganiem augļiem - kauleņiem."
    },
    {
      "id": 810,
      "title": "pļava",
      "level": 1,
      "definition": "Dabisko vai sēto zālaugu platība, kur zāli izmanto pļaušanai vai ganīšanai; zālājs (mēreni vēsā, nokrišņiem bagāta klimata joslās), kurā ir bieza lakstaugu (galvenokārt graudaugu) sega."
    },
    { "id": 811, "title": "pļāpa",
      "level": 1, "definition": "Pļāpīgs cilvēks." },
    { "id": 812,
      "title": "pļeka",
      "level": 3,
      "definition": "Govju mēslu čupa."
    },
    {
      "id": 813,
      "title": "poēma",
      "level": 2,
      "definition": "Liroepikas žanrs, kam raksturīgs dzejisks vēstījums par svarīgiem, izšķirošiem notikumiem tautas, kādas sociālas grupas vai atsevišķa cilvēka dzīvē; šī žanra daiļdarbs."
    },
    {
      "id": 814,
      "title": "poķis",
      "level": 3,
      "definition": "Potīte, kauliņš kājai; poķītis; poķīte."
    },
    { "id": 815, "title": "polis",
      "level": 2, "definition": "Poļi." },
    {
      "id": 816,
      "title": "polka",
      "level": 2,
      "definition": "Strauja deja 2/4 taktsmērā; čehu tautasdeja; šīs dejas mūzika."
    },
    {
      "id": 817,
      "title": "pončo",
      "level": 3,
      "definition": "No taisnstūrveida auduma darināts apmetnis ar izgriezumu galvai."
    },
    {
      "id": 818,
      "title": "ports",
      "level": 2,
      "definition": "Pieslēgvieta - punkts, kurā pie datora vai mikroprocesora datorkopnes pieslēgta ārējā ierīce."
    },
    {
      "id": 819,
      "title": "posms",
      "level": 1,
      "definition": "Atsevišķa (kā) daļa ar noteiktām īpašībām, pazīmēm."
    },
    {
      "id": 820,
      "title": "posts",
      "level": 1,
      "definition": "Notikums, apstāklis, to kopums, kas ir saistīts ar lieliem materiāliem zaudējumiem, saimnieciski ekonomiskās dzīves pilnīgu sabrukumu."
    },
    {
      "id": 821,
      "title": "prāts",
      "level": 1,
      "definition": "Psihisko norišu un personības īpašību kopums, kas rada iespēju veidot subjektīvu, ar priekšstatiem un jēdzieniem pastarpinātu īstenības atspoguļojumu, izzināt priekšmetu un parādību vispārīgās un būtiskās īpašības un darboties jaunā situācijā, izmantojot šādi iegūto informāciju; arī intelekts."
    },
    { "id": 822, "title": "prāva",
      "level": 3, "definition": "Tiesas process." },
    {
      "id": 823,
      "title": "prece",
      "level": 1,
      "definition": "Darba produkts, kam ir lietošanas vērtība un kas paredzēts maiņai; šāds produkts kā maiņas, pirkšanas un pārdošanas objekts."
    },
    {
      "id": 824,
      "title": "prese",
      "level": 1,
      "definition": "Mašīna, mehānisms, iekārta (kā) apstrādei ar statisku spiedienu (bez triecieniem)."
    },
    {
      "id": 825,
      "title": "prīma",
      "level": 3,
      "definition": "Intervāls - nulle pustoņu vai viens pustonis."
    },
    {
      "id": 826,
      "title": "prīze",
      "level": 3,
      "definition": "Aizturēts un apķīlāts pretinieka vai kontrabandistu kuģis ar kravu."
    },
    {
      "id": 827,
      "title": "prosa",
      "level": 2,
      "definition": "Sējas sāre (\"Panicum miliaceum\") - viengadīgs cerains sausumizturīgs graudzāļu dzimtas labības augs."
    },
    { "id": 828, "title": "prove",
      "level": 2, "definition": "Raudze ." },
    {
      "id": 829,
      "title": "proza",
      "level": 2,
      "definition": "Teksts (arī tekstu kopums) metriski nesaistītā valodā; metriski nesaistīta valodas forma; daiļdarbs (arī daiļdarbu kopums), kas rakstīts šādā valodas formā."
    },
    {
      "id": 830,
      "title": "psihe",
      "level": 3,
      "definition": "Smadzeņu spēja atspoguļot objektīvo īstenību, analizēt un sintezēt saņemtos kairinājumus un pareizi uz tiem reaģēt; cilvēka nervu darbības procesu kopums; arī dvēsele."
    },
    { "id": 831, "title": "puika",
      "level": 1, "definition": "Zēns." },
    {
      "id": 832,
      "title": "pulks",
      "level": 2,
      "definition": "Administratīvi un saimnieciski patstāvīga karaspēka daļa, kas sastāv no bataljoniem, divizioniem vai eskadriļām."
    },
    {
      "id": 833,
      "title": "pulpa",
      "level": 3,
      "definition": "Mīksto audu kopums zoba dobumā."
    },
    {
      "id": 834,
      "title": "pulss",
      "level": 2,
      "definition": "Asinsvadu sienu periodisks viļņojums, ko rada to tilpuma, spiediena un asins plūsmas ātruma svārstības sirds sistoles un diastoles laikā."
    },
    {
      "id": 835,
      "title": "pults",
      "level": 1,
      "definition": "Ierīce (parasti paliktnis ar slīpu virsu), kas paredzēta, lai ko (piemēram, grāmatu, notis) novietotu lasīšanai ērtā stāvoklī, leņķī."
    },
    {
      "id": 836,
      "title": "pumpa",
      "level": 1,
      "definition": "Ieapaļš, neliels, parasti slimības izraisīts, izaugums, veidojums (uz organisma daļām)."
    },
    {
      "id": 837,
      "title": "punšs",
      "level": 2,
      "definition": "Alkoholisks, parasti karsts, dzēriens, ko gatavo no ruma, karstas tējas, cukura, augļu sulas un garšvielām."
    },
    {
      "id": 838,
      "title": "purns",
      "level": 1,
      "definition": "Galvas priekšējā daļa ar muti un nāsīm (mugurkaulniekiem, izņemot putnus)."
    },
    {
      "id": 839,
      "title": "purvs",
      "level": 1,
      "definition": "Pārmitra ekoloģiskā sistēma, kurā noris kūdras uzkrāšanās process un kurā galvenais organiskās masas veidotājs ir zemsedze; attiecīgā vieta, nogabals u. tml."
    },
    {
      "id": 840,
      "title": "putas",
      "level": 1,
      "definition": "Gaisa, gāzes pūslīšu kopums, kas izdalās kāda šķidruma, masas virspusē."
    },
    {
      "id": 841,
      "title": "putns",
      "level": 1,
      "definition": "Hordaiņu tipa mugurkaulnieku apakštipa klase (\"Aves\"), dzīvnieks, kam ķermeni klāj spalvas, priekšējās ekstremitātes pārvērstas spārnos un kas parasti spēj lidot, 28 kārtas, ~160 dzimtas, ~9000 sugu, Latvijā konstatētas 18 kārtas, 58 dzimtas, 325 sugas (79 sugas iekļautas Latvijas Sarkanajā grāmatā)."
    },
    {
      "id": 842,
      "title": "putra",
      "level": 1,
      "definition": "Šķidrs vai pusšķidrs ēdiens no putraimiem vai miltiem, kas vārīti ūdenī vai pienā, vai arī ūdenī ar piena piedevu."
    },
    {
      "id": 843,
      "title": "pūķis",
      "level": 1,
      "definition": "Pārdabiska, parasti daudzgalvaina, būtne."
    },
    {
      "id": 844,
      "title": "pūles",
      "level": 2,
      "definition": "Fizisko, garīgo spēku intensitāte, koncentrācija (kādā darbībā); fizisko, garīgo spēku patēriņš."
    },
    {
      "id": 845,
      "title": "pūlis",
      "level": 2,
      "definition": "Liels neorganizēts vai vāji organizēts (cilvēku) kopums."
    },
    {
      "id": 846,
      "title": "pūsma",
      "level": 2,
      "definition": "Viegla (gaisa) kustība, plūsma."
    },
    {
      "id": 847,
      "title": "radio",
      "level": 1,
      "definition": "Informācijas raidīšana ar radioviļņiem un tās uztveršana; attiecīgā tehnisko iekārtu sistēma."
    },
    {
      "id": 848,
      "title": "radze",
      "level": 3,
      "definition": "Ass izvirzījums, izcilnis (klintij, akmenim)."
    },
    {
      "id": 849,
      "title": "radža",
      "level": 3,
      "definition": "Valdnieks (kādā Indijas vai Malajas teritorijā); šī valdnieka tituls."
    },
    { "id": 850, "title": "raize",
      "level": 2, "definition": "Durošas sāpes." },
    {
      "id": 851,
      "title": "rampa",
      "level": 2,
      "definition": "Skatuves grīdas priekšējā mala, kur izvietoti gaismas ķermeņi."
    },
    {
      "id": 852,
      "title": "rančo",
      "level": 2,
      "definition": "Lauku mājas (Latīņamerikā); lopkopības ferma (gk. Amerikas Savienoto Valstu rietumos)."
    },
    {
      "id": 853,
      "title": "rands",
      "level": 3,
      "definition": "Dienvidāfrikas Republikas naudas pamatvienība."
    },
    {
      "id": 854,
      "title": "rangs",
      "level": 2,
      "definition": "Cilvēku grupējuma pakāpe, piemēram, pēc ieņemamā amata, kvalifikācijas, nopelniem."
    },
    {
      "id": 855,
      "title": "rauda",
      "level": 2,
      "definition": "Karpu dzimtas suga (\"Rutilus rutilus\"), sudrabbalta saldūdens zivs ar sarkanām spurām un sarkanām acīm."
    },
    {
      "id": 856,
      "title": "raugs",
      "level": 1,
      "definition": "Saharomicēšu dzimtas vienšūnas sēnes, kas vairojas pumpurojoties un ar sporām un kas cukuru saturošās vielās izraisa rūgšanu."
    },
    {
      "id": 857,
      "title": "rāmis",
      "level": 1,
      "definition": "Veidojums (piemēram, no listēm, stieņiem), kas samērā šaurā joslā no visām pusēm ietver (ko tajā ievietotu, iestiprinātu); arī ietvars."
    },
    {
      "id": 858,
      "title": "redze",
      "level": 1,
      "definition": "Bioloģisko norišu kopums, ar kurām organisms uztver un analizē gaismu."
    },
    {
      "id": 859,
      "title": "reids",
      "level": 2,
      "definition": "Vieta krasta vai ostas tuvumā, kur stāv noenkurojušies kuģi."
    },
    { "id": 860, "title": "reihs", "level": 3, "definition": "Vācijas impērija." },
    {
      "id": 861,
      "title": "reiss",
      "level": 2,
      "definition": "Brauciens (ar transportlīdzekli) no maršruta viena galapunkta līdz otram."
    },
    {
      "id": 862,
      "title": "reize",
      "level": 1,
      "definition": "Norāda uz darbības, stāvokļa vietu kādā secībā vai uz to atkārtošanos, biežumu."
    },
    {
      "id": 863,
      "title": "rejas",
      "level": 1,
      "definition": "Vairākkārtīgas suņa vai suņu dzimtas dzīvnieka radītas raksturīgas skaņas."
    },
    {
      "id": 864,
      "title": "rekte",
      "level": 3,
      "definition": "Noteikta, iedibināta kārtība; arī tiesība."
    },
    {
      "id": 865,
      "title": "rente",
      "level": 2,
      "definition": "Regulārs ienākums, ko saņem no kapitāla, zemes vai īpašuma un kas nav saistīts ar uzņēmēja darbību."
    },
    {
      "id": 866,
      "title": "repis",
      "level": 3,
      "definition": "Ādas, drēbes vai kaltēta un izmīcīta cūkas pūšļa tabakas maks, kur dažkārt glabājas arī šķiltavas; arī naudas maks."
    },
    {
      "id": 867,
      "title": "retro",
      "level": 2,
      "definition": "Tāds, kas bijis populārs, modē pagājušā laikposmā un atkal kļuvis populārs, moderns."
    },
    {
      "id": 868,
      "title": "rēdze",
      "level": 3,
      "definition": "Vārpstas vai ass daļa, kas balstās gultnī."
    },
    {
      "id": 869,
      "title": "riepa",
      "level": 1,
      "definition": "Transportlīdzekļa riteņa apvalks, kas saskaras ar ceļa virsmu un kas parasti ir veidots no gumijas (ar kameru vai bez tās), metāla."
    },
    {
      "id": 870,
      "title": "riets",
      "level": 1,
      "definition": "Virzīšanās šķietamā kustībā aiz apvāršņa (debess spīdekļiem); apgaismojums laikā, kad saule riet."
    },
    {
      "id": 871,
      "title": "rieva",
      "level": 1,
      "definition": "Garens, šaurs padziļinājums (priekšmeta, auga virsmā)."
    },
    { "id": 872, "title": "rikšā",
      "level": 3, "definition": "Steidzīgi, ātriem soļiem." },
    { "id": 873, "title": "rikšu",
      "level": 3, "definition": "Rikšiem." },
    {
      "id": 874,
      "title": "rinda",
      "level": 1,
      "definition": "Vienā līnijā novietots, novietojies (cilvēku vai dzīvnieku) kopums."
    },
    {
      "id": 875,
      "title": "rings",
      "level": 2,
      "definition": "Ar virvēm iežogots kvadrātveida laukums boksa cīņām."
    },
    {
      "id": 876,
      "title": "ripss",
      "level": 3,
      "definition": "Audums ar šķērsvirziena, garenvirziena vai diagonālām rievām, kas veidojas no pagarinātām audu vai šķēru pārsedzām."
    },
    {
      "id": 877,
      "title": "risks",
      "level": 1,
      "definition": "Iespējamas briesmas; zaudējuma iespēja pārdrošā, arī neapdomīgā rīcībā, darbībā."
    },
    {
      "id": 878,
      "title": "ritms",
      "level": 1,
      "definition": "Vienmērīga (procesu, parādību) secība, atkārtošanās (laikā vai telpā)."
    },
    {
      "id": 879,
      "title": "rīkle",
      "level": 1,
      "definition": "Orgāns, kurā krustojas gremošanas un elpošanas ceļi."
    },
    {
      "id": 880,
      "title": "rodeo",
      "level": 3,
      "definition": "Kovboju veiklības sacensības jāšanā, laso mešanā u. tml.; veiklības sacensības ar motocikliem vai automobiļiem; arī šāda veida izrāde."
    },
    {
      "id": 881,
      "title": "rombs",
      "level": 2,
      "definition": "Paralelograms, kam visu malu garums ir vienāds."
    },
    {
      "id": 882,
      "title": "ronis",
      "level": 1,
      "definition": "Zīdītāju klases plēsēju kārtas dzimta (\"Phocidae\"), kurā ietilpst lieli un vidēji lieli dzīvnieki, kas labi pielāgojušies dzīvei ūdenī (galvenokārt aukstās un mērenās joslas jūrās) un kam raksturīgs vārpstveida ķermenis, peldēšanai pielāgotas ekstremitātes, 10 ģintis, 19 sugu, Baltijas jūrā konstatētas 2 ģ., 3 sugas."
    },
    {
      "id": 883,
      "title": "rosme",
      "level": 1,
      "definition": "Rosīga darbība, rosīgs process; rosība ."
    },
    {
      "id": 884,
      "title": "rovis",
      "level": 3,
      "definition": "Velvēts pārsegums dzirksteļu uztveršanai virs atklāta pavarda."
    },
    {
      "id": 885,
      "title": "rudzi",
      "level": 2,
      "definition": "Graudzāļu dzimtas ģints (\"Secale\"), viengadīgi, divgadīgi vai daudzgadīgi lakstaugi ar gari smailām lapām un sēdošām vārpiņām divrindu saliktā vārpā, 6-8 s."
    },
    {
      "id": 886,
      "title": "rumba",
      "level": 2,
      "definition": "Vidusdaļa (rotējošam elementam, detaļai, piemēram, ritenim) ar caurumu (tā) novietošanai uz ass."
    },
    { "id": 887, "title": "runga",
      "level": 1, "definition": "Resna, smaga nūja." },
    {
      "id": 888,
      "title": "rutks",
      "level": 2,
      "definition": "Kāpostu (krustziežu) dzimtas pērkoņu ģints suga (\"Raphanus sativus\"), viengadīgs vai divgadīgs augs ar (parasti) plūksnaini šķeltām lapām, baltiem, iesārtiem vai violetiem ziediem, apaļām, ovālām vai iegareni koniskām baltām vai melnām saknēm."
    },
    {
      "id": 889,
      "title": "rūķis",
      "level": 1,
      "definition": "Maza cilvēkveida mitoloģiska būtne, kas dara brīnumus, parasti uzturas pazemē, mežos, koku dobumos un ir cilvēkiem labvēlīga, retāk ļauna; rūķītis."
    },
    {
      "id": 890,
      "title": "rūpes",
      "level": 1,
      "definition": "Nevēlams, nepatīkams gadījums, stāvoklis, apstākļi, kuri jāpacieš vai kurus jācenšas novērst; psihisks stāvoklis, ko izraisa šāds gadījums, stāvoklis, apstākļi."
    },
    {
      "id": 891,
      "title": "sagša",
      "level": 3,
      "definition": "Četrstūraina plecu sega (parasti sieviešu tautas tērpa sastāvdaļa); villaine."
    },
    {
      "id": 892,
      "title": "saiga",
      "level": 3,
      "definition": "Dobradžu dzimtas suga (\"Saiga tatarica\"), neliels pārnadzis dzīvnieks (stepēs, pustuksnešos) ar dzeltenpelēku apmatojumu un neproporcionāli lielu galvu un kumpainu purnu, izplatīti Vidusāzijā, Ziemeļķīnā un Mongolijā."
    },
    {
      "id": 893,
      "title": "saime",
      "level": 2,
      "definition": "Kopums, ko veido cilvēki, cilvēku grupas, retāk tautas un kam ir kāda kopēja pazīme, kopējas īpašības."
    },
    {
      "id": 894,
      "title": "saite",
      "level": 1,
      "definition": "Lente, virve, aukla, auduma vai ādas sloksne u. tml., ko izmanto, piemēram, kā piesiešanai, sasiešanai, nostiprināšanai."
    },
    {
      "id": 895,
      "title": "saiva",
      "level": 3,
      "definition": "Neliels laiviņveida rīks pavediena uztīšanai (aušanai, tīklu lāpīšanai u. tml.)."
    },
    {
      "id": 896,
      "title": "sakas",
      "level": 2,
      "definition": "Aizjūga piederums, ko mauc darba dzīvniekiem kaklā un kas ir veidots no divdaļīgām izliektām koka detaļām, kuras apakšdaļā ir savelkamas; pie tā piesaistītās dzeņaukstes pārnes zirga vilcējspēku uz velkamo priekšmetu."
    },
    {
      "id": 897,
      "title": "sakne",
      "level": 1,
      "definition": "Augstāko augu veģetatīvais orgāns, kas nostiprina augu augsnē, uzsūc ūdeni un tajā izšķīdušās minerālvielas, sintezē organiskas vielas un sekmē to pārvietošanos uz citiem orgāniem, izdala vielmaiņas produktus."
    },
    {
      "id": 898,
      "title": "sakta",
      "level": 1,
      "definition": "Rotas lieta (Eiropas tautām) tērpa, tā daļu saspraušanai."
    },
    {
      "id": 899,
      "title": "salna",
      "level": 1,
      "definition": "Gaisa temperatūras pazemināšanās vakarā, naktī zem 0 grādiem pēc Celsija skalas, ja dienā tā ir bijusi virs 0 grādiem; ledus kristālu kopums, kas rodas, šādi pazeminoties gaisa temperatūrai."
    },
    {
      "id": 900,
      "title": "salne",
      "level": 2,
      "definition": "Sirma govs; govs ar sirmu, brūni iesārtu spalvu."
    },
    { "id": 901, "title": "salsa",
      "level": 2, "definition": "Mērce." },
    {
      "id": 902,
      "title": "samba",
      "level": 2,
      "definition": "Brazīliešu cilmes deja 4/4 taktsmērā."
    },
    {
      "id": 903,
      "title": "sambo",
      "level": 3,
      "definition": "Cīņas sporta veids - pretošanās bez ieroča stiprāka vai apbruņota pretinieka uzbrukumam."
    },
    {
      "id": 904,
      "title": "samts",
      "level": 2,
      "definition": "Audums ar ļoti blīvu, smalku, īsu plūksnu labajā pusē."
    },
    {
      "id": 905,
      "title": "sargs",
      "level": 1,
      "definition": "Darbinieks (uzņēmumā, iestādē u. tml.), kura uzdevums ir sargāt ."
    },
    {
      "id": 906,
      "title": "sarķe",
      "level": 3,
      "definition": "Sarkanbrūna, sarkanīga govs."
    },
    {
      "id": 907,
      "title": "sarma",
      "level": 1,
      "definition": "Sīku ledus kristālu apledojums, kas radies uz augu zariem, lapām, iekārtiem vadiem, stieplēm u. tml., desublimējoties ūdens tvaikiem vai sasalstot pārdzesētiem miglas pilieniem."
    },
    {
      "id": 908,
      "title": "saržs",
      "level": 3,
      "definition": "Kokvilnas vai zīda audums ar sīkām, šķērsām rieviņām."
    },
    {
      "id": 909,
      "title": "sauja",
      "level": 1,
      "definition": "Ieliekta plauksta ar kopā sakļautiem, parasti mazliet saliektiem, pirkstiem."
    },
    {
      "id": 910,
      "title": "saule",
      "level": 1,
      "definition": "Mūsu planētu sistēmas centrāla debess ķermeņa starojuma radītā gaisma, siltums, ultravioletie stari."
    },
    {
      "id": 911,
      "title": "sauna",
      "level": 2,
      "definition": "Pirts, kas sastāv no lāvas telpas, dušas telpas, atpūtas telpas un peldbaseina (ar aukstu ūdeni) un kur ir augsta temperatūra, sauss gaiss; somu pirts."
    },
    {
      "id": 912,
      "title": "sādža",
      "level": 2,
      "definition": "Grupveida apdzīvota vieta (Latgalē), kurai ir kopējs nosaukums, bet kuras mājām nav atsevišķu mājvārdu."
    },
    {
      "id": 913,
      "title": "sārms",
      "level": 3,
      "definition": "Sārmu metāla vai sārmzemju metālu hidroksīds; ūdenī šķīstoša bāze."
    },
    {
      "id": 914,
      "title": "scēna",
      "level": 2,
      "definition": "Vizuāli uztverams, parasti emocionāli iedarbīgs, notikums."
    },
    { "id": 915, "title": "sedli",
      "level": 3, "definition": "Segli." },
    {
      "id": 916,
      "title": "segli",
      "level": 3,
      "definition": "Uz dzīvnieka, parasti zirga, muguras piestiprināma ierīce (ar ieliektu vidusdaļu) sēdēšanai vai kravas novietošanai."
    },
    {
      "id": 917,
      "title": "seifs",
      "level": 2,
      "definition": "Ugunsdrošs tērauda skapis, kaste, atvilktne (parasti ar speciālu slēdzeni) dokumentu, naudas, dārglietu u. tml. glabāšanai."
    },
    {
      "id": 918,
      "title": "seims",
      "level": 3,
      "definition": "Kārtu pārstāvības institūcija (Polijas-Lietuvas valstī)."
    },
    {
      "id": 919,
      "title": "sekas",
      "level": 1,
      "definition": "Parādība, ko nepieciešami rada, izraisa cita parādība."
    },
    { "id": 920, "title": "sekss", "level": 3, "definition": "Dzimums." },
    {
      "id": 921,
      "title": "sekta",
      "level": 3,
      "definition": "Savrupa reliģiska draudze, savrups reliģisks grupējums, kas ir nošķīries no kādas galvenās, valdošās baznīcas, reliģijas, saglabājot tās elementus."
    },
    {
      "id": 922,
      "title": "selga",
      "level": 3,
      "definition": "Dziļa vieta (parasti jūrā) tālu no krasta."
    },
    { "id": 923, "title": "sence", "level": 3, "definition": "Senči." },
    {
      "id": 924,
      "title": "sepse",
      "level": 3,
      "definition": "Organisma vispārēja smaga saindēšanās, kuras cēlonis ir strutas radošo mikroorganismu un to toksīnu cirkulācija asinīs un limfā."
    },
    {
      "id": 925,
      "title": "serde",
      "level": 1,
      "definition": "Cilindriska vidusdaļa (auga stumbram vai saknei), kas sastāv no irdeniem uzkrājējaudiem."
    },
    {
      "id": 926,
      "title": "serve",
      "level": 3,
      "definition": "Bumbas (bumbiņas) raidīšana pretinieka spēles laukumā pēc punkta izcīņas vai uzsākot spēli, setu (piemēram, tenisā, galda tenisā, volejbolā, badmintonā)."
    },
    {
      "id": 927,
      "title": "sesks",
      "level": 1,
      "definition": "Sermuļu dzimtas suga (\"Mustela putorius\"), neliels dzīvnieks ar slaidu ķermeni, pagaru asti un dziedzeriem, kas izdala sekrētu, kuram ir asa smaka."
    },
    {
      "id": 928,
      "title": "sēkla",
      "level": 1,
      "definition": "Sēklaugu vairošanās un izplatīšanās orgāns, kurā ir jaunā auga dīglis, tā attīstībai nepieciešamās barības vielas un apvalks; arī sauss auglis, tā daļa, kas parasti satur vienu šādu orgānu un ar ko pavairo augus sēklu iegūšanai."
    },
    {
      "id": 929,
      "title": "sēras",
      "level": 1,
      "definition": "Psihisks (emocionāls) stāvoklis, kas ir saistīts ar dziļām bēdām, ciešanām, skumjām, parasti sakarā ar kāda nāvi; šāda psihiska (emocionāla) stāvokļa izpausme."
    },
    {
      "id": 930,
      "title": "sērga",
      "level":1,
      "definition": "Slimība, parasti infekcioza; arī epidēmija."
    },
    {
      "id": 931,
      "title": "sfēra",
      "level": 2,
      "definition": "Telpas punktu kopa, kas atrodas noteiktā attālumā no dotā punkta."
    },
    {
      "id": 932,
      "title": "shēma",
      "level": 2,
      "definition": "Rasējums, zīmējums u. tml., kurā vispārināti ar pieņemtiem grafiskiem apzīmējumiem ir attēlota (kā) uzbūve, sastāvdaļu savstarpējās attiecības."
    },
    {
      "id": 933,
      "title": "sidrs",
      "level": 2,
      "definition": "Mazalkoholisks dzēriens, ko gatavo no raudzētas ābolu sulas."
    },
    {
      "id": 934,
      "title": "sieks",
      "level": 3,
      "definition": "Tilpuma mērvienība - aptuveni 0,26 kubikmetri (vecajā krievu mērvienību sistēmā)."
    },
    {
      "id": 935,
      "title": "siena",
      "level": 1,
      "definition": "Telpas vai telpiska veidojuma vertikālais (ārējais vai iekšējais) konstruktīvais norobežojums."
    },
    {
      "id": 936,
      "title": "siens",
      "level": 1,
      "definition": "Rupjā lopbarība - nopļauta, izkaltēta zāle, kas satur aptuveni 17 procentu ūdens."
    },
    {
      "id": 937,
      "title": "siers",
      "level": 1,
      "definition": "Pārtikas produkts, ko iegūst no piena, sarecinot to ar siera raugu vai ar pienskābes baktērijām."
    },
    {
      "id": 938,
      "title": "siets",
      "level": 2,
      "definition": "Rīks, ierīce, arī ierīces, iekārtas u. tml. detaļa, kurā ir vienmērīgi izveidoti caurumi un kuru izmanto, lai atdalītu (kā) mazākās daļiņas no lielākajām vai šķidrumu no cietajām daļiņām."
    },
    {
      "id": 939,
      "title": "sieva",
      "level": 1,
      "definition": "Precēta sieviete attiecībā pret savu vīru; dzīvesbiedre."
    },
    { "id": 940, "title": "sikhs", "level": 3, "definition": "Sikhu reliģijas sekotājs." },
    {
      "id": 941,
      "title": "siļķe",
      "level": 1,
      "definition": "Kaulzivju klases siļķveidīgo kārtas dzimta (\"Clupeidae\"), izplatīta gk. Atlantijas un Klusajā okeānā, 65 ģ., ~230 sugu, Baltijas jūrā konstatētas 3 ģ., 3 sugas - reņģe, brētliņa, palede."
    },
    {
      "id": 942,
      "title": "sirds",
      "level": 1,
      "definition": "Dobs asinsrites centrālais orgāns, kas ar muskuļu ritmisku darbību izraisa asins plūsmu pa asinsvadiem."
    },
    {
      "id": 943,
      "title": "sīlis",
      "level": 2,
      "definition": "Putnu klases zvirbuļveidīgo kārtas zvirbuļputnu (dziedātājputnu) apakškārtas vārnu dzimtas atsevišķas sugas."
    },
    {
      "id": 944,
      "title": "skala",
      "level": 3,
      "definition": "Detaļa (ierīcē, iekārtā u. tml.) ar iedaļām."
    },
    {
      "id": 945,
      "title": "skals",
      "level": 2,
      "definition": "Gara, plāna, samērā šaura koksnes plāksne (parasti apgaismošanas ierīcēm, iekuriem, arī pinumiem)."
    },
    {
      "id": 946,
      "title": "skaņa",
      "level": 1,
      "definition": "Mehāniskas svārstības, kas elastīgu viļņu veidā izplatās cietā, šķidrā vai gāzveida vidē; šādas svārstības, kas rada dzirdes sajūtas."
    },
    {
      "id": 947,
      "title": "skara",
      "level": 2,
      "definition": "Ķekars, kura galvenajai asij ir sānu asis ar vienkāršas vārpas vai ķekara uzbūvi."
    },
    {
      "id": 948,
      "title": "skate",
      "level": 2,
      "definition": "Pasākums, kura mērķis ir publiski demonstrēt (kā, piemēram, mākslas darbu, zinātnes un tehnikas sasniegumu, priekšmetu) kopumu; publiskai demonstrēšanai izvietotais (kā) kopums; arī izstāde."
    },
    {
      "id": 949,
      "title": "skats",
      "level": 1,
      "definition": "Redzes lokā ietverama apkārtne, apkārtējā vide vai kāda, parasti plaša, tās daļa; arī aina ."
    },
    {
      "id": 950,
      "title": "skava",
      "level": 2,
      "definition": "Plakana, parasti leņķveidīgi vai lokveidīgi saliekta, detaļa, arī stienis ar nostiprinātiem galiem, piemēram, cauruļu nostiprināšanai, koka siju, pāļu u. tml. sastiprināšanai."
    },
    {
      "id": 951,
      "title": "skābe",
      "level": 1,
      "definition": "Ķīmisks savienojums, kas šķīdumā spēj atdot ūdeņraža jonus."
    },
    {
      "id": 952,
      "title": "skāde",
      "level": 1,
      "definition": "Kaitējums; arī zaudējums."
    },
    {
      "id": 953,
      "title": "skečs",
      "level": 3,
      "definition": "Īss humoristisks vai satīrisks dramaturģijas darbs, arī estrādes priekšnesums, parasti divām vai trim darbības personām."
    },
    {
      "id": 954,
      "title": "skice",
      "level": 2,
      "definition": "Attēls, kurā vispārināti, arī vienkāršoti, nedetalizēti ir fiksētas (kā veidojama, piemēram, mākslas darba, celtnes) galvenās iezīmes; attēls, kurā vispārināti ir fiksēts kāds iespaids, iecere, ideja u. tml."
    },
    {
      "id": 955,
      "title": "skits",
      "level": 3,
      "definition": "Īss humoristiska vai satīriska rakstura literārs sacerējums; īss komiska rakstura uzvedums."
    },
    {
      "id": 956,
      "title": "skola",
      "level": 1,
      "definition": "Mācību un audzināšanas iestāde, parasti zemākās vai vidējās vispārējās, arī speciālās izglītības iegūšanai; celtne, kurā darbojas šāda iestāde."
    },
    { "id": 957, "title": "skuba",
      "level": 3, "definition": "Steiga." },
    { "id": 958, "title": "skuja",
      "level": 1, "definition": "Skujkoku adatveida lapa." },
    { "id": 959, "title": "skuķe",
      "level": 1, "definition": "Meitene; skuķis." },
    {
      "id": 960,
      "title": "slava",
      "level": 2,
      "definition": "Ļoti augsts, sabiedrībā vai tās daļā izplatīts (kāda cilvēka, cilvēku grupas, organizācijas darbības, īpašību) vērtējums."
    },
    {
      "id": 961,
      "title": "sleja",
      "level": 2,
      "definition": "Samērā šaurs, garens, taisns (kāda samērā plāna materiāla, piemēram, auduma, ādas) gabals; samērā šaura, garena, taisna josla (kādā materiālā)."
    },
    {
      "id": 962,
      "title": "slēgs",
      "level": 2,
      "definition": "Slēdzējierīce (kā) galu, malu u. tml. savienošanai; slēdzis (2)."
    },
    { "id": 963, "title": "slēpe",
      "level": 1, "definition": "Slēpes." },
    { "id": 964, "title": "slida",
      "level": 1, "definition": "Slidas." },
    {
      "id": 965,
      "title": "slita",
      "level": 3,
      "definition": "Horizontāli nostiprināts baļķis zirgu piesiešanai, parasti pajūgu stāvvietās."
    },
    {
      "id": 966,
      "title": "slīde",
      "level": 2,
      "definition": "Darbība, process --> slīdēt."
    },
    {
      "id": 967,
      "title": "slīpe",
      "level": 2,
      "definition": "Slīpā (jumta, tā seguma) daļa."
    },
    {
      "id": 968,
      "title": "slogs",
      "level": 2,
      "definition": "Attiecīga smaguma priekšmets, ko liek (kam) virsū, lai (to) sablīvētu, saspiestu."
    },
    {
      "id": 969,
      "title": "sloka",
      "level": 3,
      "definition": "Tārtiņveidīgo kārtas dzimta (\"Scolopacidae\"), nelieli vai vidēji lieli putni ar garu vai pagaru knābi, 23 ģ., 85 s., Latvijā konstatētas 13 ģ., 28 s."
    },
    {
      "id": 970,
      "title": "slota",
      "level": 1,
      "definition": "Rīks (piemēram, telpu, pagalmu, ielu) slaucīšanai - vienādā virzienā sakārtotu, samērā tievu zaru, arī stiebru saišķis, kurā (parasti) ir iestiprināts kāts."
    },
    {
      "id": 971,
      "title": "smaka",
      "level": 1,
      "definition": "Vielas ķīmiskā īpašība, ko uztver ar ožas analizatoriem un kas parasti izraisa nepatīkamu kairinājumu; attiecīgā ožas sajūta."
    },
    {
      "id": 972,
      "title": "smēde",
      "level": 2,
      "definition": "Kalēja darbnīca; kalve ."
    },
    { "id": 973, "title": "smēre",
      "level": 1, "definition": "Ziede." },
    { "id": 974, "title": "smērs",
      "level": 2, "definition": "Ziede." },
    {
      "id": 975,
      "title": "smīns",
      "level": 1,
      "definition": "Smaidam līdzīgs sejas daļu (lūpu, vaigu) kustību kopums, raksturīga izteiksme, ko izraisa nicinoša, noraidoša attieksme pret ko."
    },
    {
      "id": 976,
      "title": "smogs",
      "level": 2,
      "definition": "Intensīvs lielu pilsētu un rūpniecības centru gaisa piesārņojums; dūmu, gāzu, miglas u. tml. kopums, kas veido šādu piesārņojumu."
    },
    {
      "id": 977,
      "title": "snobs",
      "level": 3,
      "definition": "Cilvēks, kas cenšas sekot augstākās sabiedrības modei, gaumei, manierēm u. tml., nicinot tos, kas atrodas zemākā bagātības un sociālā stāvokļa līmenī."
    },
    {
      "id": 978,
      "title": "soģis",
      "level": 3,
      "definition": "Feodālismā - augstākais tiesnesis, teritorijas pārvaldnieks; arī fogts."
    },
    {
      "id": 979,
      "title": "soldo",
      "level": 3,
      "definition": "Naudas vienība (Itālijā līdz 1947. g.); attiecīgā naudas zīme, monēta."
    },
    {
      "id": 980,
      "title": "solis",
      "level": 1,
      "definition": "Kustības cikls (ejot, skrienot u. tml.), kurā kāju pārvieto uz citu atbalsta punktu un pārnes uz to ķermeņa svaru."
    },
    {
      "id": 981,
      "title": "sopka",
      "level": 3,
      "definition": "Kalns ar ieapaļu vai konusveida virsotni (Aizbaikālā, Tālajos Austrumos)."
    },
    {
      "id": 982,
      "title": "sorgo",
      "level": 3,
      "definition": "Graudzāļu dzimtas ģints (\"Sorghum\"), viengadīgi vai daudzgadīgi lakstaugi, ~50 s., gk. tropos un subtropos, Latvijā konstatētas 2 adventīvas sugas."
    },
    {
      "id": 983,
      "title": "spals",
      "level": 2,
      "definition": "Detaļa (piemēram, darbarīkam, instrumentam), kas ir paredzēta aptveršanai ar roku un parasti izveidota taisnā virzienā attiecībā pret darbīgās daļas asi."
    },
    {
      "id": 984,
      "title": "spars",
      "level": 2,
      "definition": "Dedzība, neatlaidība (darbībā, rīcībā)."
    },
    {
      "id": 985,
      "title": "spāre",
      "level": 1,
      "definition": "Viena no jumta seguma nesošām horizontālām vai slīpām detaļām."
    },
    {
      "id": 986,
      "title": "spēja",
      "level": 2,
      "definition": "Psihiska vai fiziska īpašība, šādu īpašību kopums (cilvēkam), kas (tam) rada iespēju ko sekmīgi darīt, veikt, arī uztvert ko, reaģēt uz ko."
    },
    {
      "id": 987,
      "title": "spēks",
      "level": 1,
      "definition": "Fizikāls lielums, kas raksturo ķermeņu mijiedarbību, kurā tie iegūst paātrinājumu vai deformējas."
    },
    {
      "id": 988,
      "title": "spēle",
      "level": 1,
      "definition": "Noteiktu darbību kopums, kam ir sacensības pazīmes un ar ko cenšas sasniegt vēlamo (ar sabiedriskiem vai ekonomiskiem mērķiem nesaistītu vai netieši saistītu) rezultātu, izmantojot prasmes, iemaņas, arī apstākļu nejaušu sakritību."
    },
    { "id": 989, "title": "spice",
      "level": 2, "definition": "Smaile." },
    {
      "id": 990,
      "title": "spins",
      "level": 3,
      "definition": "Elementārdaļiņu kustības daudzuma moments, kas tām piemīt neatkarīgi no to kustības."
    },
    {
      "id": 991,
      "title": "spīde",
      "level": 3,
      "definition": "Darbība, process --> spīdēt; arī spīdums ."
    },
    { "id": 992, "title": "spīle",
      "level": 3, "definition": "Spīles." },
    {
      "id": 993,
      "title": "spīts",
      "level": 2,
      "definition": "Psihes, rakstura, personības īpašība, kas izpaužas apzinātā, nepiekāpīgā izturēšanās, rīcības veidā, kurš krasi atšķiras no (kāda) vēlēšanās, norādījumiem, uzskatiem un kura mērķis parasti ir (tam) kaitēt, nodarīt ko nevēlamu; spītība ."
    },
    {
      "id": 994,
      "title": "spoks",
      "level": 1,
      "definition": "Ar mirušu cilvēku, retāk dzīvnieku saistīts redzes priekšstats, redzes iztēles tēls, ko parasti izraisa negatīvi sagrozīta īstenības uztvere un kas iedveš bailes; arī rēgs."
    },
    {
      "id": 995,
      "title": "spole",
      "level": 2,
      "definition": "Cilindrveida vai konusveida priekšmets, arī rotējoša detaļa, elements (ar paplatinājumu galos vai bez tā), uz kura ko uztin vai no kura ko notin; šāds priekšmets, arī detaļa, elements kopā ar tam uztīto materiālu."
    },
    {
      "id": 996,
      "title": "spora",
      "level": 2,
      "definition": "Dažu augstāko augu (sūnaugu, paparžaugu) un zemāko augu (aļģu, sēņu, ķērpju) vienšūnas veidojums, ar ko tie vairojas."
    },
    {
      "id": 997,
      "title": "spura",
      "level": 2,
      "definition": "Ūdensdzīvnieku (piemēram, zivju, abinieku, galvkāju) pārvietošanās orgāns."
    },
    {
      "id": 998,
      "title": "stabs",
      "level": 1,
      "definition": "Vertikāli kādā pamatnē iestiprināts baļķis vai tam pēc formas līdzīga konstrukcija."
    },
    {
      "id": 999,
      "title": "stara",
      "level": 2,
      "definition": "Bikšu daļa, kas aptver kāju."
    },
    {
      "id": 1000,
      "title": "stars",
      "level": 1,
      "definition": "Šaura redzama gaismas izplatīšanās josla."
    },
    {
      "id": 1001,
      "title": "stats",
      "level": 3,
      "definition": "Saslietu (labības, linu) kūļu kopa; statiņš (2)."
    },
    {
      "id": 1002,
      "title": "stāds",
      "level": 1,
      "definition": "Jauns, parasti neliels, augs, kas ir izaudzēts vai izaudzis no sēklas, spraudeņa, noliektņa u. tml. un ko pārstāda vai paredz pārstādīt pastāvīgā vietā."
    },
    {
      "id": 1003,
      "title": "stāja",
      "level": 1,
      "definition": "Dabiskais, parasti vertikālais, ķermeņa stāvoklis balstā uz kājām; noteikts ķermeņa stāvoklis, kas ir saistīts ar kādas darbības veikšanu."
    },
    {
      "id": 1004,
      "title": "stāžs",
      "level": 2,
      "definition": "Darbības ilgums (kādā nozarē); laiks, kas ir nepieciešams, lai, strādājot (kādā specialitātē), darbojoties (kādā organizācijā), iegūtu pieredzi, paaugstinātu kvalifikāciju, arī noteiktu piemērotību."
    },
    {
      "id": 1005,
      "title": "steks",
      "level": 2,
      "definition": "Aukstais (parasti policijas, milicijas) ierocis - paresna, neliela gumijas nūja."
    },
    {
      "id": 1006,
      "title": "stepe",
      "level": 2,
      "definition": "Veģetācijas tips, ko veido kserofili daudzgadīgi lakstaugi (piemēram, graudzāles, sīpolaugi) un kas rodas iekškontinentālos apvidos, mērenā un subtropu klimatā; teritorija, kur ir šāds veģetācijas tips."
    },
    {
      "id": 1007,
      "title": "steps",
      "level": 2,
      "definition": "Strauja deja ar ritmiskiem purngalu un papēžu piesitieniem; šīs dejas mūzika."
    },
    {
      "id": 1008,
      "title": "sters",
      "level": 2,
      "definition": "Grēdās sakrauta kokmateriālu (parasti malkas, žagaru) mērvienība - 1 kubikmetrs materiāla (ieskaitot gaisa spraugas); krāvummetrs."
    },
    {
      "id": 1009,
      "title": "stiba",
      "level": 3,
      "definition": "Tievs nolauzts zars; arī vica."
    },
    {
      "id": 1010,
      "title": "stiga",
      "level": 3,
      "definition": "Izcirsta josla mežā, kura atdala kvartālus, audzes u. tml. citu no cita."
    },
    {
      "id": 1011,
      "title": "stils",
      "level": 1,
      "definition": "Māksliniecisko izteiksmes līdzekļu kopums, daiļrades paņēmienu kopums, tēlu sistēmas īpatnības (piemēram, mākslas darbā, kāda autora daiļradē, tautas, laikmeta mākslā)."
    },
    {
      "id": 1012,
      "title": "stīga",
      "level": 2,
      "definition": "Auga vasa ar gariem guļošiem, ložņājošiem vai kāpelējošiem posmiem."
    },
    {
      "id": 1013,
      "title": "stīpa",
      "level": 3,
      "definition": "Riņķveida detaļa, ko uzvelk, parasti no dēlīšiem gatavotiem, koka traukiem."
    },
    {
      "id": 1014,
      "title": "stops",
      "level": 3,
      "definition": "Rokas ierocis šaušanai ar bultām - uz laides nostiprināts loks."
    },
    {
      "id": 1015,
      "title": "store",
      "level": 3,
      "definition": "Storveidīgo kārtas dzimta (\"Acispenseridae\"), 4 ģ., 24 s."
    },
    { "id": 1016, "title": "stute", "level": 2, "definition": "Balsts; balstkoks." },
    {
      "id": 1017,
      "title": "stūre",
      "level": 1,
      "definition": "Ierīce transportlīdzekļa kustības vadīšanai noteiktā virzienā; detaļa, kam ir, piemēram, rata, sviras forma un kas ir paredzēta šīs ierīces darbināšanai ar rokām vai kājām."
    },
    { "id": 1018, "title": "suits", "level": 3, "definition": "Suiti." },
    {
      "id": 1019,
      "title": "suķis",
      "level": 3,
      "definition": "Lauska, sasista trauka gabals."
    },
    {
      "id": 1020,
      "title": "summa",
      "level": 1,
      "definition": "Divu vai vairāku lielumu saskaitīšanas rezultāts; izteiksme, kuras locekļi ir savienoti ar plusa zīmi."
    },
    {
      "id": 1021,
      "title": "susla",
      "level": 3,
      "definition": "Dzēriens, kas satur maz vēlamo vielu; arī negaršīgs dzēriens."
    },
    { "id": 1022, "title": "sūbrs", "level": 3, "definition": "Sumbrs." },
    {
      "id": 1023,
      "title": "svars",
      "level": 1,
      "definition": "Spēks, ar kuru ķermenis Zemes (debess ķermeņa) gravitācijas lauka ietekmē iedarbojas uz balstu vai piekari."
    },
    {
      "id": 1024,
      "title": "svece",
      "level": 1,
      "definition": "Apgaismošanai paredzēts cilindrisks stearīna, parafīna, vaska, kausētu tauku veidojums ar dakti vidū."
    },
    {
      "id": 1025,
      "title": "sveķi",
      "level": 1,
      "definition": "Augu (retāk kukaiņu) vielmaiņas galaprodukts - bezkrāsains, dzeltens vai brūns, viskozs, gaisā sacietējošs šķidrums (dažkārt ar raksturīgu smaržu, garšu)."
    },
    {
      "id": 1026,
      "title": "svins",
      "level": 1,
      "definition": "Ķīmiskais elements - zilganpelēks, smags, mīksts, plastisks, viegli kūstošs metāls, periodiskās sistēmas 82. elements, Pb, atommasa - 207,2, zināmi 19 izotopi, no kuriem 4 ir stabili."
    },
    {
      "id": 1027,
      "title": "svira",
      "level": 2,
      "definition": "Vienkāršs mehānisms - ar statni kustīgi savienots ciets ķermenis, kas var pagriezties ap savienojuma ģeometrisko asi."
    },
    {
      "id": 1028,
      "title": "svīre",
      "level": 3,
      "definition": "Putnu klases svīrveidīgo kārtas dzimta (\"Apodidae\"), nelieli putni, garums - 10-18 cm, masa - līdz 60 g, 8-18 ģ., 67-82 s."
    },
    {
      "id": 1029,
      "title": "svīta",
      "level": 2,
      "definition": "Pavadoņu kopums (ievērojamai, augstai personai, parasti valdniekam)."
    },
    {
      "id": 1030,
      "title": "šahta",
      "level": 3,
      "definition": "Apakšzemes un virszemes būvju, ietaišu sistēma derīgo izrakteņu (parasti ogļu) ieguvei; kalnrūpniecības uzņēmuma ražošanas vienība, kas izmanto šādu sistēmu."
    },
    { "id": 1031, "title": "šalka", "level": 3, "definition": "Šņākoņa, žužinoša skaņa." },
    {
      "id": 1032,
      "title": "šalle",
      "level": 1,
      "definition": "Garens tekstilizstrādājums kakla, plecu, galvas segšanai."
    },
    {
      "id": 1033,
      "title": "šalts",
      "level": 2,
      "definition": "Spēcīgi, spēji plūstošs (šķidras vielas) kopums."
    },
    {
      "id": 1034,
      "title": "šarms",
      "level": 2,
      "definition": "Savdabīga, neatvairāma pievilcība, savdabīgs, neatvairāms valdzinājums (cilvēkam)."
    },
    {
      "id": 1035,
      "title": "šaržs",
      "level": 3,
      "definition": "Satīrisks vai humoristisks (kā) attēlojums (tēlotājas mākslas darbā), kurā ir izceltas, pārspīlētas (tā) raksturīgākās īpašības, pazīmes."
    },
    {
      "id": 1036,
      "title": "šeihs",
      "level": 3,
      "definition": "Arābu klejotāju cilts vai cilšu savienības galva."
    },
    {
      "id": 1037,
      "title": "šelfs",
      "level": 3,
      "definition": "Seklūdens josla ap kontinentu starp jūras krastu un vietu, kur sākas krasta dziļuma nogāze."
    },
    {
      "id": 1038,
      "title": "šēras",
      "level": 3,
      "definition": "Nelielas klinšainas salas un pussalas jūrās un ezeros kādreizējā apledojuma apgabalos (Karēlijā, Somijā, Zviedrijā, Norvēģijā, Kanādā u. c.), to krasti ir stipri izroboti, ar daudziem līčiem un jomām."
    },
    {
      "id": 1039,
      "title": "šifrs",
      "level": 3,
      "definition": "Iepriekš norunāta burtu, ciparu, vārdu u. tml. lietošanas sistēma slepenai informācijas fiksēšanai, pārraidei."
    },
    {
      "id": 1040,
      "title": "šihta",
      "level": 3,
      "definition": "Speciāli sagatavots un noteiktās attiecībās sajaukts materiālu maisījums, kas paredzēts pārstrādāšanai, piemēram, metalurģiskos, ķīmiskos agregātos."
    },
    {
      "id": 1041,
      "title": "šiīts",
      "level": 3,
      "definition": "Šiisma piekritējs; musulmanis, kas par kalifiem atzīst tikai pravieša noteiktos cilvēkus."
    },
    {
      "id": 1042,
      "title": "šilte",
      "level": 3,
      "definition": "Plāksnīte ar uzrakstu; izkārtne."
    },
    {
      "id": 1043,
      "title": "širas",
      "level": 3,
      "definition": "No siksnām darināts zirga aizjūga piederums (bezloka aizjūgos), ko lieto saku vietā."
    },
    {
      "id": 1044,
      "title": "šķēle",
      "level": 1,
      "definition": "No pārtikas produkta (piemēram, maizes klaipa, gaļas, siera) atdalīts samērā plāns gabals."
    },
    {
      "id": 1045,
      "title": "šķēps",
      "level": 1,
      "definition": "Duramais vai metamais ierocis - samērā garš stienis ar uzasinātu galu vai smailu uzgali."
    },
    {
      "id": 1046,
      "title": "šķila",
      "level": 3,
      "definition": "Samērā liels (no kā) nošķelts gabals."
    },
    {
      "id": 1047,
      "title": "šķira",
      "level": 2,
      "definition": "Pēc noteiktām kvalitātes pazīmēm veidota (vienveidīgu priekšmetu, vielu u. tml.) grupa."
    },
    { "id": 1048, "title": "šķore", "level": 3, "definition": "Kore ." },
    {
      "id": 1049,
      "title": "šķūre",
      "level": 3,
      "definition": "Ierīce, iekārta, arī rīks (kā) pārvietošanai bīdot, arī (kā) līdzināšanai, tīrīšanai."
    },
    {
      "id": 1050,
      "title": "šļute",
      "level": 3,
      "definition": "Plats, plāns cirvis tēsto kokmateriālu gatavošanai; platcirvis."
    },
    {
      "id": 1051,
      "title": "šļūce",
      "level": 3,
      "definition": "Rīks, piemēram, lauka virsmas līdzināšanai, augsnes virskārtas drupināšanai."
    },
    {
      "id": 1052,
      "title": "šļūde",
      "level": 3,
      "definition": "Trauks vai bedre, kur salej netīro ūdeni."
    },
    { "id": 1053, "title": "šmīze", "level": 3, "definition": "Iznesīga meitene." },
    { "id": 1054, "title": "šmuce", "level": 2,"definition": "Netīrumi; netīrība." },
    { "id": 1055, "title": "šņore", "level": 3, "definition": "Aukla." },
    {
      "id": 1056,
      "title": "šoras",
      "level": 3,
      "definition": "Širas - no siksnām darināts zirga aizjūga piederums (bezloka aizjūgos), ko lieto saku vietā."
    },
    {
      "id": 1057,
      "title": "šorti",
      "level": 1,
      "definition": "Virsbikses, kas nesniedzas zemāk par ceļgaliem; īsbikses."
    },
    {
      "id": 1058,
      "title": "špaga",
      "level": 3,
      "definition": "Paukošanas ierocis ar elastīgu trīsšķautņu asmeni, kam ir uzskrūvējams uzgalis."
    },
    {
      "id": 1059,
      "title": "špats",
      "level": 3,
      "definition": "Špati - caurspīdīgi minerāli ar labu skaldnību; ietilpst vairāku minerālu nosaukumos, piem., laukšpats, Islandes špats."
    },
    {
      "id": 1060,
      "title": "špics",
      "level": 3,
      "definition": "Neliels dekoratīvs suns, kam raksturīgs pasmails, īss purns, mazas, stāvas, trīsstūrveida ausis, gredzenā saritināta aste un biezs, garš, taisns apmatojums; attiecīgā suņu šķirne."
    },
    {
      "id": 1061,
      "title": "štats",
      "level": 3,
      "definition": "Darbinieku skaitliskais sastāvs (iestādē, uzņēmumā, organizācijā u. tml.) ar noteiktiem amatiem un algām."
    },
    {
      "id": 1062,
      "title": "štābs",
      "level": 2,
      "definition": "Galvenā karaspēka vadības institūcija."
    },
    {
      "id": 1063,
      "title": "šunts",
      "level": 3,
      "definition": "Elektrības vadītājs vai magnētvads, ko pieslēdz paralēli elektriskās vai magnētiskās ķēdes posmam, lai daļa strāvas vai magnētiskās plūsmas apietu ķēdes posmu pa izveidoto paralēlo atzarojumu."
    },
    {
      "id": 1064,
      "title": "šūpas",
      "level": 3,
      "definition": "Darbība, process --> šūpot , šūpoties ."
    },
    {
      "id": 1065,
      "title": "švīka",
      "level": 1,
      "definition": "Svītra, parasti samērā plata, nenoteikta."
    },
    {
      "id": 1066,
      "title": "švīts",
      "level": 2,
      "definition": "Švītīgs vīrietis; iedomīgi grezns, ārīgi smalks."
    },
    {
      "id": 1067,
      "title": "tablo",
      "level": 2,
      "definition": "Iekārta, uz kuras virsmas, ekrāna u. tml. veido maināmus signālus, tekstus operatīvai informācijai."
    },
    {
      "id": 1068,
      "title": "tacis",
      "level": 3,
      "definition": "Pasīvās zvejas rīks, ko ierīko aizsprosta veidā upju seklajās vietās migrējošo ūdensdzīvnieku (parasti nēģu, lašu) ceļos."
    },
    {
      "id": 1069,
      "title": "tafts",
      "level": 3,
      "definition": "Blīvs, plāns, blāvi spožs kokvilnas vai mākslīgā zīda audums."
    },
    {
      "id": 1070,
      "title": "tahta",
      "level": 3,
      "definition": "Mīksta mēbele sēdēšanai, arī gulēšanai, parasti bez atzveltnes vai ar nelielu atzveltni."
    },
    {
      "id": 1071,
      "title": "taiga",
      "level": 2,
      "definition": "Veģetācijas tips, kurā dominē skujkoku meži (Eiropas, Āzijas, Amerikas kontinenta mērenajās zonās, kalnos); šāda veģetācijas tipa mežs."
    },
    {
      "id": 1072,
      "title": "takse",
      "level": 3,
      "definition": "Noteikta maksa, atlīdzība, parasti naudas izteiksmē."
    },
    {
      "id": 1073,
      "title": "takts",
      "level": 2,
      "definition": "Skaņdarba posms no vienas uzsvērtas metra daļas līdz nākamajai metra daļai, kam ir tāds pats uzsvērums; skaņdarba posms starp divām taktssvītrām."
    },
    {
      "id": 1074,
      "title": "talka",
      "level": 1,
      "definition": "Kopēja darba veikšana brīvprātīgi, bez atlīdzības (parasti pēc aicinājuma), lai sniegtu palīdzību (kādam cilvēkam, saimniecībai u. tml.)."
    },
    {
      "id": 1075,
      "title": "talks",
      "level": 2,
      "definition": "Balts vai iezaļgans, pēc taustes taukains silikātu grupas minerāls; pārtikas piedeva E553b (magnija silikāts), pretsalipes viela, var radīt kuņģa problēmas, veicināt vēzi (kuņģa un olvadu), veicināt klepu, vemšanu, radīt elpošanas problēmas."
    },
    {
      "id": 1076,
      "title": "taļļa",
      "level": 3,
      "definition": "Jostasvieta (cilvēka ķermenim)."
    },
    {
      "id": 1077,
      "title": "tango",
      "level": 2,
      "definition": "Viesību deja (2/4 taktsmērā), kam ir raksturīgs lēns, slīdošs solis, spriegas kustības; šīs dejas mūzika."
    },
    {
      "id": 1078,
      "title": "tanks",
      "level": 1,
      "definition": "Kāpurķēžu kaujas mašīna, kuras konstrukcijai ir raksturīgs bruņu korpuss, tornis, spēcīga bruņojuma komplekss."
    },
    {
      "id": 1079,
      "title": "tante",
      "level": 1,
      "definition": "Tēvamāsa vai mātesmāsa; tēvabrāļa vai mātesbrāļa sieva."
    },
    {
      "id": 1080,
      "title": "tarba",
      "level": 2,
      "definition": "No (parasti) auduma šūta kule; zirgam kaklā karams auzu maiss."
    },
    {
      "id": 1081,
      "title": "tauki",
      "level": 1,
      "definition": "Ūdenī nešķīstoši un par ūdeni vieglāki glicerīna un taukskābju esteri, kas ietilpst dzīvo organismu sastāvā."
    },
    {
      "id": 1082,
      "title": "taure",
      "level": 2,
      "definition": "Sens pūšamais mūzikas instruments, arī signalizācijas instruments (parasti ar konusveidīgi paplašinātu galu), kuram nav skaņu caurumu un ar kuru var iegūt tikai dabiskās skaņurindas skaņas."
    },
    {
      "id": 1083,
      "title": "taurs",
      "level": 2,
      "definition": "Dobradžu dzimtas suga (\"Bos primigenius\"), izmiris dzīvnieks (mājas govs priekštecis), domesticēts 8.-6. gt. p. m. ē., pēdējais iznīcināts 1627. g. Polijā, bet 20. gs., izmantojot atgriezenisko selekciju un krustojot dažādas mājas govju šķirnes, ir selekcionēta govju šķirne \"Auroxen\" jeb taurgovs."
    },
    {
      "id": 1084,
      "title": "tauta",
      "level": 1,
      "definition": "Vēsturiski izveidojusies cilvēku kopība (nācija, tautība, radniecīgu cilšu grupa u. tml.), kurai raksturīga, piemēram, kopīga valoda, psihiskā struktūra, arī teritorija."
    },
    { "id": 1085, "title": "tauva",
      "level": 2, "definition": "Resna, vīta virve, trose." },
    {
      "id": 1086,
      "title": "tārps",
      "level": 1,
      "definition": "Dzīvnieks, kas pieder pie kāda no bezmugurkaulnieku tipiem (piemēram, plakantārpiem, velteņtārpiem, posmtārpiem); vairāku bezmugurkalnieku tipu kopīgs nosaukums (\"Vermes\")."
    },
    {
      "id": 1087,
      "title": "tehno",
      "level": 3,
      "definition": "Elektroniskās mūzikas stils, intensīva deju mūzika, attīstās kopš 20. gs. 80. gadiem; tehniskā mūzika."
    },
    {
      "id": 1088,
      "title": "teika",
      "level": 1,
      "definition": "Vēstītājas folkloras sacerējums, kurā ir apvienots reālais un fantastiskais un kuram piemīt izziņas raksturs; attiecīgais vēstītājas folkloras žanrs."
    },
    {
      "id": 1089,
      "title": "tekne",
      "level": 2,
      "definition": "Gara, samērā šaura cauruļveida ierīce, parasti šķidru vai beramu vielu novadīšanai."
    },
    { "id": 1090, "title": "teķis", "level": 3, "definition": "Aitu tēviņš." },
    {
      "id": 1091,
      "title": "telpa",
      "level": 1,
      "definition": "Ar būvkonstrukcijām norobežota (celtnes) daļa."
    },
    {
      "id": 1092,
      "title": "telts",
      "level": 1,
      "definition": "No viegla materiāla (piemēram, no ūdensnecaurlaidīga auduma, zariem) veidota pagaidu mītne (parasti ar slīpām sānu dalām)."
    },
    {
      "id": 1093,
      "title": "temps",
      "level": 1,
      "definition": "Ātrums (norisei, darbībai u. tml.)."
    },
    {
      "id": 1094,
      "title": "tenge",
      "level": 3,
      "definition": "Naudas vienība Kazahstānas Republikā, sīknauda - tiņa."
    },
    { "id": 1095, "title": "tenka",
      "level": 2, "definition": "Runa, pļāpa; tenkas." },
    {
      "id": 1096,
      "title": "terca",
      "level": 3,
      "definition": "Intervāls - trīs vai četri pustoņi."
    },
    {
      "id": 1097,
      "title": "terce",
      "level": 3,
      "definition": "Trešais tonis gammā, arī tam atbilstošais intervāls; terca."
    },
    {
      "id": 1098,
      "title": "terms",
      "level": 3,
      "definition": "Objekta apzīmējums ar matemātikas valodas līdzekļiem."
    },
    {
      "id": 1099,
      "title": "tests",
      "level": 1,
      "definition": "Standartizēta darbība, darbību kopums, arī darbību programma (kā) pārbaudei, defektu konstatēšanai."
    },
    {
      "id": 1100,
      "title": "tērce",
      "level": 3,
      "definition": "Neliela ūdenstece (bez noteikti izveidotas gultnes), kas parasti rodas, tekot kūstoša sniega ūdenim; mitra, staigna ieplaka, pa kuru (parasti pavasaros vai lietus uzplūdienos) tek šāda ūdenstece."
    },
    {
      "id": 1101,
      "title": "tērps",
      "level": 1,
      "definition": "Apģērbs, apģērba gabalu komplekts valkāšanai īpašos, noteiktos (sadzīves, darba u. tml.) apstākļos."
    },
    {
      "id": 1102,
      "title": "tētis",
      "level": 1,
      "definition": "Vīrietis, kam ir bērns vai bērni; tēvs ."
    },
    { "id": 1103, "title": "tētus", "level": 3, "definition": "Tētis." },
    {
      "id": 1104,
      "title": "tiāra",
      "level": 3,
      "definition": "Augsta, ar trim kroņiem rotāta galvassega (pāvestam)."
    },
    {
      "id": 1105,
      "title": "tiesa",
      "level": 1,
      "definition": "Valsts institūcija, kas valsts vārdā likumā noteiktā kārtībā izskata civillietas un krimināllietas; celtne, telpas, kur darbojas šāda valsts institūcija."
    },
    {
      "id": 1106,
      "title": "tilde",
      "level": 2,
      "definition": "Diakritiska zīme, tehniska rakstu zīme (~)."
    },
    {
      "id": 1107,
      "title": "tills",
      "level": 3,
      "definition": "Viegls, caurspīdīgs kokvilnas vai sintētisks tīklveida audums."
    },
    {
      "id": 1108,
      "title": "tilts",
      "level": 1,
      "definition": "Inženiertehniska celtne ceļa pārvadei pār apvidus šķēršļiem (piemēram, pār upēm, gravām, ceļiem, apbūvēm)."
    },
    {
      "id": 1109,
      "title": "tinte",
      "level": 1,
      "definition": "Rakstīšanai paredzēts organisku krāsvielu šķīdums vai suspensija ar sabiezinātāja un konservanta piedevu."
    },
    {
      "id": 1110,
      "title": "titrs",
      "level": 3,
      "definition": "Kādas vielas koncentrācija noteiktā šķīduma tilpuma vienībā."
    },
    {
      "id": 1111,
      "title": "tīkls",
      "level": 1,
      "definition": "No samērā tieva materiāla (piemēram, tekstilšķiedras, stieples) darināts pinums, kam raksturīgi, parasti četrstūraini, elementi ar tukšu vidusdaļu; šāda pinuma gabals."
    },
    {
      "id": 1112,
      "title": "tīnis",
      "level": 1,
      "definition": "Pusaudzis, arī jaunietis (aptuveni līdz 19 gadu vecumam); tīneidžers."
    },
    {
      "id": 1113,
      "title": "tonis",
      "level": 1,
      "definition": "Periodisku svārstību radīta skaņa ar labi uztveramu augstumu; muzikāla skaņa."
    },
    {
      "id": 1114,
      "title": "tonna",
      "level": 2,
      "definition": "Masas (svara) mērvienība - 1000 kilogramu."
    },
    { "id": 1115, "title": "torss", "level": 3, "definition": "Cilvēka rumpis." },
    {
      "id": 1116,
      "title": "torte",
      "level": 1,
      "definition": "Samērā liels konditorejas izstrādājums, kas ir gatavots no izceptas mīklas kārtām ar pildījumu (piemēram, krēmu, augļu biezeņiem) un kam virsma parasti ir rotāta."
    },
    {
      "id": 1117,
      "title": "tosts",
      "level": 2,
      "definition": "Īsa uzruna, īsa apsveikuma runa (viesībās, sarīkojumos u. tml.), pēc kuras uzaicina iedzert par godu kādam, kam."
    },
    {
      "id": 1118,
      "title": "trans",
      "level": 3,
      "definition": "Bišu saimē - tēviņš, kura funkcija ir apaugļot bišu māti."
    },
    { "id": 1119, "title": "traps", "level": 3, "definition": "Kuģa kāpnes." },
    {
      "id": 1120,
      "title": "trase",
      "level": 2,
      "definition": "Līnija, kas, parasti projektā, iezīmē (ceļa, kanāla, komunikāciju u. tml.) novietojumu apvidū, vidē; apvidus, vides josla, kur tiks veidots vai atrodas (ceļš, kanāls, komunikācijas u. tml.)."
    },
    {
      "id": 1121,
      "title": "trata",
      "level": 3,
      "definition": "Rakstisks kreditora rīkojums parādniekam vai bankai samaksāt noteiktu naudas summu trešajai personai."
    },
    {
      "id": 1122,
      "title": "trāns",
      "level": 3,
      "definition": "Taukviela, ko iegūst no zivīm, apaļmutēm un jūras zīdītājdzīvniekiem."
    },
    {
      "id": 1123,
      "title": "treks",
      "level": 3,
      "definition": "Sporta būve riteņbraukšanas, motosporta, skriešanas sacensībām - noslēgts ovāls celiņš ar slīpu pamatu."
    },
    { "id": 1124, "title": "trepe",
      "level": 1, "definition": "Trepes." },
    {
      "id": 1125,
      "title": "trese",
      "level": 3,
      "definition": "Lentveida (parasti formas tērpa) uzšuve, apdare (parasti zelta vai sudraba krāsā); šādai uzšuvei, apdarei paredzēts veidojums."
    },
    {
      "id": 1126,
      "title": "trice",
      "level": 3,
      "definition": "Kravas ceļamais mehānisms, kas parasti sastāv no vairākiem trīšiem."
    },
    {
      "id": 1127,
      "title": "triko",
      "level": 3,
      "definition": "Īpašā tehnikā adīts audums (veļai, virsdrēbēm)."
    },
    {
      "id": 1128,
      "title": "triks",
      "level": 2,
      "definition": "Darbība, darbību kopums, kam nepieciešama īpaša veiklība un kas ir paredzēts pārsteiguma, izbrīnas u. tml. izraisīšanai (piemēram, akrobātikā, cirka mākslā)."
    },
    {
      "id": 1129,
      "title": "trimo",
      "level": 3,
      "definition": "Liels spogulis, kas ir veidots kā patstāvīgs telpas iekārtas priekšmets vai piestiprināts pie sienas."
    },
    {
      "id": 1130,
      "title": "trīce",
      "level": 2,
      "definition": "Darbība, process --> trīcēt ."
    },
    {
      "id": 1131,
      "title": "trops",
      "level": 3,
      "definition": "Viens no diviem iedomātiem riņķiem (uz Zemes virsmas vai pie debess sfēras), kas ir paralēls ekvatoram un atrodas no tā 23 grādu un 27 minūšu attālumā."
    },
    { "id": 1132, "title": "trose",
      "level": 2, "definition": "No stieplēm vīta virve." },
    { "id": 1133, "title": "trums", "level": 3, "definition": "Augonis." },
    {
      "id": 1134,
      "title": "trupa",
      "level": 3,
      "definition": "Noteiktai darbībai angažētu cilvēku grupa (parasti skatuves mākslā)."
    },
    {
      "id": 1135,
      "title": "trupe",
      "level": 3,
      "definition": "Darbība, process, arī rezultāts --> trupēt."
    },
    {
      "id": 1136,
      "title": "trūce",
      "level": 3,
      "definition": "Iekšējo orgānu vai dziļo audu izspiešanās zem ādas, muskuļos vai ķermeņa dobumos."
    },
    {
      "id": 1137,
      "title": "trūdi",
      "level": 3,
      "definition": "Organisko vielu dalīšanās, sairšanas produkti, kas radušies, trūdot, parasti bojā gājušiem, organismiem, to daļām."
    },
    {
      "id": 1138,
      "title": "trūds",
      "level": 3,
      "definition": "Sadalījušās organisko vielu atliekas (trūdvielas) saturoša aramzeme (irdne, augsne)."
    },
    {
      "id": 1139,
      "title": "tulks",
      "level": 1,
      "definition": "Tulkotājs, kas mutiski tulko tekstu no vienas valodas citā valodā; speciālists, kurš specilizējies runāta teksta tulkošanā mutvārdos."
    },
    {
      "id": 1140,
      "title": "tulpe",
      "level": 1,
      "definition": "Liliju dzimtas ģints (\"Tulipa\"), daudzgadīgs augs ar vienu ziedu, retāk ar vairākiem ziediem stublāja galā, >100 s., Latvijā ne visai bieži sastopama savvaļā pārgājusī meža tulpe, Latvijā audzē ~1000 šķirņu."
    },
    {
      "id": 1141,
      "title": "tumsa",
      "level": 1,
      "definition": "Stāvoklis (apkaimē, telpā, vidē), kad nav gaismas, apgaismojuma vai tas ir ļoti vājš."
    },
    {
      "id": 1142,
      "title": "turbo",
      "level": 3,
      "definition": "Paātrināts režīms; turborežīms."
    },
    {
      "id": 1143,
      "title": "turis",
      "level": 3,
      "definition": "Datorgrafikas un datorizdevniecības programmās - mazi, melni laukumi, kas parasti izvietoti ap katru objektu; velkot aiz tā, ar peles palīdzību var mainīt izvēlētā objekta novietojumu vai tā izmērus."
    },
    {
      "id": 1144,
      "title": "turza",
      "level": 2,
      "definition": "Papīra, tāss u. tml. materiāla veidojums neliela (kā, piemēram, produktu) daudzuma ievietošanai; arī tūta."
    },
    {
      "id": 1145,
      "title": "tūska",
      "level": 2,
      "definition": "Pārmērīga šķidruma uzkrāšanās organisma audos, dobumos."
    },
    {
      "id": 1146,
      "title": "tvans",
      "level": 2,
      "definition": "Oglekļa (II) oksīds - indīga bezkrāsaina gāze bez smakas (parasti kurināmā nepilnīgas sadegšanas produkts)."
    },
    {
      "id": 1147,
      "title": "tvīds",
      "level": 3,
      "definition": "Plāns vilnas vai pusvilnas audums (piemēram, starpsezonu mēteļiem, kostīmiem)."
    },
    {
      "id": 1148,
      "title": "ubags",
      "level": 1,
      "definition": "Cilvēks, kas sagādā eksistences līdzekļus ubagojot; arī nabags ."
    },
    {
      "id": 1149,
      "title": "uguns",
      "level": 1,
      "definition": "Redzamās gaismas un siltuma starojums, kas rodas līdz attiecīgajai temperatūrai sakarsētā, parasti liesmojošā, vielā, materiālā; arī liesma, liesmu kopums."
    },
    {
      "id": 1150,
      "title": "ukris",
      "level": 3,
      "definition": "Degungals, padegune; deguns kopā ar padeguni."
    },
    {
      "id": 1151,
      "title": "ulāns",
      "level": 3,
      "definition": "Vieglās kavalērijas karavīrs."
    },
    {
      "id": 1152,
      "title": "upene",
      "level": 1,
      "definition": "Melnā jāņoga - akmeņlauzīšu dzimtas jāņogu ģints suga (\"Ribes nigrum\"), savvaļas vai kultivēts krūms ar saldskābām melnām, brūnganām, zaļganām vai baltām ogām ķekaros."
    },
    {
      "id": 1153,
      "title": "urāns",
      "level": 2,
      "definition": "Ķīmiskais elements - ciets, smags, sudrabbalts radioaktīvs metāls, periodiskās sistēmas 92. elements, U, atommasa - 238,029, zināmi 14 radioaktīvie izotopi."
    },
    {
      "id": 1154,
      "title": "urbis",
      "level": 1,
      "definition": "Viena vai vairāku asmeņu, parasti cilindrveida, griezējinstruments caurumu, dobumu veidošanai vai paplašināšanai."
    },
    { "id": 1155, "title": "urdze", "level": 3, "definition": "Urga." },
    {
      "id": 1156,
      "title": "urīns",
      "level": 2,
      "definition": "Šķidrums, kas veidojas nierēs un pa urīnceļiem tiek izvadīts no organisma."
    },
    {
      "id": 1157,
      "title": "urķis",
      "level": 2,
      "definition": "Smails, parasti tievs, priekšmets (kā) bikstīšanai, rušināšanai u. tml.; arī kruķis; miets."
    },
    {
      "id": 1158,
      "title": "uzacs",
      "level": 1,
      "definition": "Apmatojuma lokveida josla virs acs dobuma."
    },
    {
      "id": 1159,
      "title": "uzeja",
      "level": 2,
      "definition": "Vieta, kas paredzēta nokļūšanai kur augšā."
    },
    {
      "id": 1160,
      "title": "ūbele",
      "level": 2,
      "definition": "Baložu dzimtas ģints (\"Streptopelia\"), neliels putns ar brūnu vai pelēku mugurpusi un garu, noapaļotu asti, kurai ir baltas malas, 16 sugu, Latvijā konstatētas 2 sugas."
    },
    {
      "id": 1161,
      "title": "ūdele",
      "level": 2,
      "definition": "Plēsēju kārtas sermuļu dzimtas ģints (\"Mustela\"), kas dzīvo ūdenstilpju krastos."
    },
    {
      "id": 1162,
      "title": "ūdens",
      "level": 1,
      "definition": "Ūdeņraža oksīds - šķidra viela (minerāls), kam nav garšas, smaržas, krāsas (biezākam slānim zilgana krāsa) un kas, parasti šķīdumu, maisījumu sastāva, ir plaši izplatīta ūdenstilpēs, augsnē, gaisā, organismos."
    },
    { "id": 1163, "title": "ūnija", "level": 3, "definition": "Apvienība, savienība." },
    {
      "id": 1164,
      "title": "vaids",
      "level": 3,
      "definition": "Izelpā radīta (parasti paklusa) balss skaņa (parasti aiz sāpēm, piepūles)."
    },
    {
      "id": 1165,
      "title": "vaigs",
      "level": 1,
      "definition": "Viena no divām sejas daļām, kas atrodas katrā pusē degunam starp aci un apakšžokli."
    },
    {
      "id": 1166,
      "title": "vaina",
      "level": 1,
      "definition": "Pēc likuma sodāms pārkāpums; nosodāma rīcība, arī rīcība, kā dēļ rodas kas nevēlams, kādi sarežģījumi."
    },
    { "id": 1167, "title": "vakts", "level": 3, "definition": "Sardze (3)." },
    {
      "id": 1168,
      "title": "valde",
      "level": 2,
      "definition": "Koleģiāls veidojums (vēlēts vai iecelts) organizācijas, iestādes u. tml. vadīšanai, arī administratīvs vai pašvaldības institūts."
    },
    {
      "id": 1169,
      "title": "valgs",
      "level": 2,
      "definition": "Virve, aukla, arī saite ar cilpu."
    },
    {
      "id": 1170,
      "title": "valis",
      "level": 1,
      "definition": "Zīdītāju klases kārta (\"Cetacea\"), kurā ietilpst lieli ūdensdzīvnieki ar elastīgu ādu, biezu zemādas tauku slāni un lokanu asti, kas beidzas ar horizontālu spuru (piemēram, kašaloti, narvaļi, delfīni), samērā lielu galvu, kam mutē ir vai nu raga plātnes (planktona kāšanai), vai zobi (zivju izmantošanai barībā, piemēram, kašalotiem, narvaļiem); vaļveidīgie."
    },
    {
      "id": 1171,
      "title": "valks",
      "level": 2,
      "definition": "Ikdienai paredzētais (parasti apģērbs)."
    },
    {
      "id": 1172,
      "title": "vanna",
      "level": 1,
      "definition": "Ietilpīgs, parasti garens, trauks (piemēram, skārda, koka), tilpe (piemēram, emaljēta čuguna) ar noapaļotām malām, kurā mazgājas vai ko mazgā."
    },
    {
      "id": 1173,
      "title": "varde",
      "level": 1,
      "definition": "Bezastaino abinieku kārtas dzimta (\"Ranidae\"), kurā ietilpst dzīvnieki ar masīvu ķermeni, platu galvu, gludu un mitru ādu, garām, lēkšanai un peldēšanai piemērotām pakaļkājām, 45 ģ., ~550 s., Latvijā konstatēta 1 ģ., 5 s."
    },
    {
      "id": 1174,
      "title": "varza",
      "level": 3,
      "definition": "Bars (cilvēku vai dzīvnieku), parasti neorganizēts, arī kādām normām neatbilstošs."
    },
    {
      "id": 1175,
      "title": "vasks",
      "level": 1,
      "definition": "Dabiska vai sintētiska taukveida, amorfa, plastiska, viegli kūstoša viela, kuras galvenā sastāvdaļa ir augstāko taukskābju un augstāko vienvērtīgo (retāk divvērtīgo) spirtu esteri."
    },
    {
      "id": 1176,
      "title": "važas",
      "level": 3,
      "definition": "Kustīgi savienotu (piemēram, savērtu) gredzenveida, ovālu u. tml. (parasti metāla) detaļu virkne; ķēde; važa."
    },
    { "id": 1177, "title": "vāģis",
      "level": 1, "definition": "Rati." },
    {
      "id": 1178,
      "title": "vārds",
      "level": 1,
      "definition": "Mazākā patstāvīgā strukturāli semantiska valodas pamatvienība, kas apzīmē kādu priekšmetu, parādību, norisi, pazīmi, attieksmi starp tiem."
    },
    {
      "id": 1179,
      "title": "vārna",
      "level": 1,
      "definition": "Zvirbuļveidīgo kārtas dziedātājputnu apakškārtas dzimta (\"Corvidae\"), pie kuras pieder vārnas, kovārņi, krauķi, kraukļi, 26-29 ģ., 104-112 s., Latvijā konstatētas 5 ģ., 8 s."
    },
    {
      "id": 1180,
      "title": "vārpa",
      "level": 2,
      "definition": "Ziedkopa ar pagarinātu galveno asi, uz kuras atrodas sēdoši ziedi; graudaugu (labības) ziedkopa."
    },
    {
      "id": 1181,
      "title": "vārti",
      "level": 1,
      "definition": "Caurstaigājama, caurbraucama samērā liela aile, brīva vieta (kādas teritorijas, celtnes, uzņēmuma u. tml.) nožogojumā, arī celtnē kopā ar veramu, bīdāmu u. tml. daļu šīs ailes, vietas aizdarīšanai."
    },
    { "id": 1182, "title": "vecis",
      "level": 1, "definition": "Vecs vīrietis." },
    {
      "id": 1183,
      "title": "veģis",
      "level": 3,
      "definition": "Noteiktas formas baltmaizes mīklas izstrādājums."
    },
    { "id": 1184, "title": "veice",
      "level": 3, "definition": "Spēja, veikums." },
    {
      "id": 1185,
      "title": "veids",
      "level": 2,
      "definition": "Viena no vairākām (kā) eksistences izpausmēm."
    },
    { "id": 1186, "title": "velce", "level": 3, "definition": "Darbība --> vilkt." },
    { "id": 1187, "title": "velis",
      "level": 2, "definition": "Veļi." },
    {
      "id": 1188,
      "title": "velki",
      "level": 3,
      "definition": "Pavedienu kopums, kas ir novietots auduma garenvirzienā; šķēri."
    },
    {
      "id": 1189,
      "title": "velns",
      "level": 1,
      "definition": "Ļaunais gars, ļauno garu valdnieks, ko vaino grēku, nelaimju radīšanā; sātans."
    },
    {
      "id": 1190,
      "title": "velte",
      "level": 1,
      "definition": "Tas, ko dāvina, tas, kas ir uzdāvināts; dāvana."
    },
    {
      "id": 1191,
      "title": "velve",
      "level": 3,
      "definition": "Arkveida būvkonstrukcija telpas vai tās daļas pārsegšanai."
    },
    {
      "id": 1192,
      "title": "verbs",
      "level": 3,
      "definition": "Vārdšķira, pie kuras pieder lokāmi vārdi, kas apzīmē darbību vai stāvokli; šīs vārdšķiras vārds; darbības vārds."
    },
    {
      "id": 1193,
      "title": "vergs",
      "level": 1,
      "definition": "Cilvēks (verdzības iekārtā), kas ir vergtura īpašums."
    },
    {
      "id": 1194,
      "title": "veste",
      "level": 1,
      "definition": "Parasti zem žaketes valkājams vīriešu apģērba gabals, kas sedz ķermeņa augšdaļu aptuveni krūšu kurvja joslā un kam nav apkakles un piedurkņu; šādas formas apģērba gabals sievietēm."
    },
    {
      "id": 1195,
      "title": "vēdas",
      "level": 3,
      "definition": "Vissenākie indiešu literatūras teksti, kas sarakstīti sanskritā (sākot no 15. gs. p. m. ē.), hinduisma svētās grāmatas."
    },
    {
      "id": 1196,
      "title": "vēlme",
      "level": 2,
      "definition": "Vēlēšanās; tas, ko (kāds) vēlas."
    },
    {
      "id": 1197,
      "title": "vēris",
      "level": 3,
      "definition": "Sausieņu meža augšanas apstākļu tips (\"Oxalidosa\"), mežs, kurā aug egļu tīraudze vai egļu audze ar bērzu, apšu un baltalkšņu piemistrojumu, retāk bērzu, apšu, baltalkšņa tīraudze vai bērzu, apšu, baltalkšņu audze ar egļu piemistrojumu; attiecīgais meža augšanas apstākļu tips."
    },
    {
      "id": 1198,
      "title": "vērpe",
      "level": 3,
      "definition": "Deformācija, kas rodas, ja uz stieni, kura viens gals ir nostiprināts, iedarbojas spēku pāris, kas atrodas pret stieni perpendikulārā plaknē."
    },
    {
      "id": 1199,
      "title": "vēsma",
      "level": 2,
      "definition": "Lēna gaisa plūsma; arī lēns vējš."
    },
    { "id": 1200, "title": "vēsts",
      "level": 1, "definition": "Ziņa, arī paziņojums." },
    {
      "id": 1201,
      "title": "vētra",
      "level": 1,
      "definition": "Ļoti stiprs vējš, kas izraisa spēcīgu jūras viļņošanos un postījumus uz sauszemes (9 balles pēc Boforta skalas - 20,8-24,4 m/sek., bet plašākā nozīmē - 8-11 balles pēc Boforta skalas, t. i. 17,2-32,6 m/sek.)."
    },
    {
      "id": 1202,
      "title": "vēzis",
      "level": 1,
      "definition": "Posmkāju tipa žaunaiņu apakštipa klase (\"Crustacea\"), >40 tk sugu, kas pieder pie vairākām apakšklasēm, Latvijā pārstāvētas 4 apakšklases."
    },
    {
      "id": 1203,
      "title": "video",
      "level": 1,
      "definition": "Elektroniskais attēls, ko rada ar videotehniku."
    },
    {
      "id": 1204,
      "title": "vidus",
      "level": 1,
      "definition": "Vieta, daļa (kam), kas atrodas aptuveni vienādā attālumā no (tā) malām, pusēm, galiem."
    },
    { "id": 1205, "title": "viela",
      "level": 1, "definition": "Matērija." },
    {
      "id": 1206,
      "title": "vieta",
      "level": 1,
      "definition": "Apvidus, platības u. tml. daļa zemes virsmai, teritorijai, kurā kas pastāv, atrodas, notiek, arī ir pastāvējis, atradīsies, varētu notikt u. tml."
    },
    {
      "id": 1207,
      "title": "vilce",
      "level": 3,
      "definition": "Vilcējspēks , šāda spēka avots."
    },
    {
      "id": 1208,
      "title": "vilks",
      "level": 1,
      "definition": "Plēsēju kārtas suņu dzimtas suga (\"Canis lupus\"), dzīvnieks ar spēcīgi attīstītu ķermeni, garām, spēcīgām kājām, garu, kuplu asti un stāvām ausīm ar melnu apmali."
    },
    {
      "id": 1209,
      "title": "villa",
      "level": 1,
      "definition": "Grezna vasarnīca, māja, parasti ārpus pilsētas."
    },
    {
      "id": 1210,
      "title": "vilna",
      "level": 1,
      "definition": "Apmatojums, ko veido smalki, bieži spirālē savīti, mati (zīdītājdzīvniekiem - aitai, kazai, kamielim u. tml.); arī no šāda apmatojuma iegūta šķiedra."
    },
    {
      "id": 1211,
      "title": "vimba",
      "level": 2,
      "definition": "Karpu dzimtas suga (\"Vimba vimba\", senāk \"Abramis vimba\"), saldūdens zivs ar dzeltenīgām spurām un lejup vērstu muti."
    },
    {
      "id": 1212,
      "title": "vinča",
      "level": 3,
      "definition": "Mehānisms ar spoli un trosi smaguma celšanai un pārvietošanai."
    },
    {
      "id": 1213,
      "title": "vinda",
      "level": 3,
      "definition": "Svira ūdens spaiņa izcelšanai no akas."
    },
    { "id": 1214, "title": "virca",
      "level": 2, "definition": "Šķidrie kūtsmēsli." },
    { "id": 1215, "title": "virce", "level": 3, "definition": "Virces." },
    { "id": 1216, "title": "virma", "level": 3, "definition": "Virmojums ." },
    {
      "id": 1217,
      "title": "virpa",
      "level": 2,
      "definition": "Griezējmašīna, kam ir rotējoša apstrādes detaļa, sagatave."
    },
    {
      "id": 1218,
      "title": "virsa",
      "level": 1,
      "definition": "Virsējā, augšējā daļa (piemēram, priekšmetam, veidojumam)."
    },
    {
      "id": 1219,
      "title": "virve",
      "level": 1,
      "definition": "Samērā resns, parasti tekstilšķiedru, auklu, savijums."
    },
    {
      "id": 1220,
      "title": "virza",
      "level": 3,
      "definition": "Neļķu dzimtas ģints (\"Stellaria\"), lakstaugs ar ložņājošu sakneni un gulošu vai pacilā stublāju, pretējām lapām un baltiem ziediem."
    },
    {
      "id": 1221,
      "title": "virze",
      "level": 2,
      "definition": "Ķermeņa taisnvirziena kustība."
    },
    {
      "id": 1222,
      "title": "vista",
      "level": 1,
      "definition": "Vistveidīgo kārtas fazānputnu dzimtas ģints (\"Gallus\"), 4 sugas."
    },
    { "id": 1223, "title": "vists", "level": 3, "definition": "Kāršu spēle." },
    {
      "id": 1224,
      "title": "vizla",
      "level": 3,
      "definition": "Silikātu grupas minerāls, parasti ar plākšņainu uzbūvi, sastopams magmatisko, metamorfo un noguluma iežu sastāvā."
    },
    {
      "id": 1225,
      "title": "vizma",
      "level": 2,
      "definition": "Rezultāts --> vizmot; arī vizmojums."
    },
    {
      "id": 1226,
      "title": "vižņi",
      "level": 2,
      "definition": "Uz ūdens virsas uzpeldējis ūdeņu ledus, kas veidojas tekošā pārdzesētā ūdenī, kā arī no ūdenī iekrituša sniega un malasledus atlūzām."
    },
    {
      "id": 1227,
      "title": "vīķis",
      "level": 3,
      "definition": "Tauriņziežu dzimtas ģints (\"Vicia\"), viengadīgs, divgadīgs vai daudzgadīgs augs ar pamīšus sakārtotām lapām un gaiši violetiem ziediem."
    },
    {
      "id": 1228,
      "title": "vītne",
      "level": 2,
      "definition": "Garens vijums, savīta virkne (parasti no ziediem, zaļumiem kā izgreznošanai); vijīgu augu, to daļu, arī saistītu priekšmetu garens kopums."
    },
    {
      "id": 1229,
      "title": "vobla",
      "level": 3,
      "definition": "Apmēram 20 cm gara karpveidīgo kārtas zivs, ko parasti lieto sālītā, kūpinātā vai kaltētā veidā."
    },
    {
      "id": 1230,
      "title": "volts",
      "level": 3,
      "definition": "Elektriskā sprieguma, elektriskā potenciāla, elektrisko potenciālu starpības un elektrodzinējspēka mērvienība; apzīmējums - V."
    },
    {
      "id": 1231,
      "title": "vraks",
      "level": 2,
      "definition": "Sapostīts, līdz pilnīgai nederīguma pakāpei nolietots kuģis, arī lidaparāts, arī (tā) atliekas, kas pamatos saglabājušas savu ārējo formu."
    },
    {
      "id": 1232,
      "title": "zaimi",
      "level": 3,
      "definition": "Sarkastisks izsmiekls, ļaunas, cilvēka cieņu pazemojošas nievas."
    },
    {
      "id": 1233,
      "title": "zaķis",
      "level": 1,
      "definition": "Zīdītāju klases zaķveidīgo kārtas dzimta (\"Leporidae\"), vidēji liels savvaļas dzīvnieks ar garām ausīm, pagarinātām pakaļkājām un īsu asti, 10 ģ., 45-47 s., Latvijā konstatēta 1 ģ., 2 sugas."
    },
    {
      "id": 1234,
      "title": "zalve",
      "level": 2,
      "definition": "Vairāku viena veida ieroču vienlaicīgu šāvienu kopums; šādu vienlaicīgu šāvienu radīts troksnis."
    },
    {
      "id": 1235,
      "title": "zampa",
      "level": 2,
      "definition": "Šķidri, izmiekšķējušies mēsli (parasti kūtsmēsli); vieta, kur ir šādi mēsli."
    },
    {
      "id": 1236,
      "title": "zamšs",
      "level": 3,
      "definition": "Mīksta, īpaši izstrādāta plūksnaina āda."
    },
    { "id": 1237, "title": "zarna",
      "level": 1, "definition": "Zarnas." },
    {
      "id": 1238,
      "title": "zāģis",
      "level": 1,
      "definition": "Daudzasmeņu griezējinstruments, kura asmeņi izvietoti plātnes, lentes, diska malās vai piestiprināti pie ķēdes atsevišķiem locekļiem; arī darbmašīna, kurai ir šāda veida griezējinstruments."
    },
    { "id": 1239, "title": "zākas", "level": 3, "definition": "Ļauns izsmiekls, nievas." },
    {
      "id": 1240,
      "title": "zārds",
      "level": 3,
      "definition": "Primitīva koka konstrukcija (siena, labības u. tml.) žāvēšanai uz lauka; šāda konstrukcija kopā ar tajā sakrauto sienu, labību u. tml."
    },
    {
      "id": 1241,
      "title": "zārks",
      "level": 2,
      "definition": "Īpaši veidots garens, aizdarāms kastveida priekšmets, kurā ievieto un apglabā mirušo."
    },
    {
      "id": 1242,
      "title": "zebra",
      "level": 1,
      "definition": "Vairākas zirgu ģints sugas, savvaļas dzīvnieks (Āfrikā) ar raksturīgām gaišām un tumšam svītrām šķērsām pa visu ķermeņa virsmu."
    },
    {
      "id": 1243,
      "title": "zelts",
      "level": 1,
      "definition": "Ķīmiskais elements - dzeltens, spīdīgs, samērā mīksts, ļoti plastisks cēlmetāls, periodiskās sistēmas 79. elements, Au, atommasa - 196,9665, zināmi 18 izotopi, no kuriem 1 ir stabils; pārtikas piedeva E175, krāsviela (metāliska), tiek uzskatīta par nekaitīgu lietošanai uzturā."
    },
    {
      "id": 1244,
      "title": "ziede",
      "level": 1,
      "definition": "Bieza, taukaina masa, ko lieto, piemēram, ārstniecībā, arī kā kosmētisku līdzekli, parasti ādas kopšanai."
    },
    {
      "id": 1245,
      "title": "zieds",
      "level": 1,
      "definition": "Augstāko augu (sēklaugu) vairošanās orgāns, kas sastāv no apziedņa, putekšņlapām un auglenīcas."
    },
    {
      "id": 1246,
      "title": "ziema",
      "level": 1,
      "definition": "Gadalaiks, klimatiskā sezona, kas Zemes ziemeļu puslodē ilgst no 23. decembra līdz 22. martam; klimatiskā sezona, kas pastāv aptuveni šajā laikposmā un kam raksturīga viszemākā gaisa temperatūra gadā."
    },
    {
      "id": 1247,
      "title": "zilbe",
      "level": 2,
      "definition": "Vārda skaņa vai skaņu kopa, ko izrunā ar vienu elpas izdvesumu."
    },
    {
      "id": 1248,
      "title": "ziņģe",
      "level": 2,
      "definition": "Tulkota, lokalizēta vai pēc svešiem paraugiem darināta (parasti viegla, sentimentāla) dziesma, kas tautā nereti ir folklorizējusies."
    },
    {
      "id": 1249,
      "title": "zirgs",
      "level": 1,
      "definition": "Nepārnadžu kārtas dzimta (\"Equidae\"), pie kuras pieder lieli dzīvnieki ar īsu, blīvu apmatojumu un slaidām, garām kājām, 1 ģints."
    },
    {
      "id": 1250,
      "title": "zlots",
      "level": 3,
      "definition": "Naudas vienība Polijā; attiecīgā naudas zīme, monēta."
    },
    { "id": 1251, "title": "znots",
      "level": 2, "definition": "Meitas vīrs." },
    {
      "id": 1252,
      "title": "zonde",
      "level": 2,
      "definition": "Pētniecisks aparāts, ierīce (kā) pētīšanai apstākļos, kad pētījuma objekts nav tieši pieejams (atrodas zemes dzīlēs, lielā attālumā, kosmosā u. tml.)."
    },
    {
      "id": 1253,
      "title": "zunds",
      "level": 3,
      "definition": "Jūras šaurums starp divām salām vai starp salu un cietzemi."
    },
    {
      "id": 1254,
      "title": "zutis",
      "level": 1,
      "definition": "Zivju klases zušveidīgo kārtas dzimta (\"Anguillidae\"), 1 ģ., ~20 sugas un pasugas, Latvijā konstatēta 1 suga."
    },
    {
      "id": 1255,
      "title": "zvans",
      "level": 1,
      "definition": "Apakšdaļā atvērts dobs metāla veidojums ar kustīgu mēli iekšpusē, kura, atsitoties pret šī veidojuma malām, rada dzidras, melodiskas, parasti samērā augstas, skaņas."
    },
    {
      "id": 1256,
      "title": "zveja",
      "level": 1,
      "definition": "Zivju, arī, piemēram, ūdens bezmugurkaulnieku, ieguve ar īpašiem rīkiem."
    },
    {
      "id": 1257,
      "title": "zvērs",
      "level": 1,
      "definition": "Savvaļas zīdītājdzīvnieks."
    },
    {
      "id": 1258,
      "title": "zvīņa",
      "level": 2,
      "definition": "Plakans ādas veidojums dzīvniekiem, gk. zivīm, arī rāpuļiem un dažām zīdītāju sugām; zvīņas."
    },
    {
      "id": 1259,
      "title": "žagas",
      "level": 2,
      "definition": "Nepatvaļīga, dziļa ieelpa, ko izraisa diafragmas periodiska savilkšanās un ko pavada raksturīgas skaņas."
    },
    {
      "id": 1260,
      "title": "žanrs",
      "level": 2,
      "definition": "Mākslas darba formas kategorija ar vēsturiski izveidotām, noteiktām raksturīgām pazīmēm."
    },
    {
      "id": 1261,
      "title": "žākle",
      "level": 3,
      "definition": "Sazarojuma vietas starpa (parasti kokaugiem, to zariem); divžuburu zars, stumbrs; arī šādi izveidots koka priekšmets; stakle ."
    },
    {
      "id": 1262,
      "title": "žāvas",
      "level": 2,
      "definition": "Nepatvaļīga, dziļa ieelpa ar atvērtu muti."
    },
    {
      "id": 1263,
      "title": "žests",
      "level": 2,
      "definition": "Kustība, ko parasti veido ar rokām vai galvu un kas noder par patstāvīgu zīmi vai par izteikuma papildinājumu."
    },
    { "id": 1264, "title": "žēlas",
      "level": 2, "definition": "Žēlabas; arī žēlums." },
    {
      "id": 1265,
      "title": "žults",
      "level": 2,
      "definition": "Šķidrums, ko izdala aknas un kas palīdz sašķelt un uzsūkt taukvielas."
    },
    {
      "id": 1266,
      "title": "žurga",
      "level": 3,
      "definition": "Netīrs šķidrums; izmirkusi, netīra masa."
    },
    {
      "id": 1267,
      "title": "žurka",
      "level": 1,
      "definition": "Peļu dzimtas ģints (\"Rattus\"), grauzējs ar retu, parasti dzeltenīgi pelēku vai brūngani melnu, apmatojumu, smailu purnu un garu asti, >100 sugu, Latvijā konstatētas 2 s."
    },
    {
      "id": 1268,
      "title": "žūžas",
      "level": 3,
      "definition": "Ilgstošu nepārtrauktu skaņu kopums --> žūžot ."
    }
  ]
}
